
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("jHois", function(module, exports) {

var $lSOAM = parcelRequire("lSOAM");


var $jIOyV = parcelRequire("jIOyV");

var $jX1qB = parcelRequire("jX1qB");

var $1UCmC = parcelRequire("1UCmC");

const $e3adf083a3ceeb07$export$8115d9033624712e = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.CONTENT_ANALYTICS_LINKS_TABLE_SEGMENT_KEY)
});
const $e3adf083a3ceeb07$export$3cf4b7499c49a1bc = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.CONTENT_ANALYTICS_VIEWERS_SEGMENT_KEY)
});
const $e3adf083a3ceeb07$export$f38e95ed03e5cac6 = (0, $lSOAM.createInteractionMetric)({
    key: (0, $jIOyV.CONTENT_ANALYTICS_DIALOG_INTERACTION)
});
const $e3adf083a3ceeb07$export$fe68f7d0c5f4b391 = (0, $lSOAM.createInteractionMetric)({
    key: (0, $jIOyV.CONTENT_ANALYTICS_DIALOG_MENTIONS_TAB_INTERACTION)
});
const $e3adf083a3ceeb07$export$f35c906f54c0512a = (0, $lSOAM.createPageLoadMetric)({
    key: (0, $1UCmC.PAGE_ANALYTICS_LOAD_KEY)
});
const $e3adf083a3ceeb07$export$aa2d84a67f31f760 = (0, $lSOAM.createPageLoadMetric)({
    key: (0, $1UCmC.SPACE_ANALYTICS_PAGE_LOAD_KEY)
});
const $e3adf083a3ceeb07$export$73b0f2ef62226204 = (0, $lSOAM.createPageLoadMetric)({
    key: (0, $1UCmC.SITE_ANALYTICS_LOAD_KEY)
});
module.exports["CONTENT_ANALYTICS_LINKS_TABLE_METRIC"] = $e3adf083a3ceeb07$export$8115d9033624712e;
module.exports["CONTENT_ANALYTICS_VIEWERS_METRIC"] = $e3adf083a3ceeb07$export$3cf4b7499c49a1bc;
module.exports["CONTENT_ANALYTICS_DIALOG_METRIC"] = $e3adf083a3ceeb07$export$f38e95ed03e5cac6;
module.exports["CONTENT_ANALYTICS_DIALOG_MENTIONS_TAB_METRIC"] = $e3adf083a3ceeb07$export$fe68f7d0c5f4b391;
module.exports["PAGE_ANALYTICS_PAGE_LOAD_METRIC"] = $e3adf083a3ceeb07$export$f35c906f54c0512a;
module.exports["SPACE_ANALYTICS_PAGE_LOAD"] = $e3adf083a3ceeb07$export$aa2d84a67f31f760;
module.exports["SITE_ANALYTICS_PAGE_LOAD"] = $e3adf083a3ceeb07$export$73b0f2ef62226204;

});

parcelRegister("pG0Ei", function(module, exports) {
var $8787696ab5570b52$export$b8ca5fa4899cbfc7 = /*#__PURE__*/ function(AccountType) {
    AccountType["NORMAL"] = "normal";
    AccountType["GUEST"] = "guest";
    AccountType["ANONYMOUS"] = "anonymous";
    return AccountType;
}({});
module.exports["AccountType"] = $8787696ab5570b52$export$b8ca5fa4899cbfc7;

});

parcelRegister("gm3T5", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");

const $c90b2bf847ef88a3$export$1850b0ac812bc305 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const fireDateChangeEvent = (0, $42omo.useCallback)(({ tabName: tabName, level: level, dateType: dateType, source: source })=>createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: source,
                action: 'clicked',
                actionSubject: 'textField',
                actionSubjectId: 'dateBarAnalytics',
                attributes: {
                    dateType: dateType,
                    tab: tabName,
                    level: level,
                    native: true
                }
            }
        }).fire(), [
        createAnalyticsEvent
    ]);
    const fireTabChangeEvent = (0, $42omo.useCallback)(({ tabName: tabName, level: level, source: source })=>createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: source,
                actionSubject: 'analyticsNavigationItem',
                action: 'clicked',
                actionSubjectId: tabName,
                attributes: {
                    native: true,
                    level: level
                }
            }
        }).fire(), [
        createAnalyticsEvent
    ]);
    const fireTableRowClickedEvent = (0, $42omo.useCallback)(({ containerId: containerId, objectId: objectId, pageType: pageType, spaceType: spaceType, level: level, source: source })=>createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: source,
                action: 'clicked',
                actionSubject: 'analyticsLink',
                actionSubjectId: 'spaceAnalytics',
                attributes: {
                    native: true,
                    level: level,
                    containerId: containerId,
                    ...objectId ? {
                        objectId: objectId
                    } : {},
                    ...pageType ? {
                        pageType: pageType
                    } : {},
                    ...spaceType ? {
                        spaceType: spaceType
                    } : {}
                }
            }
        }).fire(), [
        createAnalyticsEvent
    ]);
    const fireFilterContentChangeEvent = (0, $42omo.useCallback)(({ changedContentType: changedContentType, contentTypesList: contentTypesList, spaceTypesList: spaceTypesList, tabName: tabName, level: level, source: source })=>createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: source,
                action: 'clicked',
                actionSubject: 'contentItem',
                actionSubjectId: changedContentType || '',
                attributes: {
                    tab: tabName,
                    level: level,
                    contentSelected: contentTypesList,
                    ...spaceTypesList ? {
                        spaceSelected: spaceTypesList
                    } : {},
                    native: true
                }
            }
        }).fire(), [
        createAnalyticsEvent
    ]);
    const fireDisplayOptionChangeEvent = (0, $42omo.useCallback)(({ newDisplayOption: newDisplayOption, tabName: tabName, level: level, source: source })=>createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: source,
                action: 'clicked',
                actionSubject: 'displayItem',
                actionSubjectId: newDisplayOption,
                attributes: {
                    tab: tabName,
                    level: level,
                    native: true
                }
            }
        }).fire(), [
        createAnalyticsEvent
    ]);
    const fireMetricChangeEvent = (0, $42omo.useCallback)(({ metricChanged: metricChanged, newMetricsList: newMetricsList, tabName: tabName, level: level, source: source })=>createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: source,
                action: 'clicked',
                actionSubject: 'metricType',
                actionSubjectId: metricChanged,
                attributes: {
                    tab: tabName,
                    level: level,
                    metricsSelected: newMetricsList,
                    native: true
                }
            }
        }).fire(), [
        createAnalyticsEvent
    ]);
    const firePeriodChangeEvent = (0, $42omo.useCallback)(({ newPeriod: newPeriod, tabName: tabName, level: level, source: source })=>createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: source,
                action: 'clicked',
                actionSubject: 'groupByItem',
                actionSubjectId: newPeriod,
                attributes: {
                    tab: tabName,
                    level: level,
                    native: true
                }
            }
        }).fire(), [
        createAnalyticsEvent
    ]);
    const fireListItemEvent = (0, $42omo.useCallback)(({ listName: listName, ranking: ranking, level: level, source: source, additionalAttributes: additionalAttributes })=>createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: source,
                action: 'clicked',
                actionSubject: 'analyticsLink',
                actionSubjectId: listName,
                attributes: {
                    level: level,
                    ...ranking ? {
                        ranking: ranking
                    } : {},
                    native: true,
                    ...additionalAttributes
                }
            }
        }).fire(), [
        createAnalyticsEvent
    ]);
    const fireViewAllEvent = (0, $42omo.useCallback)(({ listName: listName, level: level, source: source })=>createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: source,
                action: 'clicked',
                actionSubject: 'analyticsViewAll',
                actionSubjectId: listName,
                attributes: {
                    level: level,
                    native: true
                }
            }
        }).fire(), [
        createAnalyticsEvent
    ]);
    const fireSearchTermClickedEvent = (0, $42omo.useCallback)(({ ranking: ranking, level: level, source: source })=>createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: source,
                action: 'clicked',
                actionSubject: 'analyticsSearchTerm',
                attributes: {
                    level: level,
                    ranking: ranking,
                    native: true
                }
            }
        }).fire(), [
        createAnalyticsEvent
    ]);
    const fireTableSearchFilterChangedEvent = (0, $42omo.useCallback)(({ tableName: tableName, isCleared: isCleared, level: level, tabName: tabName, source: source })=>createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: source,
                action: 'searched',
                actionSubject: tableName,
                attributes: {
                    cleared: isCleared,
                    level: level,
                    tab: tabName,
                    native: true
                }
            }
        }).fire(), [
        createAnalyticsEvent
    ]);
    const fireSendRemindersCtaClickedEvent = (0, $42omo.useCallback)(({ level: level, tabName: tabName, source: source })=>createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: source,
                action: 'clicked',
                actionSubject: 'sendRemindersCTA',
                attributes: {
                    level: level,
                    tab: tabName,
                    native: true
                }
            }
        }).fire(), [
        createAnalyticsEvent
    ]);
    const fireTableCellLinkClickedEvent = (0, $42omo.useCallback)(({ actionName: actionName, objectId: objectId, level: level, type: type, source: source, additionalAttributes: additionalAttributes })=>createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: source,
                action: 'clicked',
                actionSubject: actionName,
                attributes: {
                    native: true,
                    objectId: objectId,
                    level: level,
                    type: type,
                    ...additionalAttributes
                }
            }
        }).fire(), [
        createAnalyticsEvent
    ]);
    return {
        fireDateChangeEvent: fireDateChangeEvent,
        fireTabChangeEvent: fireTabChangeEvent,
        fireTableRowClickedEvent: fireTableRowClickedEvent,
        fireFilterContentChangeEvent: fireFilterContentChangeEvent,
        fireDisplayOptionChangeEvent: fireDisplayOptionChangeEvent,
        fireMetricChangeEvent: fireMetricChangeEvent,
        firePeriodChangeEvent: firePeriodChangeEvent,
        fireListItemEvent: fireListItemEvent,
        fireViewAllEvent: fireViewAllEvent,
        fireSearchTermClickedEvent: fireSearchTermClickedEvent,
        fireTableSearchFilterChangedEvent: fireTableSearchFilterChangedEvent,
        fireSendRemindersCtaClickedEvent: fireSendRemindersCtaClickedEvent,
        fireTableCellLinkClickedEvent: fireTableCellLinkClickedEvent
    };
};
module.exports["useEventUtils"] = $c90b2bf847ef88a3$export$1850b0ac812bc305;

});

parcelRegister("ljL1T", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $ci7Ox = parcelRequire("ci7Ox");


var $dE1p6 = parcelRequire("dE1p6");

const $ef2b5a7cd92c4306$var$marginLeftStyle = (0, $ecnYn.xcss)({
    marginLeft: 'auto'
});
const $ef2b5a7cd92c4306$var$i18n = (0, $cgtv4.defineMessages)({
    buttonLabel: {
        id: "confluence-analytics.help-and-support.label",
        defaultMessage: "Help and Support"
    }
});
const $ef2b5a7cd92c4306$export$12043236ba2c8bd3 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $ef2b5a7cd92c4306$var$marginLeftStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dE1p6.default), {
        href: "https://confluence.atlassian.com/x/ZJ30OQ",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($ci7Ox))),
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $ef2b5a7cd92c4306$var$i18n.buttonLabel),
        isTooltipDisabled: false,
        target: "_blank",
        rel: "noopener noreferrer",
        appearance: "subtle"
    }));
module.exports["HelpAndSupport"] = $ef2b5a7cd92c4306$export$12043236ba2c8bd3;

});

parcelRegister("4tluk", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $1kHsc = parcelRequire("1kHsc");


var $3IBnw = parcelRequire("3IBnw");


var $1uFM6 = parcelRequire("1uFM6");


var $aMcHK = parcelRequire("aMcHK");

var $bFDX4 = parcelRequire("bFDX4");


var $7Sm4c = parcelRequire("7Sm4c");





var $5ZqQS = parcelRequire("5ZqQS");

// Expected ones are 403 and 429s. Unexpected errors include 400, 404 and 500.
const $942f6f8f751995a0$var$isExpectedError = (error)=>(0, $1uFM6.isUnauthorizedError)(error) || (0, $bFDX4.isTooManyRequestsError)(error);
const $942f6f8f751995a0$export$5b59045debd3f0cf = ({ experienceName: experienceName, abortOnUnmount: abortOnUnmount = false })=>{
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    // Abort the given experience when the container component unmounts
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            if (abortOnUnmount) experienceTracker.abort({
                name: experienceName,
                reason: 'useAnalyticsExperienceTracking unmounted'
            });
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // Use the common error handler for any initial/loading experience.
    // For interactive, update based experiences (i.e. filters) we can fallback to "submitError" or create individual experiences.
    const handleAnalyticsError = (0, $42omo.useCallback)((error)=>{
        if (!error) return;
        // Errors coming from hooks like usePageAudience could have been marked already
        if (!(0, $7Sm4c.isErrorMarkedAsHandled)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
        if ($942f6f8f751995a0$var$isExpectedError(error)) {
            experienceTracker.abort({
                name: experienceName,
                reason: `Received ${(0, $aMcHK.getStatusCodeError)(error)} with the message ${error.message}`
            });
            return;
        }
        // At this point, the experience might have already stopped since users can change filters interactively. To log their errors, we use submitError as a last resort.
        const expState = experienceTracker.getExperienceState(experienceName);
        if (!Boolean(expState?.hasStopped)) experienceTracker.fail({
            name: experienceName,
            error: error
        });
        else (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).CC_INSIGHTS_AND_REPORTING
        });
    }, [
        experienceName,
        experienceTracker
    ]);
    return {
        handleAnalyticsError: handleAnalyticsError
    };
};
module.exports["useAnalyticsExperienceTracking"] = $942f6f8f751995a0$export$5b59045debd3f0cf;

});

parcelRegister("cJw8u", function(module, exports) {

var $52s3i = parcelRequire("52s3i");

var $e0SBo = parcelRequire("e0SBo");

var $dhNqt = parcelRequire("dhNqt");

var $egXhZ = parcelRequire("egXhZ");


var $b5utg = parcelRequire("b5utg");

function $49089f1e8df2e6c3$export$2e2bcd8739ae039(dirtyDate) {
    (0, $b5utg.default)(1, arguments);
    var cleanDate = (0, $egXhZ.default)(dirtyDate);
    var date = new Date(0);
    date.setFullYear(cleanDate.getFullYear(), 0, 1);
    date.setHours(0, 0, 0, 0);
    return date;
}


var $ksiqf = parcelRequire("ksiqf");

var $2aVgd = parcelRequire("2aVgd");

const $4cbe9309f056ce87$export$59aa04164f07517b = ()=>({
        dateRange: '3M',
        fromDate: (0, $2aVgd.default)((0, $dhNqt.default)(new Date()), 3),
        toDate: new Date()
    });
// gets the default date range based on the date the content was created
const $4cbe9309f056ce87$var$getDateRangeFromCreationDate = (creationDate)=>{
    const now = new Date();
    const startOfToday = (0, $dhNqt.default)(now);
    if (creationDate < (0, $2aVgd.default)(startOfToday, 1)) return {
        dateRange: '1M',
        fromDate: (0, $2aVgd.default)(startOfToday, 1),
        toDate: now
    };
    if (creationDate < (0, $ksiqf.default)(startOfToday, 7)) return {
        dateRange: '7D',
        fromDate: (0, $ksiqf.default)(startOfToday, 7),
        toDate: now
    };
    return {
        dateRange: 'Custom',
        fromDate: (0, $dhNqt.default)(creationDate),
        toDate: now
    };
};
const $4cbe9309f056ce87$export$e385d98fee27c881 = (dateRangeParams)=>{
    const startOfToday = (0, $dhNqt.default)(new Date());
    const now = new Date();
    const payload = dateRangeParams?.payload;
    switch(payload?.range){
        case '7D':
            return {
                dateRange: payload.range,
                fromDate: (0, $ksiqf.default)(startOfToday, 7),
                toDate: now
            };
        case '1M':
            return {
                dateRange: payload.range,
                fromDate: (0, $2aVgd.default)(startOfToday, 1),
                toDate: now
            };
        case '3M':
            return {
                dateRange: payload?.range || '3M',
                fromDate: (0, $2aVgd.default)(startOfToday, 3),
                toDate: now
            };
        case 'YTD':
            return {
                dateRange: payload.range,
                fromDate: (0, $49089f1e8df2e6c3$export$2e2bcd8739ae039)(startOfToday),
                toDate: now
            };
        case 'AllTime':
            return {
                dateRange: payload.range,
                fromDate: (0, $dhNqt.default)(payload.fromDate),
                toDate: now
            };
        case 'Custom':
            return {
                dateRange: payload.range,
                fromDate: payload.fromDate,
                // calendar picker will always provides the date at the start of the day, but "toDate" should be the end of the day or if it is today, it should be the current time
                toDate: (0, $e0SBo.default)((0, $52s3i.default)(payload.toDate), now) ? now : (0, $52s3i.default)(payload.toDate)
            };
        // if a starting date is provided, check its within the default range
        // if its not, return it as the start, else use the default range.
        default:
            {
                const entityCreationDate = dateRangeParams?.entityCreationDate;
                const startingDate = entityCreationDate ? new Date(entityCreationDate) : undefined;
                if (startingDate && startingDate > $4cbe9309f056ce87$export$59aa04164f07517b().fromDate) return $4cbe9309f056ce87$var$getDateRangeFromCreationDate(startingDate);
                return $4cbe9309f056ce87$export$59aa04164f07517b();
            }
    }
};
module.exports["buildDateRangeState"] = $4cbe9309f056ce87$export$e385d98fee27c881;

});

parcelRegister("lw3M4", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $67Foi = parcelRequire("67Foi");

const $05b779345cfaac57$export$53081472815db553 = ({ name: name, level: level, type: type, objectId: objectId, additionalAttributes: additionalAttributes })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $67Foi.ScreenEvent), {
        name: name,
        id: "none",
        attributes: {
            native: true,
            level: level,
            type: type,
            objectId: objectId || 'none',
            ...additionalAttributes
        }
    });
module.exports["AnalyticsScreenEvent"] = $05b779345cfaac57$export$53081472815db553;

});

parcelRegister("fa4x6", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $2W0qg = parcelRequire("2W0qg");

var $ecnYn = parcelRequire("ecnYn");

const $e2a40bcfab7dbd25$var$selectedPillButtonStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'color.background.selected',
    color: 'color.text.selected',
    ':hover': {
        backgroundColor: 'color.background.selected.hovered'
    },
    ':active': {
        backgroundColor: 'color.background.selected.pressed'
    }
});
const $e2a40bcfab7dbd25$var$unselectedPillButtonStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'color.background.neutral',
    color: 'color.text',
    ':hover': {
        backgroundColor: 'color.background.neutral.hovered'
    },
    ':active': {
        backgroundColor: 'color.background.neutral.pressed'
    }
});
const $e2a40bcfab7dbd25$var$pillButtonStyles = (0, $ecnYn.xcss)({
    outline: 'none',
    paddingBlock: 'space.050',
    paddingInline: 'space.200',
    display: 'inline-flex',
    border: 'none',
    borderRadius: 'radius.full',
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    height: '28px',
    userSelect: 'none',
    whiteSpace: 'nowrap',
    verticalAlign: 'top'
});
const $e2a40bcfab7dbd25$export$2b5462ebca51afbb = /*#__PURE__*/ (0, $42omo.forwardRef)((props, ref)=>{
    const { isSelected: isSelected, ...buttonProps } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2W0qg.default), {
        ...buttonProps,
        ref: ref,
        xcss: [
            $e2a40bcfab7dbd25$var$pillButtonStyles,
            isSelected ? $e2a40bcfab7dbd25$var$selectedPillButtonStyles : $e2a40bcfab7dbd25$var$unselectedPillButtonStyles
        ]
    });
});
module.exports["AnalyticsPillButton"] = $e2a40bcfab7dbd25$export$2b5462ebca51afbb;

});

parcelRegister("fei6Y", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $dWCFT = parcelRequire("dWCFT");


var $ghftu = parcelRequire("ghftu");


var $6f0Oj = parcelRequire("6f0Oj");

var $bUlM5 = parcelRequire("bUlM5");

var $dcJ7R = parcelRequire("dcJ7R");

var $ecnYn = parcelRequire("ecnYn");


var $8DN9t = parcelRequire("8DN9t");


var $lGgRw = parcelRequire("lGgRw");


var $c4Cbx = parcelRequire("c4Cbx");


var $3gadb = parcelRequire("3gadb");


var $fa4x6 = parcelRequire("fa4x6");

const $be3c8f88e099336a$var$i18n = (0, $cgtv4.defineMessages)({
    customExpanded: {
        id: "confluence-analytics.filters.date-option-custom-expanded-form",
        defaultMessage: "Custom date range"
    },
    calendarIconLabel: {
        id: "confluence-analytics.filters.date-option-cal-icon-label",
        defaultMessage: "Calendar icon"
    },
    expandIconLabel: {
        id: "confluence-analytics.filters.date-option-expand-icon-label",
        defaultMessage: "Expand icon"
    }
});
const $be3c8f88e099336a$var$datePickerContainerStyles = (0, $ecnYn.xcss)({
    padding: 'space.050'
});
const $be3c8f88e099336a$var$calendarContainerStyles = (0, $ecnYn.xcss)({
    zIndex: 'modal'
});
const $be3c8f88e099336a$var$calendarIconContainerStyles = (0, $ecnYn.xcss)({
    height: '100%'
});
const $be3c8f88e099336a$export$904d39b6b448e4e5 = ({ isSelected: isSelected, startDateDefaultvalue: startDateDefaultvalue, startDateValue: startDateValue, startDateMin: startDateMin, startDateMax: startDateMax, onStartDateUpdate: onStartDateUpdate, endDateDefaultvalue: endDateDefaultvalue, endDateValue: endDateValue, endDateMin: endDateMin, endDateMax: endDateMax, onEndDateUpdate: onEndDateUpdate })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [isCalendarOpen, setIsCalendarOpen] = (0, $42omo.useState)(false);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        as: "div",
        xcss: $be3c8f88e099336a$var$calendarContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lGgRw.default), {
        shouldRenderToParent: true,
        isOpen: isCalendarOpen,
        onClose: ()=>setIsCalendarOpen(false),
        placement: "bottom",
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
                alignBlock: "center",
                space: "space.100",
                separator: "-",
                xcss: $be3c8f88e099336a$var$datePickerContainerStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c4Cbx.default), {
                appearance: "subtle",
                value: startDateValue.toISOString(),
                minDate: startDateMin.toISOString(),
                maxDate: startDateMax.toISOString(),
                onChange: (value)=>{
                    // There may be cases where value is nullish, i.e. select's clear state
                    onStartDateUpdate(value || startDateDefaultvalue.toISOString());
                },
                shouldShowCalendarButton: true
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c4Cbx.default), {
                appearance: "subtle",
                value: endDateValue.toISOString(),
                minDate: endDateMin.toISOString(),
                maxDate: endDateMax.toISOString(),
                onChange: (value)=>{
                    onEndDateUpdate(value || endDateDefaultvalue.toISOString());
                },
                shouldShowCalendarButton: true
            })),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
                content: formatMessage($be3c8f88e099336a$var$i18n.customExpanded)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fa4x6.AnalyticsPillButton), {
                ...triggerProps,
                onClick: ()=>setIsCalendarOpen(!isCalendarOpen),
                isSelected: isCalendarOpen || isSelected
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
                alignItems: "center",
                xcss: $be3c8f88e099336a$var$calendarIconContainerStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8DN9t))), {
                label: formatMessage($be3c8f88e099336a$var$i18n.calendarIconLabel),
                color: "currentColor"
            }), isSelected && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                paddingInline: "space.100"
            }, (0, $dWCFT.default)(startDateValue, 'MMM dd, yyyy'), " -", ' ', (0, $dWCFT.default)(endDateValue, 'MMM dd, yyyy')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                label: formatMessage($be3c8f88e099336a$var$i18n.expandIconLabel),
                color: "currentColor",
                spacing: "compact",
                size: "small"
            }))))
    }));
};
module.exports["CalendarPicker"] = $be3c8f88e099336a$export$904d39b6b448e4e5;

});

parcelRegister("xnejN", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");

const $4a38abe1df5327d7$var$fixedSizeStyle = (0, $ecnYn.xcss)({
    width: '312px'
});
const $4a38abe1df5327d7$var$fullSizeStyle = (0, $ecnYn.xcss)({
    width: '100%'
});
const $4a38abe1df5327d7$var$borderBoxStyle = (0, $ecnYn.xcss)({
    borderRadius: 'radius.xlarge',
    borderColor: 'color.border',
    borderWidth: 'border.width',
    borderStyle: 'solid',
    backgroundColor: 'elevation.surface'
});
const $4a38abe1df5327d7$export$e0783c06784f5b0 = ({ children: children, padding: padding, shouldFitContainer: shouldFitContainer = true, testId: testId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        padding: padding || 'space.400',
        xcss: [
            $4a38abe1df5327d7$var$borderBoxStyle,
            shouldFitContainer ? $4a38abe1df5327d7$var$fullSizeStyle : $4a38abe1df5327d7$var$fixedSizeStyle
        ],
        as: "div",
        testId: testId
    }, children);
module.exports["AnalyticsBorderBox"] = $4a38abe1df5327d7$export$e0783c06784f5b0;

});

parcelRegister("h631n", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $gtD4K = parcelRequire("gtD4K");

var $8C5kA = parcelRequire("8C5kA");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $a3fRD = parcelRequire("a3fRD");


var $1H4PD = parcelRequire("1H4PD");

const $711d917d3c507823$var$inlineTextStyles = (0, $ecnYn.xcss)({
    display: 'inline'
});
const $711d917d3c507823$export$12141c7359388aed = ()=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a3fRD))), {
        spacing: "spacious",
        label: formatMessage((0, $1H4PD.sharedI18n).serverErrorMessageTitle),
        color: "var(--ds-icon-warning, #E56910)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $711d917d3c507823$var$inlineTextStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $1H4PD.sharedI18n).serverErrorMessageTitle), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $1H4PD.sharedI18n).serverErrorMessageDescription)));
};
module.exports["AnalyticsCommonErrorState"] = $711d917d3c507823$export$12141c7359388aed;

});

parcelRegister("7MSLi", function(module, exports) {
const $9d6e032627b47e77$export$d64425f8a23d9468 = 'Anonymous';
const $9d6e032627b47e77$export$72a96dbd0b162542 = 'unidentified';
const $9d6e032627b47e77$export$569010ea5f619c6d = 'Anonymous';
const $9d6e032627b47e77$export$96b7ce240ce8577a = 100;
const $9d6e032627b47e77$export$97859498171aec4c = 25;
const $9d6e032627b47e77$export$b62205b461818e38 = 'desc';
var $9d6e032627b47e77$export$7ae723045d45777a = /*#__PURE__*/ function(SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
    return SortOrder;
}({});
var $9d6e032627b47e77$export$70b22f6d35407341 = /*#__PURE__*/ function(ContentViewsSortKey) {
    ContentViewsSortKey["TOTAL_VIEWED"] = "totalViewed";
    ContentViewsSortKey["TOTAL_COMMENTS"] = "totalComments";
    ContentViewsSortKey["UNIQUE_USERS_VIEWED"] = "uniqueUsersViewed";
    ContentViewsSortKey["LAST_VIEWED_AT"] = "lastViewedAt";
    ContentViewsSortKey["LAST_MODIFICATION_DATE"] = "lastModificationDate";
    return ContentViewsSortKey;
}({});
var $9d6e032627b47e77$export$8cbcddc26051013f = /*#__PURE__*/ function(UsersActivitySortKey) {
    UsersActivitySortKey["CREATED"] = "created";
    UsersActivitySortKey["VIEWED"] = "viewed";
    UsersActivitySortKey["UPDATED"] = "updated";
    UsersActivitySortKey["COMMENT_CREATED"] = "commentCreated";
    return UsersActivitySortKey;
}({});
var $9d6e032627b47e77$export$25040d5e82b12bc9 = /*#__PURE__*/ function(SpaceTableSortKeyV2) {
    SpaceTableSortKeyV2["TOTAL_CREATED"] = "totalCreated";
    SpaceTableSortKeyV2["TOTAL_UPDATED"] = "totalUpdated";
    SpaceTableSortKeyV2["TOTAL_VIEWED"] = "totalViewed";
    SpaceTableSortKeyV2["UNIQUE_USERS"] = "uniqueUsers";
    SpaceTableSortKeyV2["LAST_VIEWED_AT"] = "lastViewedAt";
    return SpaceTableSortKeyV2;
}({});
var $9d6e032627b47e77$export$8265e0ea326cbb55 = /*#__PURE__*/ function(AnalyticsUIState) {
    AnalyticsUIState["Error"] = "Error";
    AnalyticsUIState["PartialDataError"] = "PartialDataError";
    AnalyticsUIState["Loading"] = "Loading";
    AnalyticsUIState["Data"] = "Data";
    AnalyticsUIState["Empty"] = "Empty";
    return AnalyticsUIState;
}({});
var $9d6e032627b47e77$export$27396ce65304f112 = /*#__PURE__*/ function(AnalyticsContainer) {
    AnalyticsContainer["PAGE"] = "Page";
    AnalyticsContainer["SPACE"] = "Space";
    AnalyticsContainer["SITE"] = "Site";
    return AnalyticsContainer;
}({});
module.exports["ANONYMOUS"] = $9d6e032627b47e77$export$d64425f8a23d9468;
module.exports["UNIDENTIFIED"] = $9d6e032627b47e77$export$72a96dbd0b162542;
module.exports["ANONYMOUS_USER_DISPLAY_NAME"] = $9d6e032627b47e77$export$569010ea5f619c6d;
module.exports["LONG_TABLE_PER_PAGE_LIMIT"] = $9d6e032627b47e77$export$96b7ce240ce8577a;
module.exports["SHORT_TABLE_PER_PAGE_LIMIT"] = $9d6e032627b47e77$export$97859498171aec4c;
module.exports["SORT_DESC_STRING"] = $9d6e032627b47e77$export$b62205b461818e38;
module.exports["SortOrder"] = $9d6e032627b47e77$export$7ae723045d45777a;
module.exports["ContentViewsSortKey"] = $9d6e032627b47e77$export$70b22f6d35407341;
module.exports["UsersActivitySortKey"] = $9d6e032627b47e77$export$8cbcddc26051013f;
module.exports["SpaceTableSortKeyV2"] = $9d6e032627b47e77$export$25040d5e82b12bc9;
module.exports["AnalyticsUIState"] = $9d6e032627b47e77$export$8265e0ea326cbb55;
module.exports["AnalyticsContainer"] = $9d6e032627b47e77$export$27396ce65304f112;

});

parcelRegister("4tanV", function(module, exports) {
$parcel$export(module.exports, "default", () => $3411ed14a3855349$export$2e2bcd8739ae039);

var $ea9Et = parcelRequire("ea9Et");

/* AxisBottom.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $gMc0m = parcelRequire("gMc0m");


var $eytdg = parcelRequire("eytdg");

const $582dc1bd5024a241$export$554ff5554bedd348 = {
    textAnchor: 'middle',
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif",
    fontSize: 12,
    color: "var(--ds-text-subtlest, lightgrey)"
};
const $582dc1bd5024a241$export$51ee3858fd381684 = {
    textAlign: 'center',
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif",
    fontSize: 12,
    color: "var(--ds-text-subtlest, lightgrey)"
};


const $861f32923f3bcf7a$var$Orientation = {
    top: 'top',
    left: 'left',
    right: 'right',
    bottom: 'bottom'
};
var $861f32923f3bcf7a$export$2e2bcd8739ae039 = $861f32923f3bcf7a$var$Orientation;


/**
 * Uses the scale domain to check the type of data.
 *
 * If domainValues[0] ends up being null, we will return string. Since null
 * can only be value on ordinal axis.
 */ function $d5a096f7d5090d1d$export$2e2bcd8739ae039(scale) {
    const domainValues = scale.domain();
    if (domainValues.length === 0) return 'string';
    if (domainValues[0] instanceof Date || domainValues[domainValues.length - 1] instanceof Date) return 'time';
    else if (typeof domainValues[0] === 'number') return 'number';
    else return 'string';
}



var $1T8PM = parcelRequire("1T8PM");

function $d559c292b7e9e63f$export$2e2bcd8739ae039(scale) {
    // Broaden type before using 'xxx' in s as typeguard.
    const s = scale;
    // For point or band scales,
    // have to add offset to make the tick centered.
    if (scale.domain()[0] instanceof Date || scale.domain()[1] instanceof Date) return (0, $1T8PM.default).multiTimeFormat;
    else if ('tickFormat' in s) return (0, $1T8PM.default).formatNumberAbbreviated;
    return String;
}






var $l998X = parcelRequire("l998X");

const $4ca54ec00d5923ef$export$1b23eda9d50a8331 = "var(--ds-border-bold, lightgrey)";
const $4ca54ec00d5923ef$export$6b38ce563ca3e26b = (0, $eytdg.element)((props)=>{
    const { style: style, hide: hide } = props;
    if (hide) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        style: style
    });
});








const $9d38492a5243bb73$var$tickStroke = "var(--ds-border-bold, lightgrey)";
const $9d38492a5243bb73$var$TICK_LENGTH = 8;
const $9d38492a5243bb73$var$STROKE_WIDTH = 1;
const $9d38492a5243bb73$export$b1778e7c62739fdb = (0, $eytdg.element)((props)=>{
    const { from: from, to: to, hide: hide } = props;
    const isHorizontal = (from === null || from === void 0 ? void 0 : from.y) === (to === null || to === void 0 ? void 0 : to.y);
    if (hide) return null;
    const border = isHorizontal ? {
        borderBottom: `${$9d38492a5243bb73$var$STROKE_WIDTH}px solid ${$9d38492a5243bb73$var$tickStroke}`
    } : {
        borderLeft: `${$9d38492a5243bb73$var$STROKE_WIDTH}px solid ${$9d38492a5243bb73$var$tickStroke}`
    };
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        style: {
            ...border,
            width: isHorizontal ? $9d38492a5243bb73$var$TICK_LENGTH : 0,
            height: !isHorizontal ? $9d38492a5243bb73$var$TICK_LENGTH : 0,
            position: 'absolute',
            top: `calc(${to === null || to === void 0 ? void 0 : to.y}px)`,
            left: `calc(${from === null || from === void 0 ? void 0 : from.x}px)`,
            transform: isHorizontal ? `translateX(-${$9d38492a5243bb73$var$TICK_LENGTH}px)` : ``
        }
    });
});


parcelRequire("85XjS");
var $9hPuh = parcelRequire("9hPuh");







const $129074074271cd16$var$TRUNCATE_STYLES = {
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap'
};
const $129074074271cd16$export$d3f6b56e9fbffff3 = (0, $eytdg.element)((props)=>{
    // TODO: Force singleline
    const { formatter: formatter, style: style, truncate: truncate, singleline: singleline, children: children } = props;
    const truncateStyles = truncate ? $129074074271cd16$var$TRUNCATE_STYLES : {};
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        style: {
            ...style,
            ...truncateStyles
        },
        children: /*#__PURE__*/ (0, $l998X.jsx)("span", {
            children: typeof formatter === 'function' ? formatter(children) : (0, $9hPuh.timeFormat)(formatter)(children)
        })
    });
});


function $73a2d786f1f88572$export$2e2bcd8739ae039(val) {
    if ((typeof val === 'function' || typeof val === 'object' && !!val) && 'valueOf' in val) {
        var num = val.valueOf();
        if (typeof num === 'number') return num;
    }
    return val;
}

function $785649866c235de3$export$2e2bcd8739ae039(scale, numTicks) {
    // Because `Scale` is generic type which maybe a subset of AnyD3Scale
    // that may not have `ticks` field,
    // TypeScript will not let us do the `'ticks' in scale` check directly.
    // Have to manually cast and expand type first.
    var s = scale;
    if ('ticks' in s) return s.ticks(numTicks);
    return s.domain().filter(function(_, index, arr) {
        return numTicks == null || arr.length <= numTicks || index % Math.round((arr.length - 1) / numTicks) === 0;
    });
}


var $K7JGK = parcelRequire("K7JGK");

function $523d59130fa87f70$export$2e2bcd8739ae039(scale) {
    // Try a sequence of typeguards to figure out the scale type
    if ('paddingInner' in scale) return 'band';
    if ('padding' in scale) return 'point';
    if ('quantiles' in scale) return 'quantile';
    if ('base' in scale) return 'log';
    if ('exponent' in scale) return scale.exponent() === 0.5 ? 'sqrt' : 'pow';
    if ('constant' in scale) return 'symlog';
    if ('clamp' in scale) {
        // Linear, Time or Utc scales
        if (scale.ticks()[0] instanceof Date) return (0, $K7JGK.default)(scale) ? 'utc' : 'time';
        return 'linear';
    }
    if ('nice' in scale) return 'quantize';
    if ('invertExtent' in scale) return 'threshold';
    return 'ordinal';
}


var $k7wMP = parcelRequire("k7wMP");


var $ewsGH = parcelRequire("ewsGH");

var $355931b808dc9ff1$export$a5ffb43f629473d4 = (0, $ewsGH.default)('domain', 'range', 'reverse', 'clamp', 'interpolate', 'nice', 'round');
function $355931b808dc9ff1$export$2e2bcd8739ae039(config) {
    return $355931b808dc9ff1$export$a5ffb43f629473d4((0, $k7wMP.default)(), config);
}



const $1e21d44cebad5ba8$export$b3026b3c8d26dc41 = 70;


class $2cf9d581b4e4565b$export$2e2bcd8739ae039 {
    value() {
        return {
            x: this.x,
            y: this.y
        };
    }
    toArray() {
        return [
            this.x,
            this.y
        ];
    }
    constructor(_ref){
        this.x = 0;
        this.y = 0;
        let { x: x = 0, y: y = 0 } = _ref;
        this.x = x;
        this.y = y;
    }
}


function $680d0bf613e091b4$export$2e2bcd8739ae039(_ref, horizontal) {
    let { x: x, y: y } = _ref;
    return new (0, $2cf9d581b4e4565b$export$2e2bcd8739ae039)(horizontal ? {
        x: x,
        y: y
    } : {
        x: y,
        y: x
    });
}


/**
 * Create a function that returns a tick position for the given tick value
 */ function $2a888e21ec6b913a$export$2e2bcd8739ae039(scale, align) {
    if (align === void 0) align = 'center';
    // Broaden type before using 'xxx' in s as typeguard.
    const s = scale;
    // For point or band scales,
    // have to add offset to make the tick at center or end.
    if (align !== 'start' && 'bandwidth' in s) {
        let offset = s.bandwidth();
        if (align === 'center') offset /= 2;
        if (s.round()) offset = Math.round(offset);
        return (d)=>{
            const scaledValue = s(d);
            return typeof scaledValue === 'number' ? scaledValue + offset : scaledValue;
        };
    }
    return scale;
}


function $425dc1e740c6d363$export$b1d0fead756358a0(_ref) {
    let { scale: scale, numTicks: numTicks, tickValues: tickValues, tickLength: tickLength, orientation: orientation, hideZero: hideZero = false } = _ref;
    const isLeft = orientation === (0, $861f32923f3bcf7a$export$2e2bcd8739ae039).left;
    const isTop = orientation === (0, $861f32923f3bcf7a$export$2e2bcd8739ae039).top;
    const horizontal = isTop || orientation === (0, $861f32923f3bcf7a$export$2e2bcd8739ae039).bottom;
    const tickPosition = (0, $2a888e21ec6b913a$export$2e2bcd8739ae039)(scale);
    const tickSign = isLeft || isTop ? -1 : 1;
    const range = scale.range();
    const scaleType = (0, $523d59130fa87f70$export$2e2bcd8739ae039)(scale);
    const isNumeric = scaleType === 'linear' || scaleType === 'log';
    const tempCalcTicks = Math.round(Math.abs((range[1] || 1) - (range[0] || 0)) / (isLeft ? isNumeric ? (0, $1e21d44cebad5ba8$export$b3026b3c8d26dc41) : 18 : (0, $1e21d44cebad5ba8$export$b3026b3c8d26dc41)));
    const calculatedNumTicks = (numTicks !== null && numTicks !== void 0 ? numTicks : tempCalcTicks < 2) ? 2 : tempCalcTicks;
    // Check to see if the scale is
    let calculatedScale = scale;
    // Doing a detection here to figure out if we want the ticks to use temporal instead of the
    // ordinal tick detection.
    if ('timeUnit' in scale && typeof scale.timeUnit === 'function' && scale.timeUnit()) {
        const domain = scale.domain();
        if (domain.length > 0) calculatedScale = (0, $355931b808dc9ff1$export$2e2bcd8739ae039)({
            range: scale.range(),
            domain: [
                scale.domain()[0],
                scale.domain()[scale.domain().length - 1]
            ]
        });
    }
    const filteredTickValues = (tickValues !== null && tickValues !== void 0 ? tickValues : (0, $785649866c235de3$export$2e2bcd8739ae039)(calculatedScale, calculatedNumTicks)).filter((value)=>!hideZero || value !== 0 && value !== '0').map((value, index)=>({
            value: value,
            index: index
        }));
    const ticks = filteredTickValues.reduce((filtered, _ref2)=>{
        let { value: value, index: index } = _ref2;
        const scaledValue = (0, $73a2d786f1f88572$export$2e2bcd8739ae039)(tickPosition(value));
        if (tickPosition(value) !== undefined) filtered.push({
            value: value,
            index: index,
            from: (0, $680d0bf613e091b4$export$2e2bcd8739ae039)({
                x: scaledValue,
                y: 0
            }, horizontal),
            to: (0, $680d0bf613e091b4$export$2e2bcd8739ae039)({
                x: scaledValue,
                y: tickLength * tickSign
            }, horizontal)
        });
        return filtered;
    }, []);
    return {
        ticks: ticks
    };
}





const $8828968c6a0c9e95$export$cd0785a309729df9 = {
    color: "var(--ds-text-subtlest, grey)",
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif",
    fontSize: 12,
    textAlign: 'center'
};
const $8828968c6a0c9e95$var$tickLength = 8;
const $8828968c6a0c9e95$var$orientation = (0, $861f32923f3bcf7a$export$2e2bcd8739ae039).bottom;
const $8828968c6a0c9e95$export$34bea378c04af713 = (0, $eytdg.element)((0, $9d38492a5243bb73$export$b1778e7c62739fdb));
const $8828968c6a0c9e95$export$84b05a0ae8b61ab5 = (0, $eytdg.element)((_ref)=>{
    let { width: width, top: top, hide: hide } = _ref;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $4ca54ec00d5923ef$export$6b38ce563ca3e26b), {
        hide: hide,
        style: {
            borderBottom: `${(0, $4ca54ec00d5923ef$export$1b23eda9d50a8331)} solid 2px`,
            width: `${width}px`,
            position: 'absolute',
            top: `${top}px`
        }
    });
});
const $8828968c6a0c9e95$export$ebfad67a29d89d08 = (0, $eytdg.element)((_ref2)=>{
    let { width: width, formatter: formatter, truncate: truncate, singleline: singleline, children: children, transform: transform } = _ref2;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $129074074271cd16$export$d3f6b56e9fbffff3), {
        style: {
            width: width,
            transform: transform
        },
        formatter: formatter,
        truncate: truncate,
        singleline: singleline,
        children: children
    });
});
function $8828968c6a0c9e95$var$AxisBottom(_ref3) {
    let { scale: scale, numTicks: numTicks, tickValues: tickValues, top: top, left: left, rangePadding: rangePadding, hideZero: hideZero, label: label } = _ref3;
    const { ticks: ticks } = (0, $425dc1e740c6d363$export$b1d0fead756358a0)({
        scale: scale,
        numTicks: numTicks,
        tickValues: tickValues,
        orientation: $8828968c6a0c9e95$var$orientation,
        rangePadding: rangePadding,
        hideZero: hideZero,
        tickLength: $8828968c6a0c9e95$var$tickLength
    });
    const TickTextsComponent = ticks.map((_ref4)=>{
        let { value: value, index: index, from: from, to: to } = _ref4;
        const formatter = (0, $d559c292b7e9e63f$export$2e2bcd8739ae039)(scale);
        return /*#__PURE__*/ (0, $l998X.jsx)("div", {
            style: {
                left: `${to.x}px`
            },
            className: (0, $gMc0m.default)([
                "_yyhykb7n _1ii7kb7n _kqswh2mm _1bsbidpf _syaz13nv _ect41wi2 _1wyb1crf _y3gn1h6o"
            ]),
            children: /*#__PURE__*/ (0, $l998X.jsx)($8828968c6a0c9e95$export$ebfad67a29d89d08, {
                width: Number(scale.range()[1]) / ticks.length,
                formatter: formatter,
                truncate: (0, $d5a096f7d5090d1d$export$2e2bcd8739ae039)(scale) === 'string',
                transform: "translateX(-50%)",
                children: value
            })
        }, `axis-bottom-text-${index}-${value}-${from.toArray()}-${to.toArray()}`);
    });
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("div", {
                style: {
                    gridArea: 'plot'
                },
                children: /*#__PURE__*/ (0, $l998X.jsx)($8828968c6a0c9e95$export$84b05a0ae8b61ab5, {
                    width: left,
                    top: top
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)("div", {
                style: {
                    gridArea: 'axis-bottom',
                    display: 'grid',
                    gridTemplateRows: 'auto min-content'
                },
                "data-axis-type": "axis-bottom",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)("div", {
                        className: (0, $gMc0m.default)([
                            "_1e0c11p5 _yv0ehkll _2z05hkll _ca0q1crf"
                        ]),
                        children: TickTextsComponent
                    }),
                    label && /*#__PURE__*/ (0, $l998X.jsx)("div", {
                        style: {
                            paddingTop: '8px',
                            width: '100%',
                            textAlign: 'center',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                            ...(0, $582dc1bd5024a241$export$51ee3858fd381684)
                        },
                        children: label
                    })
                ]
            })
        ]
    });
}
const $8828968c6a0c9e95$export$deea0fad05dcb466 = (0, $eytdg.element)($8828968c6a0c9e95$var$AxisBottom);


/* AxisLeft.tsx generated by @compiled/babel-plugin v0.28.8 */ 
















const $02e60cd405540c9a$export$ec95513e2647ff3 = {
    color: "var(--ds-text-subtlest, grey)",
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif",
    fontSize: 12
};
const $02e60cd405540c9a$var$tickLength = 8;
const $02e60cd405540c9a$var$orientation = (0, $861f32923f3bcf7a$export$2e2bcd8739ae039).left;
const $02e60cd405540c9a$export$d9ad68803a03e71 = (0, $eytdg.element)((0, $9d38492a5243bb73$export$b1778e7c62739fdb));
const $02e60cd405540c9a$export$25abdf51e62eb76e = (0, $eytdg.element)((_ref)=>{
    let { height: height, hide: hide } = _ref;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $4ca54ec00d5923ef$export$6b38ce563ca3e26b), {
        hide: hide,
        style: {
            borderLeft: `2px solid ${(0, $4ca54ec00d5923ef$export$1b23eda9d50a8331)}`,
            height: `${height}px`,
            position: 'absolute',
            transform: 'translateX(-1px)'
        }
    });
});
const $02e60cd405540c9a$export$68f34be0235fe9c0 = (0, $eytdg.element)((_ref2)=>{
    let { width: width, formatter: formatter, truncate: truncate, singleline: singleline, children: children } = _ref2;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $129074074271cd16$export$d3f6b56e9fbffff3), {
        style: {
            maxWidth: width
        },
        formatter: formatter,
        truncate: truncate,
        singleline: singleline,
        children: children
    });
});
function $02e60cd405540c9a$var$AxisLeft(_ref3) {
    let { scale: scale, numTicks: numTicks, tickValues: tickValues, rangePadding: rangePadding, hideZero: hideZero, label: // TODO: Should label become it's own element?
    label } = _ref3;
    const { ticks: ticks } = (0, $425dc1e740c6d363$export$b1d0fead756358a0)({
        scale: scale,
        numTicks: numTicks,
        tickValues: tickValues,
        orientation: $02e60cd405540c9a$var$orientation,
        rangePadding: rangePadding,
        hideZero: hideZero,
        tickLength: $02e60cd405540c9a$var$tickLength
    });
    const TicksComponent = ticks.map((_ref4)=>{
        let { value: value, index: index, from: from, to: to } = _ref4;
        const formatter = (0, $d559c292b7e9e63f$export$2e2bcd8739ae039)(scale);
        return /*#__PURE__*/ (0, $l998X.jsx)("div", {
            style: {
                // Ugh I hate you magic number
                top: `calc(${to.y}px - .6em)`,
                minWidth: 0,
                gridColumn: 1,
                gridRow: 1,
                position: 'relative',
                textAlign: 'right',
                ...$02e60cd405540c9a$export$ec95513e2647ff3
            },
            children: /*#__PURE__*/ (0, $l998X.jsx)($02e60cd405540c9a$export$68f34be0235fe9c0, {
                formatter: formatter,
                width: 250,
                truncate: (0, $d5a096f7d5090d1d$export$2e2bcd8739ae039)(scale) === 'string',
                children: value
            })
        }, `axis-left-text-${index}-${value}-${from.toArray()}-${to.toArray()}`);
    });
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("div", {
                style: {
                    gridArea: 'plot',
                    display: 'flex'
                },
                children: /*#__PURE__*/ (0, $l998X.jsx)($02e60cd405540c9a$export$25abdf51e62eb76e, {
                    height: scale.range()[0]
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)("div", {
                "data-axis-type": "axis-left",
                className: (0, $gMc0m.default)([
                    "_nd5l1jbf _1e0c11p5 _yv0ey09t _1tke1osq"
                ]),
                children: [
                    label && /*#__PURE__*/ (0, $l998X.jsx)("div", {
                        style: {
                            overflow: 'hidden',
                            height: '100%',
                            width: 'max-content',
                            textOverflow: 'ellipsis',
                            alignSelf: 'center',
                            writingMode: 'vertical-rl',
                            transform: 'rotate(-180deg)',
                            paddingLeft: '8px',
                            whiteSpace: 'nowrap',
                            ...(0, $582dc1bd5024a241$export$51ee3858fd381684)
                        },
                        children: label
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("div", {
                        className: (0, $gMc0m.default)([
                            "_1e0c11p5 _1bsb1ris _wij21bp4 _yv0ehkll _2z05hkll _u5f31crf"
                        ]),
                        children: TicksComponent
                    })
                ]
            })
        ]
    });
}
const $02e60cd405540c9a$export$4b76feaa547cd202 = (0, $eytdg.element)($02e60cd405540c9a$var$AxisLeft);


parcelRequire("lg6bu");
var $lPjcQ = parcelRequire("lPjcQ");
var $lg6bu = parcelRequire("lg6bu");


var $990l4 = parcelRequire("990l4");





var $42omo = parcelRequire("42omo");









function $7e5572c2722d3374$export$2e2bcd8739ae039(scale) {
    return 'bandwidth' in scale ? scale.bandwidth() : 0;
}





function $ffe589dce100e7c1$var$GridColumns(_ref) {
    let { top: top = 0, left: left = 0, scale: scale, height: height, stroke: stroke = "var(--ds-border, lightgrey)", strokeWidth: strokeWidth = 1, numTicks: numTicks, lineStyle: lineStyle = 'solid', offset: offset, tickValues: tickValues, hide: hide = false } = _ref;
    if (hide) return null;
    const { ticks: ticks } = (0, $425dc1e740c6d363$export$b1d0fead756358a0)({
        scale: scale,
        numTicks: numTicks,
        tickValues: tickValues,
        tickLength: 8,
        orientation: (0, $861f32923f3bcf7a$export$2e2bcd8739ae039).bottom,
        rangePadding: undefined
    });
    const scaleOffset = (offset !== null && offset !== void 0 ? offset : 0) + (0, $7e5572c2722d3374$export$2e2bcd8739ae039)(scale) / 2;
    const tickLines = ticks.map((_ref2)=>{
        var _coerceNumber;
        let { value: value, index: index } = _ref2;
        const x = ((_coerceNumber = (0, $73a2d786f1f88572$export$2e2bcd8739ae039)(scale(value))) !== null && _coerceNumber !== void 0 ? _coerceNumber : 0) + scaleOffset;
        return {
            index: index,
            from: new (0, $2cf9d581b4e4565b$export$2e2bcd8739ae039)({
                x: x,
                y: 0
            }),
            to: new (0, $2cf9d581b4e4565b$export$2e2bcd8739ae039)({
                x: x,
                y: height
            })
        };
    });
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        style: {
            top: top,
            left: left,
            position: 'relative'
        },
        children: tickLines.map((_ref3)=>{
            let { from: from, to: to, index: index } = _ref3;
            return /*#__PURE__*/ (0, $l998X.jsxs)((0, $42omo.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $8828968c6a0c9e95$export$34bea378c04af713), {
                        from: from,
                        to: to
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("div", {
                        style: {
                            borderLeft: `${stroke} ${lineStyle} ${strokeWidth}px`,
                            height: `${to.y}px`,
                            position: 'absolute',
                            left: to.x
                        }
                    })
                ]
            }, `grid-columns-lines-${index}-${from.toArray()}-${to.toArray()}`);
        })
    });
}
const $ffe589dce100e7c1$export$22a67e3ff32a357a = (0, $eytdg.element)($ffe589dce100e7c1$var$GridColumns);

















function $36f3d8235780a386$var$GridRows(_ref) {
    let { top: top = 0, left: left = 0, scale: scale, width: width, stroke: stroke = "var(--ds-border, lightgrey)", strokeWidth: strokeWidth = 1, numTicks: numTicks, lineStyle: lineStyle = 'solid', offset: offset, tickValues: tickValues, hide: hide = false } = _ref;
    if (hide) return null;
    const { ticks: ticks } = (0, $425dc1e740c6d363$export$b1d0fead756358a0)({
        scale: scale,
        numTicks: numTicks,
        tickValues: tickValues,
        tickLength: 8,
        orientation: (0, $861f32923f3bcf7a$export$2e2bcd8739ae039).left,
        rangePadding: undefined
    });
    const scaleOffset = (offset !== null && offset !== void 0 ? offset : 0) + (0, $7e5572c2722d3374$export$2e2bcd8739ae039)(scale) / 2;
    const tickLines = ticks.map((_ref2)=>{
        var _coerceNumber;
        let { value: value, index: index } = _ref2;
        const y = ((_coerceNumber = (0, $73a2d786f1f88572$export$2e2bcd8739ae039)(scale(value))) !== null && _coerceNumber !== void 0 ? _coerceNumber : 0) + scaleOffset;
        return {
            index: index,
            from: new (0, $2cf9d581b4e4565b$export$2e2bcd8739ae039)({
                x: 0,
                y: y
            }),
            to: new (0, $2cf9d581b4e4565b$export$2e2bcd8739ae039)({
                x: width,
                y: y
            })
        };
    });
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        style: {
            top: top,
            left: left,
            position: 'relative'
        },
        children: tickLines.map((_ref3)=>{
            let { from: from, to: to, index: index } = _ref3;
            return /*#__PURE__*/ (0, $l998X.jsxs)((0, $42omo.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $02e60cd405540c9a$export$d9ad68803a03e71), {
                        from: from,
                        to: to
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("div", {
                        style: {
                            borderBottom: `${strokeWidth}px ${lineStyle} ${stroke}`,
                            width: `${to.x}px`,
                            position: 'absolute',
                            top: `calc(${to.y}px)`
                        }
                    })
                ]
            }, `grid-rows-lines-${index}-${from.toArray()}-${to.toArray()}`);
        })
    });
}
const $36f3d8235780a386$export$f7ce055fe2ce64b1 = (0, $eytdg.element)($36f3d8235780a386$var$GridRows);





function $9aa89164c9e6e11d$var$Grid(_ref) {
    let { top: top, left: left, xScale: xScale, yScale: yScale, width: width, height: height, rowStrokeWidth: rowStrokeWidth, columnStrokeWidth: columnStrokeWidth, columnStroke: columnStroke, rowStroke: rowStroke, numTicksRows: numTicksRows, numTicksColumns: numTicksColumns, rowLineStyle: rowLineStyle, columnLineStyle: columnLineStyle, xOffset: xOffset, yOffset: yOffset, rowTickValues: rowTickValues, columnTickValues: columnTickValues, hide: hide = false } = _ref;
    if (hide) return null;
    return /*#__PURE__*/ (0, $l998X.jsxs)("div", {
        style: {
            top: top,
            left: left,
            gridArea: 'plot'
        },
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $36f3d8235780a386$export$f7ce055fe2ce64b1), {
                scale: yScale,
                width: width,
                stroke: rowStroke,
                strokeWidth: rowStrokeWidth,
                numTicks: numTicksRows,
                lineStyle: rowLineStyle,
                offset: yOffset,
                tickValues: rowTickValues
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $ffe589dce100e7c1$export$22a67e3ff32a357a), {
                scale: xScale,
                height: height,
                stroke: columnStroke,
                strokeWidth: columnStrokeWidth,
                numTicks: numTicksColumns,
                lineStyle: columnLineStyle,
                offset: xOffset,
                tickValues: columnTickValues
            })
        ]
    });
}
const $9aa89164c9e6e11d$export$ef2184bd89960b14 = (0, $eytdg.element)($9aa89164c9e6e11d$var$Grid);



var $fgtqy = parcelRequire("fgtqy");


var $gbyey = parcelRequire("gbyey");

var $gZHwv = parcelRequire("gZHwv");


var $4A2iI = parcelRequire("4A2iI");


var $90XX3 = parcelRequire("90XX3");

var $i7s9b = parcelRequire("i7s9b");


var $lKyMg = parcelRequire("lKyMg");


var $7lOgj = parcelRequire("7lOgj");




/* TooltipHeader.tsx generated by @compiled/babel-plugin v0.28.8 */ 





const $f15eed92a0011d7b$var$headerCss = null;
function $f15eed92a0011d7b$export$fd7ac08b5fcaeea(_ref) {
    let { children: children } = _ref;
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        className: (0, $gMc0m.default)([
            "_1wpz1fhb _syaz1glm _1wyb1skh _ect41wi2 _k48p1nn1 _slp31hna"
        ]),
        children: children
    });
}



var $1MtIV = parcelRequire("1MtIV");


var $ft3QQ = parcelRequire("ft3QQ");







function $c569c6717078e761$var$MultiSeriesTooltip(_ref) {
    var _tooltipData$nearestD, _window, _window2, _tooltipData$nearestS;
    let { tooltipData: tooltipData, tooltipLeft: tooltipLeft, tooltipTop: tooltipTop, xAccessor: xAccessor, yAccessor: yAccessor, colorAccessor: colorAccessor, colorScale: colorScale, valueFormatter: valueFormatter = (0, $1T8PM.default).formatNumberAbbreviated } = _ref;
    const datum = tooltipData === null || tooltipData === void 0 ? void 0 : (_tooltipData$nearestD = tooltipData.nearestDatum) === null || _tooltipData$nearestD === void 0 ? void 0 : _tooltipData$nearestD.datum;
    // TODO: SSR check
    const scrollX = ((_window = window) === null || _window === void 0 ? void 0 : _window.scrollX) || 0;
    const scrollY = ((_window2 = window) === null || _window2 === void 0 ? void 0 : _window2.scrollY) || 0;
    const portalLeft = (tooltipLeft || 0) + scrollX;
    const portalTop = (tooltipTop || 0) + scrollY;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: datum && /*#__PURE__*/ (0, $l998X.jsxs)((0, $ft3QQ.default), {
            // needed for bounds to update correctly
            left: portalLeft,
            top: portalTop,
            tooltipPortalElement: document.body,
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $f15eed92a0011d7b$export$fd7ac08b5fcaeea), {
                    children: xAccessor(datum) instanceof Date ? (0, $1T8PM.default).multiTimeFormat(xAccessor(datum)) : String(xAccessor(datum))
                }),
                tooltipData === null || tooltipData === void 0 ? void 0 : (_tooltipData$nearestS = tooltipData.nearestSeriesData) === null || _tooltipData$nearestS === void 0 ? void 0 : _tooltipData$nearestS.map((d, i)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $1MtIV.TooltipRow), {
                        color: colorScale(colorAccessor(d)),
                        label: colorAccessor(d),
                        value: String(valueFormatter(yAccessor(d)))
                    }, String(xAccessor(d)) + i))
            ]
        }, Math.random())
    });
}
const $c569c6717078e761$export$a2bd9600d7197e69 = (0, $eytdg.element)($c569c6717078e761$var$MultiSeriesTooltip);


/* mark.tsx generated by @compiled/babel-plugin v0.28.8 */ 


parcelRequire("85XjS");
var $8pvXH = parcelRequire("8pvXH");










parcelRequire("85XjS");
var $96A3a = parcelRequire("96A3a");
var $5iPSB = parcelRequire("5iPSB");
var $cxzSD = parcelRequire("cxzSD");





var $4tanV = parcelRequire("4tanV");







var $8iIOB = parcelRequire("8iIOB");




var $8785c2d80c135732$export$7ce4d19a8c2ea22f = (0, $ewsGH.default)('domain', 'range', 'reverse', 'clamp', 'interpolate', 'nice', 'round', 'zero');
function $8785c2d80c135732$export$2e2bcd8739ae039(config) {
    return $8785c2d80c135732$export$7ce4d19a8c2ea22f((0, $8iIOB.default)(), config);
}


var $fIQbT = parcelRequire("fIQbT");




var $ed81e94f4d07aed2$export$8cc7d5fc9fe1e0a3 = (0, $ewsGH.default)('domain', 'range', 'reverse', 'base', 'clamp', 'interpolate', 'nice', 'round');
function $ed81e94f4d07aed2$export$2e2bcd8739ae039(config) {
    return $ed81e94f4d07aed2$export$8cc7d5fc9fe1e0a3((0, $fIQbT.default)(), config);
}


var $3mlav = parcelRequire("3mlav");

var $0RrNK = parcelRequire("0RrNK");




var $a413ece65bcce970$export$1c86c961a04b7858 = (0, $ewsGH.default)('domain', 'range', 'reverse', 'align', 'padding', 'round');
function $a413ece65bcce970$export$2e2bcd8739ae039(config) {
    return $a413ece65bcce970$export$1c86c961a04b7858((0, $0RrNK.point)(), config);
}


const $0bbe210d91f57bce$export$3067802c84a365ce = (0, $eytdg.element)((props)=>{
    const { data: data, x: x, y: y, color: color, width: width, height: height, log: log, yDomain: yDomain } = props;
    const { fillStyles: fillStyles, useThemeFillStyles: useThemeFillStyles } = (0, $ea9Et.useElementProps)((0, $4tanV.default).elements.Theme);
    // TODO: children should come from hook
    const value = (0, $42omo.useMemo)(()=>{
        const xScale = x(data[0]) instanceof Date || x(data[data.length - 1]) instanceof Date ? (0, $355931b808dc9ff1$export$2e2bcd8739ae039)({
            // TODO: make sure this works with unique values
            // @ts-expect-error - extent might return [undefined, undefined]
            domain: (0, $96A3a.default)(data, x),
            range: [
                0,
                width
            ]
        }) : (0, $a413ece65bcce970$export$2e2bcd8739ae039)({
            // TODO: make sure this works with unique values
            domain: [
                ...new Set(data.map(x))
            ],
            range: [
                0,
                width
            ],
            padding: 0
        });
        // d3 max can handle null values
        const maxYValue = (0, $cxzSD.default)([
            ...data.map(y)
        ]);
        const yDomainOutput = [
            log ? 1 : 0,
            maxYValue !== null && maxYValue !== void 0 ? maxYValue : 1
        ];
        if (yDomain && yDomain[0] !== null) yDomainOutput[0] = yDomain[0];
        if (yDomain && yDomain[1] !== null) yDomainOutput[1] = yDomain[1];
        const yScale = !props.log ? (0, $8785c2d80c135732$export$2e2bcd8739ae039)({
            domain: yDomainOutput,
            range: [
                height,
                0
            ]
        }) : (0, $ed81e94f4d07aed2$export$2e2bcd8739ae039)({
            domain: yDomainOutput,
            range: [
                height,
                0
            ]
        });
        const { domain: domain, range: range } = useThemeFillStyles({
            fillStyles: fillStyles
        });
        const colorScale = (0, $3mlav.default)({
            domain: domain ? domain : data.map(color),
            range: range
        });
        const seriesData = (0, $5iPSB.default)(data, x);
        return {
            xScale: xScale,
            yScale: yScale,
            colorScale: colorScale,
            seriesData: seriesData
        };
    }, [
        data,
        x,
        y,
        color,
        width,
        height,
        log,
        yDomain
    ]);
    return props.children(value);
});





const $b5a1fffa633eee31$var$DataContext = /*#__PURE__*/ (0, $42omo.createContext)({});
function $b5a1fffa633eee31$export$e9dcd4f541370089(_ref) {
    let { children: children, ...props } = _ref;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $4A2iI.Theme), {
        fillStyles: (0, $4A2iI.DEFAULT_ORDINAL_COLORS),
        useThemeFillStyles: (0, $4A2iI.useThemeFillStyles),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $0bbe210d91f57bce$export$3067802c84a365ce), {
            ...props,
            children: (scales)=>/*#__PURE__*/ (0, $l998X.jsx)($b5a1fffa633eee31$var$DataContext.Provider, {
                    value: {
                        ...props,
                        ...scales
                    },
                    children: children
                })
        })
    });
}
function $b5a1fffa633eee31$export$253d7860b08dc7a0() {
    return (0, $42omo.useContext)($b5a1fffa633eee31$var$DataContext);
}





const $26f0ad785be6e3fd$var$lineStyles = null;
function $26f0ad785be6e3fd$var$_LinePath(_ref) {
    let { data: data = [], x: x, y: y, fill: fill = 'transparent', fillOpacity: fillOpacity, strokeOpacity: strokeOpacity = 1, curve: curve, defined: defined = ()=>true, stroke: stroke, strokeWidth: strokeWidth, strokeDasharray: strokeDasharray } = _ref;
    const path = (0, $8pvXH.default)().x((d)=>x(d)).y((d)=>y(d)).defined(defined);
    return /*#__PURE__*/ (0, $l998X.jsx)("path", {
        d: path(data) || '',
        fill: fill,
        fillOpacity: fillOpacity,
        strokeOpacity: strokeOpacity,
        stroke: stroke,
        strokeWidth: strokeWidth,
        strokeDasharray: strokeDasharray // without this a datum surrounded by nulls will not be visible
        ,
        strokeLinecap: "round",
        className: (0, $gMc0m.default)([
            "_v5641de5"
        ])
    });
}
const $26f0ad785be6e3fd$export$7e9023be98b4a812 = (0, $eytdg.element)($26f0ad785be6e3fd$var$_LinePath);
const $26f0ad785be6e3fd$export$83633c2b874e7fe8 = (0, $eytdg.element)((props)=>{
    const { stroke: stroke, x: x, y: y, lineGroups: lineGroups, strokeWidth: strokeWidth } = props;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: Array.from(lineGroups).map((_ref2)=>{
            let [key, entries] = _ref2;
            return /*#__PURE__*/ (0, $l998X.jsx)($26f0ad785be6e3fd$export$7e9023be98b4a812, {
                stroke: stroke(key),
                strokeWidth: strokeWidth,
                data: entries,
                x: x,
                y: y
            }, `${key}-${stroke(key)}`);
        })
    });
});
const $26f0ad785be6e3fd$export$9b27752060f27111 = (0, $eytdg.element)((props)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {});
});
const $26f0ad785be6e3fd$export$6ac937313e6b7c6 = (0, $eytdg.element)((_ref3)=>{
    let { lineGroups: lineGroups, xScale: xScale, yScale: yScale, colorScale: colorScale, xAccessor: xAccessor, yAccessor: yAccessor, hide: hide = false } = _ref3;
    if (hide) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: Array.from(lineGroups).map((_ref4)=>{
            let [key, entries] = _ref4;
            return entries.map((entry)=>{
                return /*#__PURE__*/ (0, $l998X.jsx)("circle", {
                    cx: xScale(xAccessor(entry)),
                    cy: yScale(yAccessor(entry)),
                    r: 4,
                    fill: "var(--ds-surface)",
                    stroke: colorScale(key),
                    strokeWidth: 2
                }, `line-mark-point-${key}-${xAccessor(entry)}`);
            });
        })
    });
});
function $26f0ad785be6e3fd$export$3e69a2ec6d143702() {
    const { xScale: xScale, yScale: yScale, colorScale: colorScale, xAccessor: xAccessor, yAccessor: yAccessor, lineGroups: lineGroups, data: data, height: height } = (0, $b5a1fffa633eee31$export$253d7860b08dc7a0)();
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)($26f0ad785be6e3fd$export$83633c2b874e7fe8, {
                stroke: (key)=>colorScale(key),
                x: (d)=>{
                    var _xScale;
                    return (_xScale = xScale(xAccessor(d))) !== null && _xScale !== void 0 ? _xScale : 0;
                },
                y: (d)=>{
                    var _yScale;
                    return (_yScale = yScale(yAccessor(d))) !== null && _yScale !== void 0 ? _yScale : height;
                },
                lineGroups: lineGroups,
                strokeWidth: 2
            }),
            /*#__PURE__*/ (0, $l998X.jsx)($26f0ad785be6e3fd$export$9b27752060f27111, {
                xScale: xScale,
                yScale: yScale,
                colorScale: colorScale,
                xAccessor: xAccessor,
                yAccessor: yAccessor,
                lineGroups: lineGroups,
                data: data
            }),
            /*#__PURE__*/ (0, $l998X.jsx)($26f0ad785be6e3fd$export$6ac937313e6b7c6, {
                xScale: xScale,
                yScale: yScale,
                colorScale: colorScale,
                xAccessor: xAccessor,
                yAccessor: yAccessor,
                lineGroups: lineGroups,
                data: data
            })
        ]
    });
}










var $fPEWw = parcelRequire("fPEWw");


var $lWRDd = parcelRequire("lWRDd");


var $6mMqq = parcelRequire("6mMqq");




parcelRequire("85XjS");
var $1xrzo = parcelRequire("1xrzo");
var $7XxQH = parcelRequire("7XxQH");
var $7R8A1 = parcelRequire("7R8A1");

function $215eeb6fc96d86f6$export$2e2bcd8739ae039(_ref) {
    let { scale: scale, accessor: accessor, scaledValue: scaledValue, data: data } = _ref;
    const coercedScale = scale; // broaden type before type guards below
    let nearestDatum;
    let nearestDatumIndex;
    // if scale has .invert(), convert svg coord to nearest data value
    if ('invert' in coercedScale && typeof coercedScale.invert === 'function') {
        const bisect = (0, $7XxQH.default)(accessor).left;
        // find closest data value, then map that to closest datum
        const dataValue = Number(coercedScale.invert(scaledValue));
        const index = bisect(data, dataValue);
        // take the two datum nearest this index, and compute which is closer
        const nearestDatum0 = data[index - 1];
        const nearestDatum1 = data[index];
        nearestDatum = !nearestDatum0 || Math.abs(dataValue - accessor(nearestDatum0)) > Math.abs(dataValue - accessor(nearestDatum1)) ? nearestDatum1 : nearestDatum0;
        nearestDatumIndex = nearestDatum === nearestDatum0 ? index - 1 : index;
    } else if ('step' in coercedScale && typeof coercedScale.step !== 'undefined') {
        // band scales don't have an invert function but they do have discrete domains
        // so we manually invert
        const domain = scale.domain();
        const range = scale.range().map(Number);
        // Remove the padding for the points
        // https://github.com/airbnb/visx/issues/1602
        // Need to consider
        const sortedRange = [
            ...range
        ].sort((a, b)=>a - b); // bisectLeft assumes sort
        const sortedDomain = range[0] < range[1] ? domain : domain.reverse();
        let domainValue = 0;
        if ('paddingInner' in scale) {
            // BandScale
            // Get the outer padding.
            const paddingOuter = scale(sortedDomain[0]) || 0;
            // Get each band size
            const eachBand = coercedScale.step();
            // Find the index
            const index = Math.floor((scaledValue - paddingOuter) / eachBand);
            // Get domain value
            domainValue = sortedDomain[Math.max(0, Math.min(index, sortedDomain.length - 1))];
        } else {
            // PointScale
            // Create ranges that take into account the padding of the first and last
            // elements. Basically if there is 0 padding then the first element
            // should go into the negative by 1/2 the step amount.
            const rangePoints = (0, $7R8A1.default)(sortedRange[0] - coercedScale.step() * (0.5 - coercedScale.padding()), sortedRange[1] + coercedScale.step() * (0.5 - coercedScale.padding()), coercedScale.step());
            domainValue = sortedDomain[(0, $1xrzo.bisectLeft)(rangePoints, scaledValue) - 1];
        }
        const index = data.findIndex((d)=>String(accessor(d)) === String(domainValue));
        nearestDatum = data[index];
        nearestDatumIndex = index;
    } else {
        console.warn('[visx/xychart/findNearestDatum] encountered incompatible scale type, bailing');
        return null;
    }
    if (nearestDatum == null || nearestDatumIndex == null) return null;
    const distance = Math.abs(Number(coercedScale(accessor(nearestDatum))) - scaledValue);
    return {
        datum: nearestDatum,
        index: nearestDatumIndex,
        distance: distance
    };
}


function $84ba349b3506e27b$export$2e2bcd8739ae039(_ref) {
    let { xScale: scale, xAccessor: accessor, yScale: yScale, yAccessor: yAccessor, point: point, data: data } = _ref;
    if (!point) return null;
    const nearestDatum = (0, $215eeb6fc96d86f6$export$2e2bcd8739ae039)({
        scale: scale,
        accessor: accessor,
        scaledValue: point.x,
        data: data
    });
    return nearestDatum ? {
        datum: nearestDatum.datum,
        index: nearestDatum.index,
        distanceX: nearestDatum.distance,
        distanceY: Math.abs(Number(yScale(yAccessor(nearestDatum.datum))) - point.y)
    } : null;
}



function $554b9b30214cb272$export$2e2bcd8739ae039(_ref) {
    let { yScale: scale, yAccessor: accessor, xScale: xScale, xAccessor: xAccessor, point: point, data: data } = _ref;
    if (!point) return null;
    const nearestDatum = (0, $215eeb6fc96d86f6$export$2e2bcd8739ae039)({
        scale: scale,
        accessor: accessor,
        scaledValue: point.y,
        data: data
    });
    return nearestDatum ? {
        datum: nearestDatum.datum,
        index: nearestDatum.index,
        distanceY: nearestDatum.distance,
        distanceX: Math.abs(Number(xScale(xAccessor(nearestDatum.datum))) - point.x)
    } : null;
}



var $iWLaT = parcelRequire("iWLaT");

const $8035d4ea6e40815b$export$76917c244f8b44cb = '__POINTER_EVENTS_ALL';
const $8035d4ea6e40815b$export$ee16f91d64c2973e = '__POINTER_EVENTS_NEAREST';
function $8035d4ea6e40815b$export$1d0a87a519049f8c(event) {
    return !!event && ('clientX' in event || 'changedTouches' in event);
}
function $8035d4ea6e40815b$export$9829d00ac5f2232d(event) {
    return !!event && !$8035d4ea6e40815b$export$1d0a87a519049f8c(event);
}
function $8035d4ea6e40815b$export$2e2bcd8739ae039(_ref) {
    let { findNearestDatum: findNearestDatumProps, onBlur: onBlur, onFocus: onFocus, onPointerMove: onPointerMove, onPointerOut: onPointerOut, onPointerUp: onPointerUp, onPointerDown: onPointerDown, allowedSources: allowedSources, width: width, height: height, margin: margin, data: data, xScale: xScale, yScale: yScale, xAccessor: xAccessor, yAccessor: yAccessor, seriesData: seriesData, horizontal: horizontal } = _ref;
    // this logic is shared by pointerup, pointermove, and focus handlers
    const getHandlerParams = (0, $42omo.useCallback)((params)=>{
        const { svgPoint: svgPoint, event: event } = params || {};
        // nearest Datum across all dataKeys, if relevant
        // let nearestDatumPointerParams: EventHandlerParams<Datum> | null = null;
        // let nearestDatumDistance = Infinity;
        if (params && event && svgPoint && width && height) {
            const findNearestFunction = !horizontal ? (0, $84ba349b3506e27b$export$2e2bcd8739ae039) : (0, $554b9b30214cb272$export$2e2bcd8739ae039);
            const nearestDatum = findNearestFunction({
                height: height,
                data: data,
                point: {
                    x: svgPoint.x - margin.left,
                    y: svgPoint.y - margin.top
                },
                width: width,
                xAccessor: !horizontal ? xAccessor : yAccessor,
                xScale: xScale,
                yAccessor: !horizontal ? yAccessor : xAccessor,
                yScale: yScale
            });
            if (nearestDatum) {
                const access = xAccessor;
                // TODO: get all of the data nearest
                const pointerParams = [
                    {
                        svgPoint: svgPoint,
                        event: event,
                        ...nearestDatum,
                        nearestSeriesData: seriesData.get(access(nearestDatum === null || nearestDatum === void 0 ? void 0 : nearestDatum.datum))
                    }
                ];
                // dataKey === POINTER_EVENTS_NEAREST
                // console.log(pointerParams);
                //     ? [nearestDatumPointerParams]
                // : dataKey === POINTER_EVENTS_ALL || Array.isArray(dataKey)
                //   ? Object.values(pointerParamsByKey)
                //   : [pointerParamsByKey[dataKey]];
                return pointerParams.filter((param)=>param);
            } else {
                const pointerParams = [
                    {
                        svgPoint: svgPoint,
                        event: event,
                        datum: null
                    }
                ];
                return pointerParams.filter((param)=>param);
            }
        }
        return [];
    }, [
        data,
        xScale,
        yScale,
        width,
        height,
        (0, $84ba349b3506e27b$export$2e2bcd8739ae039)
    ]);
    const handlePointerMove = (0, $42omo.useCallback)((params)=>{
        if (onPointerMove) getHandlerParams(params).forEach((p)=>onPointerMove(p));
    }, [
        getHandlerParams,
        onPointerMove
    ]);
    const handlePointerUp = (0, $42omo.useCallback)((params)=>{
        if (onPointerUp) getHandlerParams(params).forEach((p)=>onPointerUp(p));
    }, [
        getHandlerParams,
        onPointerUp
    ]);
    const handlePointerDown = (0, $42omo.useCallback)((params)=>{
        if (onPointerDown) getHandlerParams(params).forEach((p)=>onPointerDown(p));
    }, [
        getHandlerParams,
        onPointerDown
    ]);
    const handleFocus = (0, $42omo.useCallback)((params)=>{
        if (onFocus) getHandlerParams(params).forEach((p)=>onFocus(p));
    }, [
        getHandlerParams,
        onFocus
    ]);
    const handlePointerOut = (0, $42omo.useCallback)((params)=>{
        const event = params === null || params === void 0 ? void 0 : params.event;
        if (event && $8035d4ea6e40815b$export$1d0a87a519049f8c(event) && onPointerOut) onPointerOut(event);
    }, [
        onPointerOut
    ]);
    const handleBlur = (0, $42omo.useCallback)((params)=>{
        const event = params === null || params === void 0 ? void 0 : params.event;
        if (event && $8035d4ea6e40815b$export$9829d00ac5f2232d(event) && onBlur) onBlur(event);
    }, [
        onBlur
    ]);
    (0, $iWLaT.default)('pointermove', onPointerMove ? handlePointerMove : undefined, allowedSources);
    (0, $iWLaT.default)('pointerout', onPointerOut ? handlePointerOut : undefined, allowedSources);
    (0, $iWLaT.default)('pointerup', onPointerUp ? handlePointerUp : undefined, allowedSources);
    (0, $iWLaT.default)('pointerdown', onPointerDown ? handlePointerDown : undefined, allowedSources);
    (0, $iWLaT.default)('focus', onFocus ? handleFocus : undefined, allowedSources);
    (0, $iWLaT.default)('blur', onBlur ? handleBlur : undefined, allowedSources);
}






const $848a2fb1a5999420$export$3b8bee032f520d15 = (0, $eytdg.element)((props)=>{
    const { tooltipOpen: tooltipOpen, showTooltip: showTooltip, hideTooltip: hideTooltip, tooltipData: tooltipData, width: width, height: height, xScale: xScale, yScale: yScale, colorScale: colorScale, xAccessor: xAccessor, colorAccessor: colorAccessor, margin: margin, yAccessor: yAccessor, seriesData: seriesData, data: data, onClick: onClick } = props;
    const eventEmitters = (0, $6mMqq.default)({
        source: (0, $fPEWw.XYCHART_EVENT_SOURCE)
    });
    (0, $8035d4ea6e40815b$export$2e2bcd8739ae039)({
        dataKey: 'nearest',
        onPointerMove: (d)=>showTooltip(d),
        onPointerOut: ()=>hideTooltip(),
        onPointerDown: (d)=>onClick && onClick(d),
        allowedSources: [
            (0, $fPEWw.XYCHART_EVENT_SOURCE)
        ],
        width: width,
        margin: margin,
        height: height,
        data: data,
        xScale: xScale,
        yScale: yScale,
        xAccessor: xAccessor,
        yAccessor: yAccessor,
        seriesData: seriesData
    });
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            tooltipOpen && (tooltipData === null || tooltipData === void 0 ? void 0 : tooltipData.nearestSeriesData) && /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
                children: tooltipData === null || tooltipData === void 0 ? void 0 : tooltipData.nearestSeriesData.map((d)=>/*#__PURE__*/ (0, $l998X.jsx)("circle", {
                        cx: xScale(xAccessor(d)) || 0,
                        cy: yScale(yAccessor(d)) || 0,
                        fill: colorScale(colorAccessor(d)),
                        r: 5
                    }, xScale(xAccessor(d)) + '-' + xAccessor(d) + '-' + colorAccessor(d)))
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                style: {
                    cursor: onClick ? 'pointer' : 'default'
                },
                width: width,
                height: height,
                fill: "transparent",
                ...eventEmitters
            })
        ]
    });
});
function $848a2fb1a5999420$export$5b99d955e74ee803() {
    const { width: width, height: height, xScale: xScale, yScale: yScale, xAccessor: xAccessor, colorAccessor: colorAccessor, colorScale: colorScale, yAccessor: yAccessor, seriesData: seriesData, margin: margin, data: data } = (0, $b5a1fffa633eee31$export$253d7860b08dc7a0)();
    const { showTooltip: showTooltip, tooltipData: tooltipData, tooltipOpen: tooltipOpen, hideTooltip: hideTooltip } = (0, $42omo.useContext)((0, $lWRDd.default));
    return /*#__PURE__*/ (0, $l998X.jsx)($848a2fb1a5999420$export$3b8bee032f520d15, {
        tooltipOpen: tooltipOpen,
        showTooltip: showTooltip,
        hideTooltip: hideTooltip,
        tooltipData: tooltipData,
        width: width,
        height: height,
        xScale: xScale,
        yScale: yScale,
        xAccessor: xAccessor,
        colorScale: colorScale,
        colorAccessor: colorAccessor,
        yAccessor: yAccessor,
        margin: margin,
        seriesData: seriesData,
        data: data
    });
}


parcelRequire("85XjS");





/* CartesianGrid.tsx generated by @compiled/babel-plugin v0.28.8 */ 





function $38d14d07faf649c5$export$2e2bcd8739ae039(_ref) {
    let { children: children } = _ref;
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        className: (0, $gMc0m.default)([
            "_1e0c1txw _kqswh2mm _16jlkb7n _1tkeidpf _1ul9idpf"
        ]),
        children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
            className: (0, $gMc0m.default)([
                "_1e0c11p5 _yv0ey09t _2z051qft _zulp1nty _1lmcpu6d _1ul9idpf _1tkeidpf _1bsb1osq _4t3i1osq"
            ]),
            children: children
        })
    });
}



var $5FE3o = parcelRequire("5FE3o");


var $ak0BM = parcelRequire("ak0BM");


var $hGekP = parcelRequire("hGekP");


var $ezYGr = parcelRequire("ezYGr");







function $585b1de399cd5c91$export$b60d33194508b687() {
    const { xScale: xScale, yScale: yScale, height: height, width: width } = (0, $b5a1fffa633eee31$export$253d7860b08dc7a0)();
    // We should make this check better. Move out the string constructor.s
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $02e60cd405540c9a$export$4b76feaa547cd202), {
                scale: yScale
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $8828968c6a0c9e95$export$deea0fad05dcb466), {
                scale: xScale,
                top: height,
                left: width
            })
        ]
    });
}













const $c6ca694517ab312a$var$LazyDataTableModal = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("ddut0")).then((module)=>({
            default: module.DataTableModal
        })));
function $c6ca694517ab312a$export$df30df7ec97b32b5() {
    const { showDataTable: showDataTable, closeDataTable: closeDataTable } = (0, $gZHwv.useMenuData)();
    const { data: data } = (0, $b5a1fffa633eee31$export$253d7860b08dc7a0)();
    return showDataTable ? /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
        fallback: /*#__PURE__*/ (0, $l998X.jsx)("div", {
            style: {
                visibility: 'hidden'
            }
        }),
        children: /*#__PURE__*/ (0, $l998X.jsx)($c6ca694517ab312a$var$LazyDataTableModal, {
            data: data,
            closeModal: closeDataTable
        })
    }) : null;
}







function $a5f79accd4737e70$export$d8859dcc14f68e06() {
    const { xScale: xScale, yScale: yScale, height: height, width: width } = (0, $b5a1fffa633eee31$export$253d7860b08dc7a0)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9aa89164c9e6e11d$export$ef2184bd89960b14), {
        yScale: yScale,
        xScale: xScale,
        width: width,
        height: height
    });
}









function $1e68662e58dca698$export$596c258a3ca26f43() {
    const { data: data, colorAccessor: colorAccessor, colorScale: colorScale } = (0, $b5a1fffa633eee31$export$253d7860b08dc7a0)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fgtqy.OrdinalLegend), {
        shape: "line",
        data: data,
        colorScale: colorScale,
        colorAccessor: colorAccessor,
        labelAccessor: colorAccessor
    });
}














function $9b535572b0bffa78$export$88204a09bcf12e49() {
    const { xAccessor: xAccessor, yAccessor: yAccessor, colorAccessor: colorAccessor, colorScale: colorScale } = (0, $b5a1fffa633eee31$export$253d7860b08dc7a0)();
    const { tooltipData: tooltipData, tooltipLeft: tooltipLeft, tooltipTop: tooltipTop } = (0, $42omo.useContext)((0, $lWRDd.default));
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $c569c6717078e761$export$a2bd9600d7197e69), {
        tooltipData: tooltipData,
        tooltipLeft: tooltipLeft,
        tooltipTop: tooltipTop,
        xAccessor: xAccessor,
        yAccessor: yAccessor,
        colorAccessor: colorAccessor,
        colorScale: colorScale
    });
}







function $4d96981940ba37d7$var$defaultColorAccessor() {
    return (d)=>'';
}
function $4d96981940ba37d7$var$useAccessors(_ref) {
    let { xAccessor: xAccessor, yAccessor: yAccessor, colorAccessor: colorAccessor } = _ref;
    // GENERATE ENCODINGS
    const [x, y, color] = (0, $42omo.useMemo)(()=>{
        const [x] = (0, $hGekP.useSafeAccessors)(xAccessor);
        const [y] = (0, $hGekP.useSafeAccessors)(yAccessor);
        const [color] = (0, $hGekP.useSafeAccessors)(colorAccessor);
        return [
            x,
            y,
            color
        ];
    }, [
        xAccessor,
        yAccessor,
        colorAccessor
    ]);
    return {
        x: x,
        y: y,
        color: color
    };
}
function $4d96981940ba37d7$export$165a9edbbc19a7c(_ref2) {
    let { data: data, width: width, height: height, xAccessor: xAccessor, yAccessor: yAccessor, colorAccessor: colorAccessor, margin: margin = (0, $ezYGr.DEFAULT_MARGIN), svgRef: svgRef } = _ref2;
    const [plotHeight, plotWidth] = (0, $42omo.useMemo)(()=>[
            Math.max(0, height - margin.top - margin.bottom),
            Math.max(0, width - margin.left - margin.right)
        ], [
        height,
        margin,
        width
    ]);
    // GENERATE ACCESSORS
    const { x: x, y: y, color: color } = $4d96981940ba37d7$var$useAccessors({
        xAccessor: xAccessor,
        yAccessor: yAccessor,
        colorAccessor: colorAccessor || $4d96981940ba37d7$var$defaultColorAccessor()
    });
    const groups = (0, $42omo.useMemo)(()=>(0, $5iPSB.default)(data, color), [
        data,
        color
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $b5a1fffa633eee31$export$e9dcd4f541370089), {
        data: data,
        x: x,
        y: y,
        color: color,
        width: plotWidth,
        height: plotHeight,
        xAccessor: x,
        yAccessor: y,
        colorAccessor: color,
        margin: margin,
        lineGroups: groups,
        children: [
            colorAccessor && /*#__PURE__*/ (0, $l998X.jsx)((0, $1e68662e58dca698$export$596c258a3ca26f43), {}),
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $38d14d07faf649c5$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $a5f79accd4737e70$export$d8859dcc14f68e06), {}),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $585b1de399cd5c91$export$b60d33194508b687), {}),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $5FE3o.default), {
                        innerRef: svgRef,
                        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $ak0BM.default), {
                            top: margin.top,
                            left: margin.left,
                            children: [
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $26f0ad785be6e3fd$export$3e69a2ec6d143702), {}),
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $848a2fb1a5999420$export$5b99d955e74ee803), {})
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $9b535572b0bffa78$export$88204a09bcf12e49), {}),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $c6ca694517ab312a$export$df30df7ec97b32b5), {})
        ]
    });
}





function $3411ed14a3855349$export$2e2bcd8739ae039(_ref) {
    let { width: width, height: height, children: children, ...restProps } = _ref;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $ea9Et.ElementsProvider), {
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $7lOgj.default), {
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gZHwv.MenuProvider), {
                children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $lKyMg.default), {
                    children: [
                        children,
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $lg6bu.LayoutContainer), {
                            width: width,
                            height: height,
                            data: restProps.data,
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $990l4.DimensionsWrapper), {
                                children: (_ref2)=>{
                                    let { margin: margin, plotHeight: plotHeight, plotWidth: plotWidth, plotSvgRef: plotSvgRef } = _ref2;
                                    return /*#__PURE__*/ (0, $l998X.jsx)((0, $4d96981940ba37d7$export$165a9edbbc19a7c), {
                                        svgRef: plotSvgRef,
                                        height: plotHeight,
                                        width: plotWidth,
                                        margin: margin,
                                        ...restProps
                                    });
                                }
                            })
                        })
                    ]
                })
            })
        })
    });
}
$3411ed14a3855349$export$2e2bcd8739ae039.elements = {
    // All of the Axis Left components
    AxisLeft: (0, $02e60cd405540c9a$export$4b76feaa547cd202).Component,
    AxisLeftText: (0, $02e60cd405540c9a$export$68f34be0235fe9c0).Component,
    AxisLeftTick: (0, $02e60cd405540c9a$export$d9ad68803a03e71).Component,
    AxisLeftLine: (0, $02e60cd405540c9a$export$25abdf51e62eb76e).Component,
    // AxisBottomComponents
    AxisBottom: (0, $8828968c6a0c9e95$export$deea0fad05dcb466).Component,
    AxisBottomText: (0, $8828968c6a0c9e95$export$ebfad67a29d89d08).Component,
    AxisBottomTick: (0, $8828968c6a0c9e95$export$34bea378c04af713).Component,
    AxisBottomLine: (0, $8828968c6a0c9e95$export$84b05a0ae8b61ab5).Component,
    Layout: (0, $lPjcQ.Layout).Component,
    Title: (0, $i7s9b.Title).Component,
    SubTitle: (0, $90XX3.Subtitle).Component,
    Menu: (0, $gbyey.Menu).Component,
    Theme: (0, $4A2iI.Theme).Component,
    Legend: (0, $fgtqy.OrdinalLegend).Component,
    Grid: (0, $9aa89164c9e6e11d$export$ef2184bd89960b14).Component,
    // Linechart custom elements
    Scales: (0, $0bbe210d91f57bce$export$3067802c84a365ce).Component,
    Tooltip: (0, $c569c6717078e761$export$a2bd9600d7197e69).Component,
    TooltipOverlay: (0, $848a2fb1a5999420$export$3b8bee032f520d15).Component,
    Mark: (0, $26f0ad785be6e3fd$export$7e9023be98b4a812).Component,
    Marks: (0, $26f0ad785be6e3fd$export$83633c2b874e7fe8).Component,
    AddMark: (0, $26f0ad785be6e3fd$export$9b27752060f27111).Component,
    PointMarks: (0, $26f0ad785be6e3fd$export$6ac937313e6b7c6).Component
};

});

parcelRegister("ea9Et", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $l998X = parcelRequire("l998X");


var $kyRHQ = parcelRequire("kyRHQ");

const $a4f97c81204c66c3$export$a92ee76f0b1f4e66 = /*#__PURE__*/ (0, $42omo.createContext)(null);
function $a4f97c81204c66c3$export$71c0ba76abe92a7e(_ref) {
    let { children: children, defaultProps: defaultProps, kind: kind } = _ref;
    const ctx = $a4f97c81204c66c3$export$83d5c6859f2ae3df();
    const value = (0, $42omo.useMemo)(()=>{
        // If kind is specified, we assume we are in nested element so we get the parent registry
        // Ideally we'd use WeakMap but node < 20 does not support symbols as keys
        const registry = kind && (ctx === null || ctx === void 0 ? void 0 : ctx.registry) || new Map();
        return {
            registry: registry,
            register: (kind, value)=>{
                const currentEl = registry.get(kind);
                // if registry does not have element or the element is the same
                // ensure we set both the override and the fresh props
                if (!currentEl || currentEl.Component === value.Component) registry.set(kind, value);
            },
            retrieve: (kind)=>registry.get(kind),
            isNested: (k)=>k === kind || Boolean(ctx === null || ctx === void 0 ? void 0 : ctx.isNested(k)),
            getProps: (k)=>k === kind ? defaultProps : ctx === null || ctx === void 0 ? void 0 : ctx.getProps(k),
            getOuterProps: (k)=>{
                var _registry$get;
                return Boolean(ctx === null || ctx === void 0 ? void 0 : ctx.isNested(k)) ? (_registry$get = registry.get(k)) === null || _registry$get === void 0 ? void 0 : _registry$get.outerProps : null;
            }
        };
    }, [
        kind,
        defaultProps
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)($a4f97c81204c66c3$export$a92ee76f0b1f4e66.Provider, {
        value: value,
        children: children
    });
}
const $a4f97c81204c66c3$export$83d5c6859f2ae3df = ()=>(0, $42omo.useContext)($a4f97c81204c66c3$export$a92ee76f0b1f4e66);
function $a4f97c81204c66c3$export$8edbe6dd5606980(element, _temp) {
    var _process, _process$env, _useElements, _useElements2, _useElements3;
    let { mergeWith: mergeWith } = _temp === void 0 ? {} : _temp;
    if (typeof element.kind !== 'symbol') throw new Error('Invalid element argument. It must be an element or an element Component.');
    if (((_process = $kyRHQ) === null || _process === void 0 ? void 0 : (_process$env = _process.env) === null || _process$env === void 0 ? void 0 : _process$env.NODE_ENV) === 'development' && !((_useElements = $a4f97c81204c66c3$export$83d5c6859f2ae3df()) !== null && _useElements !== void 0 && _useElements.isNested(element.kind))) throw new Error('Invalid element argument. Only props of parent elements can be retrieved.');
    return {
        ...(_useElements2 = $a4f97c81204c66c3$export$83d5c6859f2ae3df()) === null || _useElements2 === void 0 ? void 0 : _useElements2.getProps(element.kind),
        ...(_useElements3 = $a4f97c81204c66c3$export$83d5c6859f2ae3df()) === null || _useElements3 === void 0 ? void 0 : _useElements3.getOuterProps(element.kind),
        ...mergeWith
    };
}
module.exports["ElementsProvider"] = $a4f97c81204c66c3$export$71c0ba76abe92a7e;
module.exports["useElements"] = $a4f97c81204c66c3$export$83d5c6859f2ae3df;
module.exports["useElementProps"] = $a4f97c81204c66c3$export$8edbe6dd5606980;

});

parcelRegister("eytdg", function(module, exports) {
// Chart element takes a chart type generic which says what kind of overrides we can do

var $ea9Et = parcelRequire("ea9Et");


var $l998X = parcelRequire("l998X");

function $a98ae6ba9361a4e9$export$8454457683f90105(DefaultComponent, options) {
    var _options$as;
    if (options === void 0) options = {};
    const displayName = DefaultComponent.displayName || DefaultComponent.name || options.displayName;
    const kind = ((_options$as = options.as) === null || _options$as === void 0 ? void 0 : _options$as.kind) || Symbol(displayName);
    if (options.as && !options.as.kind) throw new Error('Invalid "as" component. It must be an `element` or `element.Component` value.');
    /**
   * When used outside its own slot, it will register the override
   * while when its used inside the slot, it will render the component
   */ const ElementComponent = (outerProps)=>{
        const ctx = (0, $ea9Et.useElements)();
        if (!ctx) throw new Error('Element must be used inside an ElementsProvider');
        // Check if we are rendering under the own ElementComponent, if so, just render
        if (ctx !== null && ctx !== void 0 && ctx.isNested(kind)) return /*#__PURE__*/ (0, $l998X.jsx)(DefaultComponent, {
            ...!options.as && ctx.getProps(kind),
            ...outerProps
        });
        else {
            ctx.register(kind, {
                Component: DefaultComponent,
                outerProps: outerProps
            });
            return null;
        }
    };
    ElementComponent.kind = kind;
    // When as is defined we return the component without any slot implementation
    if (options.as) return ElementComponent;
    /**
   * Defines the slot where the element will be rendered, grabbing the implementation from the context
   */ const ElementSlot = (defaultProps)=>{
        const ctx = (0, $ea9Et.useElements)();
        const { Component: Component = DefaultComponent, outerProps: outerProps } = (ctx === null || ctx === void 0 ? void 0 : ctx.retrieve(kind)) || {};
        const isSelf = Component === DefaultComponent;
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $ea9Et.ElementsProvider), {
            kind: kind,
            defaultProps: defaultProps,
            children: /*#__PURE__*/ (0, $l998X.jsx)(Component, {
                ...isSelf && defaultProps,
                ...outerProps
            })
        });
    };
    ElementSlot.kind = kind;
    ElementSlot.Component = ElementComponent;
    ElementSlot.displayName = `element(${displayName})`;
    return ElementSlot;
}
module.exports["element"] = $a98ae6ba9361a4e9$export$8454457683f90105;

});

parcelRegister("1T8PM", function(module, exports) {
$parcel$export(module.exports, "default", () => $1601c7c663e4c469$export$2e2bcd8739ae039);
parcelRequire("85XjS");
var $8byOH = parcelRequire("8byOH");
var $9hPuh = parcelRequire("9hPuh");
var $hUXR8 = parcelRequire("hUXR8");
var $bvxAe = parcelRequire("bvxAe");
var $bVd5g = parcelRequire("bVd5g");
var $f05wp = parcelRequire("f05wp");
var $6D0ZF = parcelRequire("6D0ZF");
var $aDGh8 = parcelRequire("aDGh8");

const $1601c7c663e4c469$var$formatNumberAbbreviated = (value)=>{
    if (value === null) return 'null';
    let numberValue;
    if (typeof value === 'string') {
        const parsedValue = Number(value);
        if (isNaN(parsedValue)) return value;
        numberValue = parsedValue;
    } else numberValue = value;
    return new Intl.NumberFormat('en-US', {
        notation: 'compact',
        compactDisplay: 'short'
    }).format(numberValue);
};
const $1601c7c663e4c469$var$percentChange = (currentValue, previousValue)=>{
    if (previousValue === 0) return (currentValue * 100).toFixed();
    return (Math.abs(previousValue - currentValue) / previousValue * 100).toFixed();
};
const $1601c7c663e4c469$var$formatMillisecond = (0, $9hPuh.timeFormat)('.%L'), $1601c7c663e4c469$var$formatSecond = (0, $9hPuh.timeFormat)(':%S'), $1601c7c663e4c469$var$formatMinute = (0, $9hPuh.timeFormat)('%I:%M'), $1601c7c663e4c469$var$formatHour = (0, $9hPuh.timeFormat)('%I %p'), $1601c7c663e4c469$var$formatDay = (0, $9hPuh.timeFormat)('%b %d'), $1601c7c663e4c469$var$formatWeek = (0, $9hPuh.timeFormat)('%b %d'), $1601c7c663e4c469$var$formatMonth = (0, $9hPuh.timeFormat)('%b'), $1601c7c663e4c469$var$formatYear = (0, $9hPuh.timeFormat)('%Y');
function $1601c7c663e4c469$export$16cec29b78b14126(date) {
    return ((0, $f05wp.second)(date) < date ? $1601c7c663e4c469$var$formatMillisecond : (0, $bvxAe.timeMinute)(date) < date ? $1601c7c663e4c469$var$formatSecond : (0, $hUXR8.timeHour)(date) < date ? $1601c7c663e4c469$var$formatMinute : (0, $8byOH.timeDay)(date) < date ? $1601c7c663e4c469$var$formatHour : (0, $bVd5g.timeMonth)(date) < date ? (0, $6D0ZF.timeSunday)(date) < date ? $1601c7c663e4c469$var$formatDay : $1601c7c663e4c469$var$formatWeek : (0, $aDGh8.timeYear)(date) < date ? $1601c7c663e4c469$var$formatMonth : $1601c7c663e4c469$var$formatYear)(date);
}
function $1601c7c663e4c469$export$dcbb097fa84257c1(str) {
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}
var $1601c7c663e4c469$export$2e2bcd8739ae039 = {
    formatNumberAbbreviated: $1601c7c663e4c469$var$formatNumberAbbreviated,
    percentChange: $1601c7c663e4c469$var$percentChange,
    multiTimeFormat: $1601c7c663e4c469$export$16cec29b78b14126,
    toSentenceCase: $1601c7c663e4c469$export$dcbb097fa84257c1
};
module.exports["toSentenceCase"] = $1601c7c663e4c469$export$dcbb097fa84257c1;

});

parcelRegister("85XjS", function(module, exports) {
$parcel$export(module.exports, "bisectLeft", () => (parcelRequire("1xrzo")).bisectLeft);
$parcel$export(module.exports, "timeDay", () => (parcelRequire("8byOH")).timeDay);
$parcel$export(module.exports, "timeHour", () => (parcelRequire("hUXR8")).timeHour);
$parcel$export(module.exports, "timeMinute", () => (parcelRequire("bvxAe")).timeMinute);
$parcel$export(module.exports, "timeMonth", () => (parcelRequire("bVd5g")).timeMonth);
$parcel$export(module.exports, "timeYear", () => (parcelRequire("aDGh8")).timeYear);
$parcel$export(module.exports, "timeFormat", () => (parcelRequire("9hPuh")).timeFormat);
$parcel$export(module.exports, "bisector", () => (parcelRequire("7XxQH")).default);
$parcel$export(module.exports, "extent", () => (parcelRequire("96A3a")).default);
$parcel$export(module.exports, "group", () => (parcelRequire("5iPSB")).default);
$parcel$export(module.exports, "max", () => (parcelRequire("cxzSD")).default);
$parcel$export(module.exports, "range", () => (parcelRequire("7R8A1")).default);
$parcel$export(module.exports, "arc", () => (parcelRequire("hmRtu")).default);
$parcel$export(module.exports, "line", () => (parcelRequire("8pvXH")).default);
$parcel$export(module.exports, "pie", () => (parcelRequire("dPhqZ")).default);
$parcel$export(module.exports, "timeSecond", () => (parcelRequire("f05wp")).second);
$parcel$export(module.exports, "timeWeek", () => (parcelRequire("6D0ZF")).timeSunday);
parcelRequire("1xrzo");

var $7XxQH = parcelRequire("7XxQH");

var $96A3a = parcelRequire("96A3a");

var $5iPSB = parcelRequire("5iPSB");

var $cxzSD = parcelRequire("cxzSD");

var $7R8A1 = parcelRequire("7R8A1");


parcelRequire("cplqD");























var $hmRtu = parcelRequire("hmRtu");

var $8pvXH = parcelRequire("8pvXH");

var $dPhqZ = parcelRequire("dPhqZ");

parcelRequire("8byOH");
parcelRequire("hUXR8");
parcelRequire("bvxAe");
parcelRequire("bVd5g");

var $f05wp = parcelRequire("f05wp");

var $6D0ZF = parcelRequire("6D0ZF");
parcelRequire("aDGh8");

parcelRequire("9hPuh");


parcelRequire("4dZMr");

parcelRequire("ckcOL");


});

parcelRegister("lg6bu", function(module, exports) {
$parcel$export(module.exports, "Layout", () => (parcelRequire("lPjcQ")).Layout);

var $lPjcQ = parcelRequire("lPjcQ");


var $l998X = parcelRequire("l998X");

function $f79fe3a6d884dfd7$export$faad8b178f68f912(_ref) {
    let { height: height, width: width, children: children, ...props } = _ref;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $lPjcQ.Layout), {
        showBorder: true,
        width: width,
        height: height,
        hasSubtitle: true,
        gridTemplate: (0, $lPjcQ.defaultGrid),
        ...props,
        children: children
    });
}
module.exports["LayoutContainer"] = $f79fe3a6d884dfd7$export$faad8b178f68f912;

});

parcelRegister("lPjcQ", function(module, exports) {
/* layout.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $eytdg = parcelRequire("eytdg");

/* icon.tsx generated by @compiled/babel-plugin v0.28.8 */ 






var $l998X = parcelRequire("l998X");

const $e16bb3d2fc50ee6d$var$iconStyle = null;
function $e16bb3d2fc50ee6d$var$Icon(_ref) {
    let { children: children } = _ref;
    if (!children) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        className: (0, $gMc0m.default)([
            "_1bsb7vkz _4t3i1tcg _syaz1t5i"
        ]),
        children: children
    });
}
const $e16bb3d2fc50ee6d$export$f04a61298a47a40f = (0, $eytdg.element)($e16bb3d2fc50ee6d$var$Icon);



var $gbyey = parcelRequire("gbyey");


var $90XX3 = parcelRequire("90XX3");

var $i7s9b = parcelRequire("i7s9b");




const $fe3d425cfe6b24d0$export$aed5b7d86c3777ab = [
    'title',
    'subtitle',
    'legend',
    'plot'
];
function $fe3d425cfe6b24d0$var$Layout(_ref) {
    var _ref2, _ordering$plot;
    let { children: children, width: width, height: height, gridTemplate: gridTemplate, hasSubtitle: hasSubtitle, overflow: overflow = 'hidden', showBorder: showBorder = true } = _ref;
    const ordering = gridTemplate.reduce((acc, key, i)=>{
        acc[key] = i + 1;
        return acc;
    }, {});
    const chartOrder = (_ref2 = (_ordering$plot = ordering['plot']) !== null && _ordering$plot !== void 0 ? _ordering$plot : ordering['plot-legend']) !== null && _ref2 !== void 0 ? _ref2 : ordering['legend-plot'];
    const chartFlexDirection = ordering['plot'] || ordering['legend'] ? 'column' : 'row';
    const chartFlexReverse = ordering['legend'] > ordering['plot'] || ordering['plot-legend'] ? '-reverse' : '';
    const [fadeInOpacity, setFadeInOpacity] = (0, $42omo.useState)(0);
    (0, $42omo.useEffect)(()=>{
        let isMounted = true;
        const ref = window.requestAnimationFrame(()=>{
            // TODO: would be nice to fade in without triggering another render
            if (isMounted) setFadeInOpacity(1);
        });
        return ()=>{
            isMounted = false;
            window.cancelAnimationFrame(ref);
        };
    }, [
        setFadeInOpacity
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: /*#__PURE__*/ (0, $l998X.jsxs)("div", {
            "data-element": "layout",
            style: {
                width: width,
                height: height,
                backgroundColor: "var(--ds-surface, white)",
                border: showBorder ? `1px solid ${"var(--ds-border, lightgrey)"}` : '0px',
                padding: showBorder ? "var(--ds-space-200)" : 0,
                overflow: overflow
            },
            className: (0, $gMc0m.default)([
                "_1e0c1txw _kqswh2mm _4t3i1osq _2lx21bp4 _vchhusvi"
            ]),
            children: [
                /*#__PURE__*/ (0, $l998X.jsxs)("div", {
                    style: {
                        order: ordering.title,
                        position: 'relative'
                    },
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $e16bb3d2fc50ee6d$export$f04a61298a47a40f), {}),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $i7s9b.Title), {})
                    ]
                }),
                /*#__PURE__*/ (0, $l998X.jsx)("div", {
                    style: {
                        order: ordering.subtitle
                    },
                    children: hasSubtitle && /*#__PURE__*/ (0, $l998X.jsx)((0, $90XX3.Subtitle), {})
                }),
                /*#__PURE__*/ (0, $l998X.jsx)("div", {
                    "data-element": "chart",
                    style: {
                        opacity: fadeInOpacity,
                        transition: 'opacity .3s ease-in-out',
                        order: chartOrder,
                        flexDirection: `${chartFlexDirection}${chartFlexReverse}`
                    },
                    className: (0, $gMc0m.default)([
                        "_1e0c1txw _1ul9idpf _1tkeidpf _16jlkb7n"
                    ]),
                    children: children
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $gbyey.ChartMenu), {})
            ]
        })
    });
}
const $fe3d425cfe6b24d0$export$c84671f46d6a1ca = (0, $eytdg.element)($fe3d425cfe6b24d0$var$Layout);
module.exports["defaultGrid"] = $fe3d425cfe6b24d0$export$aed5b7d86c3777ab;
module.exports["Layout"] = $fe3d425cfe6b24d0$export$c84671f46d6a1ca;

});

parcelRegister("gbyey", function(module, exports) {

var $1qfLF = parcelRequire("1qfLF");


var $52EPl = parcelRequire("52EPl");

var $dAYOx = parcelRequire("dAYOx");

var $ahaN7 = parcelRequire("ahaN7");


var $jsixF = parcelRequire("jsixF");


var $eytdg = parcelRequire("eytdg");

var $ea9Et = parcelRequire("ea9Et");

parcelRequire("lg6bu");
var $lPjcQ = parcelRequire("lPjcQ");


var $gZHwv = parcelRequire("gZHwv");


var $l998X = parcelRequire("l998X");

const $bc883a8e02f1762b$export$d9b273488cd8ce6f = (0, $eytdg.element)((_ref)=>{
    let { children: children, hide: hide = false, toggleDataTable: toggleDataTable } = _ref;
    if (hide) return null;
    const { showBorder: showBorder } = (0, $ea9Et.useElementProps)((0, $lPjcQ.Layout));
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        style: {
            position: 'absolute',
            top: 0,
            right: 0,
            padding: showBorder ? "var(--ds-space-200)" : 0
        },
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $52EPl.default), {
            trigger: (_ref2)=>{
                let { triggerRef: triggerRef, ...props } = _ref2;
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                    ...props,
                    appearance: "subtle",
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($jsixF))),
                    label: "Chart Menu Options",
                    ref: triggerRef,
                    spacing: "compact"
                });
            },
            shouldRenderToParent: true,
            placement: "top-end",
            spacing: "compact",
            children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $ahaN7.default), {
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $dAYOx.default), {
                        onClick: toggleDataTable,
                        children: "Show Data Table"
                    }, "Show Data Table"),
                    children
                ]
            })
        })
    });
});
function $bc883a8e02f1762b$export$597da2837c1a3c88(props) {
    const { toggleDataTable: toggleDataTable } = (0, $gZHwv.useMenuData)();
    return /*#__PURE__*/ (0, $l998X.jsx)($bc883a8e02f1762b$export$d9b273488cd8ce6f, {
        ...props,
        toggleDataTable: toggleDataTable
    });
}
module.exports["Menu"] = $bc883a8e02f1762b$export$d9b273488cd8ce6f;
module.exports["ChartMenu"] = $bc883a8e02f1762b$export$597da2837c1a3c88;

});

parcelRegister("bw1Fx", function(module, exports) {

var $7Q5yr = parcelRequire("7Q5yr");


var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");




function $68e9c3371d4ee3c7$export$25d302a5b900a763(defaultGetTokens) {
    const emptyThemeFn = (getTokens, props)=>getTokens(props);
    /**
   * Internally, Theme uses React Context, with internal providers and consumers.
   * The React Context passes only a function that gets props, and turns them into tokens. This
   * function gets mixed as more Providers with their own themes are added. This mixed function
   * is ultimately picked up by Consumers, which implement a context consumer internally to fetch
   * the theme.
   */ const ThemeContext = /*#__PURE__*/ (0, $42omo.createContext)(defaultGetTokens);
    function useTheme(themeProps) {
        const theme = (0, $42omo.useContext)(ThemeContext);
        const themeFn = theme || emptyThemeFn;
        const tokens = themeFn(themeProps);
        return tokens;
    }
    // The Theme Consumer takes a function as its child - this function takes tokens, and the
    // return value is generally a set of nodes with the tokens applied appropriately.
    function Consumer(props) {
        const { children: children, ...themeProps } = props;
        // @ts-ignore See issue for more info: https://github.com/Microsoft/TypeScript/issues/10727
        // Argument of type 'Pick<ThemeProps & { children: (tokens: ThemeTokens) => ReactNode; }, Exclude<keyof ThemeProps, "children">>' is not assignable to parameter of type 'ThemeProps'.ts(2345)
        const tokens = useTheme(themeProps);
        // We add a fragment to ensure we don't break people upgrading.
        // Previously they may have been able to pass in undefined without things blowing up.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children(tokens));
    }
    /**
   * The Theme Provider takes regular nodes as its children, but also takes a *theme function*
   * - The theme function takes a set of props, as well as a function (getTokens) that can turn props into tokens.
   * - The getTokens function isn't called immediately - instead the props are passed
   *    through a mix of parent theming functions
   * Children of this provider will receive this mixed theme
   */ function Provider(props) {
        const themeFn = (0, $42omo.useContext)(ThemeContext);
        const valueFn = props.value || emptyThemeFn;
        const mixedFn = (0, $42omo.useCallback)((themeProps)=>valueFn(themeFn, themeProps), [
            themeFn,
            valueFn
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ThemeContext.Provider, {
            value: mixedFn
        }, props.children);
    }
    return {
        Consumer: Consumer,
        Provider: Provider,
        useTheme: useTheme
    };
}


// Create default global light theme
const { Provider: $0770364d1118e8bb$var$Provider, Consumer: $0770364d1118e8bb$var$Consumer, useTheme: $0770364d1118e8bb$export$7692396083754928 } = (0, $68e9c3371d4ee3c7$export$25d302a5b900a763)(()=>({
        mode: 'light'
    }));
const $0770364d1118e8bb$var$Theme = {
    Provider: $0770364d1118e8bb$var$Provider,
    Consumer: $0770364d1118e8bb$var$Consumer
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$0770364d1118e8bb$export$2e2bcd8739ae039 = $0770364d1118e8bb$var$Theme;


const $66d8f5b0aeced04b$var$themedBackground = {
    light: "var(--ds-surface, #FFFFFF)",
    dark: "var(--ds-surface, #1B2638)"
};
const $66d8f5b0aeced04b$export$18cb9425622d4e06 = (mode = 'light')=>$66d8f5b0aeced04b$var$themedBackground[mode];


const $5b69932953a8473c$export$c647cb0ee6e282fe = {
    small: '16px',
    medium: '24px',
    large: '32px',
    xlarge: '48px'
};
const $5b69932953a8473c$export$7bd66fc94c81bf84 = {
    small: 'small',
    medium: 'medium',
    large: 'large',
    xlarge: 'xlarge'
};
const $5b69932953a8473c$export$62ad7b0c781000e9 = {
    small: {
        width: $5b69932953a8473c$export$c647cb0ee6e282fe.small,
        height: $5b69932953a8473c$export$c647cb0ee6e282fe.small
    },
    medium: {
        width: $5b69932953a8473c$export$c647cb0ee6e282fe.medium,
        height: $5b69932953a8473c$export$c647cb0ee6e282fe.medium
    },
    large: {
        width: $5b69932953a8473c$export$c647cb0ee6e282fe.large,
        height: $5b69932953a8473c$export$c647cb0ee6e282fe.large
    },
    xlarge: {
        width: $5b69932953a8473c$export$c647cb0ee6e282fe.xlarge,
        height: $5b69932953a8473c$export$c647cb0ee6e282fe.xlarge
    }
};





const $8014eb3e0a667f02$export$16374db1c3e6dfba = {
    overflow: 'hidden',
    pointerEvents: 'none',
    /**
   * Stop-color doesn't properly apply in chrome when the inherited/current color changes.
   * We have to initially set stop-color to inherit (either via DOM attribute or an initial CSS
   * rule) and then override it with currentColor for the color changes to be picked up.
   */ stop: {
        stopColor: 'currentColor'
    }
};
const $8014eb3e0a667f02$var$smallStyles = /*#__PURE__*/ (0, $9K4OG.css)((0, $5b69932953a8473c$export$62ad7b0c781000e9).small);
const $8014eb3e0a667f02$var$mediumStyles = /*#__PURE__*/ (0, $9K4OG.css)((0, $5b69932953a8473c$export$62ad7b0c781000e9).medium);
const $8014eb3e0a667f02$var$largeStyles = /*#__PURE__*/ (0, $9K4OG.css)((0, $5b69932953a8473c$export$62ad7b0c781000e9).large);
const $8014eb3e0a667f02$var$xlargeStyles = /*#__PURE__*/ (0, $9K4OG.css)((0, $5b69932953a8473c$export$62ad7b0c781000e9).xlarge);
const $8014eb3e0a667f02$export$ef0ad74202575b64 = {
    small: $8014eb3e0a667f02$var$smallStyles,
    medium: $8014eb3e0a667f02$var$mediumStyles,
    large: $8014eb3e0a667f02$var$largeStyles,
    xlarge: $8014eb3e0a667f02$var$xlargeStyles
};
const $8014eb3e0a667f02$export$3eb7d6130acfda37 = ({ width: width, height: height, size: size })=>{
    if (width && height) return {
        width: width,
        height: height
    };
    if (size) return (0, $5b69932953a8473c$export$62ad7b0c781000e9)[size];
    return undefined;
};


function $8623fa46a9d1633a$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
/**
 * We are hiding these props from consumers as they're used to
 * hack around icon sizing specifically for icon-file-type.
 */ const $8623fa46a9d1633a$var$iconStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    display: 'inline-block',
    flexShrink: 0,
    lineHeight: 1,
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    '> svg': {
        ...(0, $8014eb3e0a667f02$export$16374db1c3e6dfba),
        maxWidth: '100%',
        maxHeight: '100%',
        color: 'var(--icon-primary-color)',
        fill: 'var(--icon-secondary-color)',
        verticalAlign: 'bottom'
    }
});
/**
 * For windows high contrast mode
 */ const $8623fa46a9d1633a$var$baseHcmStyles = {
    name: "tdbe8",
    styles: "@media screen and (forced-colors: active){> svg{filter:grayscale(1);--icon-primary-color:CanvasText;--icon-secondary-color:Canvas;}}"
};
const $8623fa46a9d1633a$var$primaryEqualsSecondaryHcmStyles = {
    name: "1pgb0eo",
    styles: "@media screen and (forced-colors: active){> svg{--icon-primary-color:Canvas;}}"
};
const $8623fa46a9d1633a$var$secondaryTransparentHcmStyles = {
    name: "s2qd3p",
    styles: "@media screen and (forced-colors: active){> svg{--icon-secondary-color:transparent;}}"
};
const $8623fa46a9d1633a$export$f04a61298a47a40f = /*#__PURE__*/ (0, $42omo.memo)(function Icon(props) {
    const { glyph: Glyph, dangerouslySetGlyph: dangerouslySetGlyph, primaryColor: primaryColor = 'currentColor', secondaryColor: secondaryColor, size: size, testId: testId, label: label, width: width, height: height } = props;
    const glyphProps = dangerouslySetGlyph ? {
        dangerouslySetInnerHTML: {
            __html: dangerouslySetGlyph
        }
    } : {
        children: Glyph ? (0, $9K4OG.jsx)(Glyph, {
            role: "presentation"
        }) : null
    };
    const dimensions = (0, $8014eb3e0a667f02$export$3eb7d6130acfda37)({
        width: width,
        height: height,
        size: size
    });
    const { mode: mode } = (0, $0770364d1118e8bb$export$7692396083754928)();
    return (0, $9K4OG.jsx)("span", (0, $7Q5yr.default)({
        "data-testid": testId,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            '--icon-primary-color': primaryColor,
            '--icon-secondary-color': secondaryColor || (0, $66d8f5b0aeced04b$export$18cb9425622d4e06)(mode)
        }
    }, glyphProps, {
        css: [
            $8623fa46a9d1633a$var$iconStyles,
            $8623fa46a9d1633a$var$baseHcmStyles,
            primaryColor === secondaryColor && $8623fa46a9d1633a$var$primaryEqualsSecondaryHcmStyles,
            secondaryColor === 'transparent' && $8623fa46a9d1633a$var$secondaryTransparentHcmStyles,
            // NB: This can be resolved if this component, composes base SVG / and/or skeleton
            // We could then simplify how common styles are dealt with simply by encapsualting them
            // at their appropriate level and/or having a singular approach to css variables in the package
            dimensions && /*#__PURE__*/ // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            (0, $9K4OG.css)({
                width: dimensions.width,
                height: dimensions.height,
                '> svg': dimensions
            })
        ]
    }));
});
var $8623fa46a9d1633a$export$2e2bcd8739ae039 = $8623fa46a9d1633a$export$f04a61298a47a40f;
module.exports["Icon"] = $8623fa46a9d1633a$export$f04a61298a47a40f;

});

parcelRegister("gZHwv", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $l998X = parcelRequire("l998X");

function $c5f41aa71698d261$export$2ce5e940c4008526() {
    const [showDataTable, setShowDataTable] = (0, $42omo.useState)(false);
    const toggleDataTable = (0, $42omo.useCallback)(()=>{
        setShowDataTable((prevShowDataTable)=>!prevShowDataTable);
    }, []);
    const closeDataTable = (0, $42omo.useCallback)(()=>{
        setShowDataTable(false);
    }, []);
    return {
        showDataTable: showDataTable,
        closeDataTable: closeDataTable,
        toggleDataTable: toggleDataTable
    };
}
const $c5f41aa71698d261$export$c7e742effb1c51e2 = /*#__PURE__*/ (0, $42omo.createContext)({});
function $c5f41aa71698d261$export$bf0039e2171862f5() {
    return (0, $42omo.useContext)($c5f41aa71698d261$export$c7e742effb1c51e2);
}
const $c5f41aa71698d261$export$62b22d151866115d = (_ref)=>{
    let { children: children } = _ref;
    const { showDataTable: showDataTable, toggleDataTable: toggleDataTable, closeDataTable: closeDataTable } = $c5f41aa71698d261$export$2ce5e940c4008526();
    return /*#__PURE__*/ (0, $l998X.jsx)($c5f41aa71698d261$export$c7e742effb1c51e2.Provider, {
        value: {
            showDataTable: showDataTable,
            closeDataTable: closeDataTable,
            toggleDataTable: toggleDataTable
        },
        children: children
    });
};
module.exports["useMenuData"] = $c5f41aa71698d261$export$bf0039e2171862f5;
module.exports["MenuProvider"] = $c5f41aa71698d261$export$62b22d151866115d;

});

parcelRegister("90XX3", function(module, exports) {
/* subtitle.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $gMc0m = parcelRequire("gMc0m");


var $eytdg = parcelRequire("eytdg");


var $l998X = parcelRequire("l998X");

const $69029e490a04d1ad$var$subTitleTextStyle = null;
function $69029e490a04d1ad$var$Subtitle(_ref) {
    let { children: children } = _ref;
    if (!children) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)("h3", {
        className: (0, $gMc0m.default)([
            "_syaz1k3w _k48p1nn1 _ect41wi2 _1wyb1crf _zg8l4jg8 _vwz47vkz _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdftgi _19bvidpf"
        ]),
        children: children
    });
}
const $69029e490a04d1ad$export$cf345ef34cd72655 = (0, $eytdg.element)($69029e490a04d1ad$var$Subtitle);
module.exports["Subtitle"] = $69029e490a04d1ad$export$cf345ef34cd72655;

});

parcelRegister("i7s9b", function(module, exports) {
/* title.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $gMc0m = parcelRequire("gMc0m");


var $eytdg = parcelRequire("eytdg");


var $l998X = parcelRequire("l998X");

const $d30eb6df62d4097d$var$titleTextStyle = null;
function $d30eb6df62d4097d$var$Title(_ref) {
    let { children: children } = _ref;
    if (!children) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)("h2", {
        className: (0, $gMc0m.default)([
            "_syaz1k3w _k48pni7l _zg8l4jg8 _ect4e86e _1wyb7vkz _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1yt4c950"
        ]),
        children: children
    });
}
const $d30eb6df62d4097d$export$f99233281efd08a0 = (0, $eytdg.element)($d30eb6df62d4097d$var$Title);
module.exports["Title"] = $d30eb6df62d4097d$export$f99233281efd08a0;

});

parcelRegister("990l4", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $6a85379e46a2ba56$var$INITIAL_DIMENSIONS = {
    plotHeight: 100,
    plotWidth: 100,
    margin: {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    }
};
function $6a85379e46a2ba56$export$a263c0cd0abdd921(_ref) {
    let { children: children } = _ref;
    const [, forceUpdate] = (0, $42omo.useState)({});
    const dimensions = (0, $42omo.useRef)($6a85379e46a2ba56$var$INITIAL_DIMENSIONS);
    const plotSvgRef = (0, $42omo.useRef)(null);
    // Update the dimensions and margin when the SVG element is resized.
    (0, $42omo.useEffect)(()=>{
        const resizeObserverSvg = new ResizeObserver((entries)=>{
            if (entries && entries[0]) {
                const { width: ws, height: hs } = entries[0].target.getBoundingClientRect();
                const newMargin = Object.assign({}, dimensions.current.margin);
                dimensions.current = {
                    margin: newMargin,
                    plotHeight: hs,
                    plotWidth: ws
                };
                forceUpdate({});
            }
        });
        // If parentDiv is available, observe it and its axis-left child (if exists).
        // If not, disconnect the observers.
        if (plotSvgRef.current) resizeObserverSvg.observe(plotSvgRef.current);
        return ()=>{
            resizeObserverSvg.disconnect();
        };
    }, []);
    return children({
        ...dimensions.current,
        plotSvgRef: plotSvgRef
    });
}
module.exports["DimensionsWrapper"] = $6a85379e46a2ba56$export$a263c0cd0abdd921;

});

parcelRegister("fgtqy", function(module, exports) {
/* OrdinalLegend.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");





var $iWLaT = parcelRequire("iWLaT");

const $95db5a2600120459$export$76a2e4c433c23bb9 = 'pointermove';
const $95db5a2600120459$export$8312cda563b4f1d7 = 'series-key-highlight';
function $95db5a2600120459$export$2e2bcd8739ae039(eventType) {
    if (eventType === void 0) eventType = $95db5a2600120459$export$76a2e4c433c23bb9;
    const emit = (0, $iWLaT.default)();
    const emitActiveSeriesKey = (0, $42omo.useCallback)((event, label)=>emit === null || emit === void 0 ? void 0 : emit(eventType, event, $95db5a2600120459$export$8312cda563b4f1d7, label), [
        emit
    ]);
    return {
        emitActiveSeriesKey: emitActiveSeriesKey
    };
}



var $eytdg = parcelRequire("eytdg");

var $ea9Et = parcelRequire("ea9Et");


var $lPjcQ = parcelRequire("lPjcQ");

const $8d819001a013d937$export$e64d201155cc8fe2 = 160;
const $8d819001a013d937$export$bc48d9a7fd313bb2 = 32;
const $8d819001a013d937$export$fece36e05d7a6c7b = 8;
const $8d819001a013d937$export$57cb39d4eda3140a = 16;
const $8d819001a013d937$export$1949567a35c96224 = 12;
const $8d819001a013d937$export$3a3ed70a2e553a67 = 2;
const $8d819001a013d937$export$7bf402e928540137 = 10000;





const $21050b35954a7334$export$178827bcd84b6d71 = (data, labelAccessor)=>{
    return data.reduce((flat, d)=>{
        const label = labelAccessor(d);
        if (flat[label]) return flat;
        const newFlatData = {
            ...flat
        };
        newFlatData[label] = d;
        return newFlatData;
    }, {});
};
const $21050b35954a7334$export$5303528d1070ff6f = (value)=>{
    if (value === 'normal') return 8;
    else return parseFloat(value);
};
function $21050b35954a7334$export$ec599d67f76e7af7(_ref) {
    let { legendRefCurrent: legendRefCurrent, setTruncationIndex: setTruncationIndex } = _ref;
    (0, $42omo.useEffect)(()=>{
        const observer = new ResizeObserver((entries)=>{
            let fit = 0;
            const content = [
                ...entries[0].target.children
            ];
            content.forEach((d)=>{
                // Look into isVisible function
                if (!$21050b35954a7334$export$660f61eb7bd5242a(entries[0].target, d)) fit += 1;
            });
            setTruncationIndex(fit);
        });
        if (legendRefCurrent) observer.observe(legendRefCurrent);
        return ()=>{
            if (legendRefCurrent) observer.unobserve(legendRefCurrent);
        };
    }, [
        legendRefCurrent,
        setTruncationIndex
    ]);
}
const $21050b35954a7334$export$660f61eb7bd5242a = (parent, child)=>{
    const box1coords = parent.getBoundingClientRect();
    const box2coords = child.getBoundingClientRect();
    if (box2coords.top + 2 < box1coords.top || box2coords.right - 2 > box1coords.right || box2coords.bottom - 2 > box1coords.bottom || box2coords.left + 2 < box1coords.left) return true;
    return false;
};
function $21050b35954a7334$export$f27cffe517b2d3a3(_ref2) {
    let { labelAccessor: labelAccessor, data: data } = _ref2;
    return (0, $42omo.useMemo)(()=>Object.values(data.reduce((flat, d)=>{
            const label = labelAccessor(d);
            if (flat[label]) return flat;
            const newFlatData = {
                ...flat
            };
            newFlatData[label] = {
                ...d
            };
            return newFlatData;
        }, {})), [
        labelAccessor,
        data
    ]);
}



var $l998X = parcelRequire("l998X");

const $b1cf2d46c91e112f$export$83dfac8e05432e26 = {
    color: "var(--ds-text-subtlest)",
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif",
    fontSize: '12px',
    margin: '8px 0px',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap'
};
const $b1cf2d46c91e112f$var$LegendSymbol = (_ref)=>{
    let { color: color, shape: shape } = _ref;
    let symbol;
    switch(shape){
        case 'square':
            symbol = /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                fill: color,
                width: (0, $8d819001a013d937$export$1949567a35c96224),
                height: (0, $8d819001a013d937$export$1949567a35c96224),
                rx: 1,
                ry: 1
            });
            break;
        case 'line':
            symbol = /*#__PURE__*/ (0, $l998X.jsx)("line", {
                x1: 0,
                y1: (0, $8d819001a013d937$export$1949567a35c96224) / 2,
                x2: (0, $8d819001a013d937$export$1949567a35c96224),
                y2: (0, $8d819001a013d937$export$1949567a35c96224) / 2,
                stroke: color,
                strokeWidth: 2
            });
            break;
        case 'circle':
        default:
            symbol = /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                fill: color,
                width: (0, $8d819001a013d937$export$1949567a35c96224),
                height: (0, $8d819001a013d937$export$1949567a35c96224),
                rx: (0, $8d819001a013d937$export$1949567a35c96224) / 2,
                ry: (0, $8d819001a013d937$export$1949567a35c96224) / 2
            });
    }
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        className: (0, $gMc0m.default)([
            "_1e0c1txw _1bah1h6o _4cvr1h6o"
        ]),
        children: /*#__PURE__*/ (0, $l998X.jsx)("svg", {
            width: (0, $8d819001a013d937$export$1949567a35c96224),
            height: (0, $8d819001a013d937$export$1949567a35c96224),
            children: symbol
        })
    });
};
const $b1cf2d46c91e112f$var$VerticalLegendMark = (_ref2)=>{
    let { color: color, label: label, shape: shape, opacity: opacity } = _ref2;
    const { emitActiveSeriesKey: emitActiveSeriesKey } = (0, $95db5a2600120459$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $l998X.jsxs)("div", {
        style: {
            opacity: opacity
        },
        onPointerEnter: (e)=>emitActiveSeriesKey(e, label),
        onPointerLeave: (e)=>emitActiveSeriesKey(e, undefined),
        className: (0, $gMc0m.default)([
            "_1e0c1txw _zulpftgi _p12f1osq _4t3izwfg _1ul9idpf"
        ]),
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)($b1cf2d46c91e112f$var$LegendSymbol, {
                color: color,
                shape: shape
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("div", {
                className: (0, $gMc0m.default)([
                    "_syaz1jij _ect41wi2 _1wyb1crf _19pkftgi _2hwxidpf _otyrftgi _18u0idpf _1bto1l2s _1reo15vq _18m915vq _o5721q9c"
                ]),
                children: label
            })
        ]
    });
};
const $b1cf2d46c91e112f$var$HorizontalLegendMark = (_ref3)=>{
    let { color: color, label: label, shape: shape, opacity: opacity } = _ref3;
    const { emitActiveSeriesKey: emitActiveSeriesKey } = (0, $95db5a2600120459$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $l998X.jsxs)("div", {
        style: {
            opacity: opacity
        },
        onPointerEnter: (e)=>emitActiveSeriesKey(e, label),
        onPointerLeave: (e)=>emitActiveSeriesKey(e, undefined),
        className: (0, $gMc0m.default)([
            "_1e0c116y _zulpftgi _4t3izwfg _1ul9idpf"
        ]),
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)($b1cf2d46c91e112f$var$LegendSymbol, {
                color: color,
                shape: shape
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("p", {
                className: (0, $gMc0m.default)([
                    "_syaz1jij _ect41wi2 _1wyb1crf _19pkftgi _2hwxidpf _otyrftgi _18u0idpf _1bto1l2s _1reo15vq _18m915vq _o5721q9c"
                ]),
                children: label
            })
        ]
    });
};
function $b1cf2d46c91e112f$var$VerticalLegend(_ref4) {
    let { data: data, colorAccessor: colorAccessor, colorScale: colorScale, labelAccessor: labelAccessor, shape: shape, justifyContent: justifyContent = 'center', maxRows: maxRows = 10 } = _ref4;
    const legendRef = (0, $42omo.useRef)(null);
    const [truncationIndex, setTruncationIndex] = (0, $42omo.useState)((0, $8d819001a013d937$export$7bf402e928540137));
    const flatData = (0, $21050b35954a7334$export$f27cffe517b2d3a3)({
        labelAccessor: labelAccessor,
        data: data
    });
    (0, $21050b35954a7334$export$ec599d67f76e7af7)({
        legendRefCurrent: legendRef.current,
        setTruncationIndex: setTruncationIndex
    });
    const itemsToTruncate = flatData.length - (truncationIndex || 0);
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        ref: legendRef,
        style: {
            maxHeight: `${maxRows * (0, $8d819001a013d937$export$bc48d9a7fd313bb2) + 2}px`,
            justifyContent: justifyContent
        },
        className: (0, $gMc0m.default)([
            "_1e0c116y _1bah1h6o _1n261g80 _16jlidpf _1o9zidpf _i0dl1r5k _2lx21bp4 _ae4v1y6m _19pk1wug _2hwx1wug _otyr1wug _18u01wug _19bv1crf _4t3i1osq _1reo15vq _18m915vq _gy1p7vkz"
        ]),
        children: flatData.map((d, i)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Fragment), {
                children: itemsToTruncate > 0 && truncationIndex - 1 <= i ? /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
                    children: /*#__PURE__*/ (0, $l998X.jsxs)("div", {
                        style: {
                            position: 'relative'
                        },
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)($b1cf2d46c91e112f$var$VerticalLegendMark, {
                                color: colorScale(colorAccessor(d)),
                                label: labelAccessor(d),
                                shape: shape,
                                opacity: 0
                            }, labelAccessor(d)),
                            truncationIndex - 1 === i && /*#__PURE__*/ (0, $l998X.jsx)("div", {
                                style: {
                                    position: 'absolute',
                                    top: 0,
                                    left: 0
                                },
                                className: (0, $gMc0m.default)([
                                    "_syaz1jij _ect41wi2 _1wyb1crf _19pkftgi _2hwxidpf _otyrftgi _18u0idpf _1bto1l2s _1reo15vq _18m915vq _o5721q9c"
                                ]),
                                children: ` ... ${itemsToTruncate + 1} more`
                            })
                        ]
                    })
                }) : /*#__PURE__*/ (0, $l998X.jsx)($b1cf2d46c91e112f$var$VerticalLegendMark, {
                    color: colorScale(colorAccessor(d)),
                    label: labelAccessor(d),
                    shape: shape
                }, labelAccessor(d))
            }, `vertical-leged-entry${labelAccessor(d)}-${colorScale(colorAccessor(d))}-${i}`))
    });
}
function $b1cf2d46c91e112f$var$HorizontalLegend(_ref5) {
    let { data: data, colorAccessor: colorAccessor, colorScale: colorScale, labelAccessor: labelAccessor, shape: shape, justifyContent: justifyContent = 'flex-start', maxRows: maxRows = 5 } = _ref5;
    const legendRef = (0, $42omo.useRef)(null);
    const [truncationIndex, setTruncationIndex] = (0, $42omo.useState)((0, $8d819001a013d937$export$7bf402e928540137));
    const flatData = (0, $21050b35954a7334$export$f27cffe517b2d3a3)({
        labelAccessor: labelAccessor,
        data: data
    });
    (0, $21050b35954a7334$export$ec599d67f76e7af7)({
        legendRefCurrent: legendRef.current,
        setTruncationIndex: setTruncationIndex
    });
    const itemsToTruncate = flatData.length - (truncationIndex || 0);
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        ref: legendRef,
        style: {
            maxHeight: `${maxRows * (0, $8d819001a013d937$export$bc48d9a7fd313bb2) + 2}px`,
            justifyContent: justifyContent
        },
        className: (0, $gMc0m.default)([
            "_1e0c116y _1n261g80 _16jlidpf _1o9zidpf _i0dl1wug _2lx2vrvc _ae4v1y6m _1bsb1osq _1reo15vq _18m915vq _gy1p7vkz"
        ]),
        children: flatData.map((d, i)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Fragment), {
                children: itemsToTruncate > 0 && truncationIndex - 1 === i ? /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
                    children: /*#__PURE__*/ (0, $l998X.jsxs)("div", {
                        style: {
                            position: 'relative'
                        },
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)($b1cf2d46c91e112f$var$HorizontalLegendMark, {
                                color: colorScale(colorAccessor(d)),
                                label: labelAccessor(d),
                                shape: shape,
                                opacity: 0
                            }, labelAccessor(d)),
                            /*#__PURE__*/ (0, $l998X.jsx)("div", {
                                style: {
                                    position: 'absolute',
                                    top: 0,
                                    left: 0
                                },
                                className: (0, $gMc0m.default)([
                                    "_syaz1jij _ect41wi2 _1wyb1crf _19pkftgi _2hwxidpf _otyrftgi _18u0idpf _1bto1l2s _1reo15vq _18m915vq _o5721q9c"
                                ]),
                                children: ` ... ${itemsToTruncate + 1} more`
                            })
                        ]
                    })
                }) : /*#__PURE__*/ (0, $l998X.jsx)($b1cf2d46c91e112f$var$HorizontalLegendMark, {
                    color: colorScale(colorAccessor(d)),
                    label: labelAccessor(d),
                    shape: shape
                }, labelAccessor(d))
            }, `horizontal-leged-entry${labelAccessor(d)}-${colorScale(colorAccessor(d))}-${i}`))
    });
}
function $b1cf2d46c91e112f$export$734b3ee2d20431e7(_ref6) {
    var _layoutProps$gridTemp;
    let { data: data, colorAccessor: colorAccessor, colorScale: colorScale, labelAccessor: labelAccessor, shape: shape, maxRows: maxRows, justifyContent: justifyContent, hide: hide = false } = _ref6;
    const layoutProps = (0, $ea9Et.useElementProps)((0, $lPjcQ.Layout));
    const sideBySide = !((_layoutProps$gridTemp = layoutProps.gridTemplate) !== null && _layoutProps$gridTemp !== void 0 && _layoutProps$gridTemp.includes('legend'));
    if (hide) return null;
    if (sideBySide) return /*#__PURE__*/ (0, $l998X.jsx)($b1cf2d46c91e112f$var$VerticalLegend, {
        data: data,
        colorAccessor: colorAccessor,
        colorScale: colorScale,
        labelAccessor: labelAccessor,
        shape: shape,
        maxRows: maxRows,
        justifyContent: justifyContent
    });
    return /*#__PURE__*/ (0, $l998X.jsx)($b1cf2d46c91e112f$var$HorizontalLegend, {
        data: data,
        colorAccessor: colorAccessor,
        colorScale: colorScale,
        labelAccessor: labelAccessor,
        shape: shape,
        maxRows: maxRows,
        justifyContent: justifyContent
    });
}
const $b1cf2d46c91e112f$export$7f71253a43a34ee6 = (0, $eytdg.element)($b1cf2d46c91e112f$export$734b3ee2d20431e7);
module.exports["OrdinalLegend"] = $b1cf2d46c91e112f$export$7f71253a43a34ee6;

});

parcelRegister("iWLaT", function(module, exports) {
$parcel$export(module.exports, "default", () => $dcb23cb128696719$export$2e2bcd8739ae039);
// eslint-disable-next-line no-restricted-syntax

var $QpgAL = parcelRequire("QpgAL");


var $42omo = parcelRequire("42omo");


var $bqrhG = parcelRequire("bqrhG");

function $dcb23cb128696719$export$2e2bcd8739ae039(/** Type of event to subscribe to. */ eventType, /** Handler invoked on emission of EventType event.  */ handler, /** Optional valid sources for EventType subscription. */ allowedSources) {
    const emitter = (0, $42omo.useContext)((0, $bqrhG.default));
    const allowedSourcesRef = (0, $42omo.useRef)();
    allowedSourcesRef.current = allowedSources; // use ref so allowedSources[] can change without creating new handlers
    // wrap emitter.emit so we can enforce stricter type signature
    const emit = (0, $42omo.useCallback)((type, event, source, datum)=>{
        if (emitter) emitter.emit(type, {
            event: event,
            svgPoint: (0, $QpgAL.default)(event),
            source: source,
            datum: datum
        });
    }, [
        emitter
    ]);
    (0, $42omo.useEffect)(()=>{
        if (emitter && eventType && handler) {
            // register handler, with source filtering as needed
            const handlerWithSourceFilter = (params)=>{
                var _allowedSourcesRef$cu;
                if (!allowedSourcesRef.current || params !== null && params !== void 0 && params.source && (_allowedSourcesRef$cu = allowedSourcesRef.current) !== null && _allowedSourcesRef$cu !== void 0 && _allowedSourcesRef$cu.includes(params.source)) handler(params);
            };
            emitter.on(eventType, handlerWithSourceFilter);
            return ()=>emitter === null || emitter === void 0 ? void 0 : emitter.off(eventType, handlerWithSourceFilter);
        }
        return undefined;
    }, [
        emitter,
        eventType,
        handler
    ]);
    return emitter ? emit : null;
}

});

parcelRegister("4A2iI", function(module, exports) {

var $eytdg = parcelRequire("eytdg");

const $b538f68b241b6f7b$export$c66920886885446e = (patterns)=>{
    if (!patterns) return [];
    return patterns.map((pattern)=>`url(#${pattern.props.id})`);
};

// import cx from 'classnames';

var $l998X = parcelRequire("l998X");

function $5515df0ee475e9e4$export$2e2bcd8739ae039(_ref) {
    let { id: id, width: width, height: height, children: children } = _ref;
    return /*#__PURE__*/ (0, $l998X.jsx)("defs", {
        children: /*#__PURE__*/ (0, $l998X.jsx)("pattern", {
            id: id,
            width: width,
            height: height,
            patternUnits: "userSpaceOnUse",
            children: children
        })
    });
}





function $d365da9fe92387d5$export$2e2bcd8739ae039(_ref) {
    var _corners;
    let { id: id, width: width, height: height, radius: radius = 2, fill: fill, stroke: stroke, strokeWidth: strokeWidth, strokeDasharray: strokeDasharray, background: background, complement: complement = false, className: className } = _ref;
    let corners;
    if (complement) corners = [
        [
            0,
            0
        ],
        [
            0,
            height
        ],
        [
            width,
            0
        ],
        [
            width,
            height
        ]
    ];
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $5515df0ee475e9e4$export$2e2bcd8739ae039), {
        id: id,
        width: width,
        height: height,
        children: [
            !!background && /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                width: width,
                height: height,
                fill: background
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("circle", {
                // className={cx('visx-pattern-circle', className)}
                cx: width / 2,
                cy: height / 2,
                r: radius,
                fill: fill,
                stroke: stroke,
                strokeWidth: strokeWidth,
                strokeDasharray: strokeDasharray
            }),
            (_corners = corners) === null || _corners === void 0 ? void 0 : _corners.map((_ref2)=>{
                let [cornerX, cornerY] = _ref2;
                return /*#__PURE__*/ (0, $l998X.jsx)("circle", {
                    // className={cx('visx-pattern-circle visx-pattern-circle-complement', className)}
                    cx: cornerX,
                    cy: cornerY,
                    r: radius,
                    fill: fill,
                    stroke: stroke,
                    strokeWidth: strokeWidth,
                    strokeDasharray: strokeDasharray
                }, `${id}-complement-${cornerX}-${cornerY}`);
            })
        ]
    });
}

// import cx from 'classnames';
// import cx from 'classnames';




function $3276ecf141295074$export$2e2bcd8739ae039(_ref) {
    let { id: id, width: width, height: height, path: path, fill: fill = 'transparent', stroke: stroke, strokeWidth: strokeWidth, strokeDasharray: strokeDasharray, strokeLinecap: strokeLinecap = 'square', shapeRendering: shapeRendering = 'auto', background: background, className: className } = _ref;
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $5515df0ee475e9e4$export$2e2bcd8739ae039), {
        id: id,
        width: width,
        height: height,
        children: [
            !!background && /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                width: width,
                height: height,
                fill: background
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                // className={cx('visx-pattern-path', className)}
                d: path,
                fill: fill,
                stroke: stroke,
                strokeWidth: strokeWidth,
                strokeDasharray: strokeDasharray,
                strokeLinecap: strokeLinecap,
                shapeRendering: shapeRendering
            })
        ]
    });
}





function $b0e7bd0c7501bb34$export$2e2bcd8739ae039(_ref) {
    let { id: id, height: height, fill: fill, stroke: stroke, strokeWidth: strokeWidth, strokeDasharray: strokeDasharray, strokeLinecap: strokeLinecap, shapeRendering: shapeRendering, background: background, className: className, size: size = 3 } = _ref;
    const sqrtSize = Math.sqrt(size);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $3276ecf141295074$export$2e2bcd8739ae039), {
        path: `M ${height},0 l ${height},0 l ${height / 2},${height * sqrtSize / 2} l ${-height / 2},${height * sqrtSize / 2} l ${-height},0 l ${-height / 2},${-height * sqrtSize / 2} Z M 0,${height * sqrtSize / 2} l ${height / 2},0 M ${3 * height},${height * sqrtSize / 2} l ${-height / 2},0`,
        id: id,
        width: size,
        height: sqrtSize,
        fill: fill,
        stroke: stroke,
        strokeWidth: strokeWidth,
        strokeDasharray: strokeDasharray,
        strokeLinecap: strokeLinecap,
        shapeRendering: shapeRendering,
        background: background
    });
}

// import cx from 'classnames';
const $54661f876215dd3e$export$c37d4d4692ef0c91 = {
    horizontal: 'horizontal',
    vertical: 'vertical',
    diagonal: 'diagonal',
    diagonalRightToLeft: 'diagonalRightToLeft'
};






function $7e0c32794be81120$export$777054cdc3eb6ab2(_ref) {
    let { height: height, orientation: orientation } = _ref;
    switch(orientation){
        case (0, $54661f876215dd3e$export$c37d4d4692ef0c91).horizontal:
            return `M 0,${height / 2} l ${height},0`;
        case (0, $54661f876215dd3e$export$c37d4d4692ef0c91).diagonal:
            return `M 0,${height} l ${height},${-height} M ${-height / 4},${height / 4} l ${height / 2},${-height / 2}
             M ${3 / 4 * height},${5 / 4 * height} l ${height / 2},${-height / 2}`;
        case (0, $54661f876215dd3e$export$c37d4d4692ef0c91).diagonalRightToLeft:
            return `M 0,0 l ${height},${height}
        M ${-height / 4},${3 / 4 * height} l ${height / 2},${height / 2}
        M ${3 / 4 * height},${-height / 4} l ${height / 2},${height / 2}`;
        case (0, $54661f876215dd3e$export$c37d4d4692ef0c91).vertical:
        default:
            return `M ${height / 2}, 0 l 0, ${height}`;
    }
}
function $7e0c32794be81120$export$2e2bcd8739ae039(_ref2) {
    let { id: id, width: width, height: height, stroke: stroke, strokeWidth: strokeWidth, strokeDasharray: strokeDasharray, strokeLinecap: strokeLinecap = 'square', shapeRendering: shapeRendering = 'auto', orientation: orientation = [
        'vertical'
    ], background: background, className: className } = _ref2;
    const orientations = Array.isArray(orientation) ? orientation : [
        orientation
    ];
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $5515df0ee475e9e4$export$2e2bcd8739ae039), {
        id: id,
        width: width,
        height: height,
        children: [
            !!background && /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                // className={cx('visx-pattern-line-background')}
                width: width,
                height: height,
                fill: background
            }),
            orientations.map((o, i)=>/*#__PURE__*/ (0, $l998X.jsx)("path", {
                    // className={cx('visx-pattern-line', className)}
                    d: $7e0c32794be81120$export$777054cdc3eb6ab2({
                        orientation: o,
                        height: height
                    }),
                    stroke: stroke,
                    strokeWidth: strokeWidth,
                    strokeDasharray: strokeDasharray,
                    strokeLinecap: strokeLinecap,
                    shapeRendering: shapeRendering
                }, `visx-${id}-line-${o}-${i}`))
        ]
    });
}

// import cx from 'classnames';




function $15d09509e153dc90$export$2e2bcd8739ae039(_ref) {
    let { id: id, width: width, height: height, fill: fill, stroke: stroke, strokeWidth: strokeWidth, strokeDasharray: strokeDasharray, strokeLinecap: strokeLinecap, shapeRendering: shapeRendering, background: background, className: className } = _ref;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $3276ecf141295074$export$2e2bcd8739ae039), {
        path: `M 0 ${height / 2} c ${height / 8} ${-height / 4} , ${height * 3 / 8} ${-height / 4} , ${height / 2} 0
             c ${height / 8} ${height / 4} , ${height * 3 / 8} ${height / 4} , ${height / 2} 0 M ${-height / 2} ${height / 2}
             c ${height / 8} ${height / 4} , ${height * 3 / 8} ${height / 4} , ${height / 2} 0 M ${height} ${height / 2}
             c ${height / 8} ${-height / 4} , ${height * 3 / 8} ${-height / 4} , ${height / 2} 0`,
        id: id,
        width: width,
        height: height,
        fill: fill,
        stroke: stroke,
        strokeWidth: strokeWidth,
        strokeDasharray: strokeDasharray,
        strokeLinecap: strokeLinecap,
        shapeRendering: shapeRendering,
        background: background
    });
}





const $355c4f1a342696c9$export$f32b764d072ed1b7 = [
    "var(--ds-chart-categorical-1, #2898BD)",
    "var(--ds-chart-categorical-2, #5E4DB2)",
    "var(--ds-chart-categorical-3, #E56910)",
    "var(--ds-chart-categorical-4, #943D73)",
    "var(--ds-chart-categorical-5, #09326C)",
    "var(--ds-chart-categorical-6, #8F7EE7)",
    "var(--ds-chart-categorical-7, #50253F)",
    "var(--ds-chart-categorical-8, #A54800)"
];
const $355c4f1a342696c9$export$5d11cb9bccf8f5db = [
    {
        key: 'danger',
        value: "var(--ds-chart-danger, #F15B50)"
    },
    {
        key: 'warning',
        value: "var(--ds-chart-warning, #B38600)"
    },
    {
        key: 'success',
        value: "var(--ds-chart-success, #22A06B)"
    },
    {
        key: 'discovery',
        value: "var(--ds-chart-discovery, #8F7EE7)"
    },
    {
        key: 'information',
        value: "var(--ds-chart-information, #388BFF)"
    },
    {
        key: 'neutral',
        value: "var(--ds-chart-neutral, #8590A2)"
    }
];
const $355c4f1a342696c9$export$f29a3c9071a2ca9 = [
    "var(--ds-chart-red-bold, #2898BD)",
    "var(--ds-chart-orange-bold, #943D73)",
    "var(--ds-chart-yellow-bold, #E56910)",
    "var(--ds-chart-lime-bold, #5E4DB2)",
    "var(--ds-chart-green-bold, #09326C)",
    "var(--ds-chart-teal-bold, #09326C)",
    "var(--ds-chart-blue-bold, #8F7EE7)",
    "var(--ds-chart-purple-bold, #50253F)",
    "var(--ds-chart-magenta-bold, #A54800)",
    "var(--ds-chart-gray-bold, #A54800)",
    "var(--ds-chart-red-boldest, #2898BD)",
    "var(--ds-chart-orange-boldest, #943D73)",
    "var(--ds-chart-yellow-boldest, #E56910)",
    "var(--ds-chart-lime-boldest, #5E4DB2)",
    "var(--ds-chart-green-boldest, #09326C)",
    "var(--ds-chart-teal-boldest, #09326C)",
    "var(--ds-chart-blue-boldest, #8F7EE7)",
    "var(--ds-chart-purple-boldest, #50253F)",
    "var(--ds-chart-magenta-boldest, #A54800)",
    "var(--ds-chart-gray-boldest, #A54800)"
];
const $355c4f1a342696c9$export$1a2fb10b6c1fe2eb = [
    "var(--ds-chart-brand, #2898BD)",
    "var(--ds-chart-orange-bold, #943D73)",
    "var(--ds-chart-magenta-bold, #E56910)",
    "var(--ds-chart-lime-bold, #5E4DB2)",
    "var(--ds-chart-purple-bold, #09326C)",
    "var(--ds-chart-teal-bold, #8F7EE7)",
    "var(--ds-chart-green-bold, #50253F)",
    "var(--ds-chart-blue-boldest, #A54800)"
];
const $355c4f1a342696c9$export$3b4caf16b18628d7 = [
    /*#__PURE__*/ (0, $l998X.jsx)((0, $7e0c32794be81120$export$2e2bcd8739ae039), {
        id: "lines1",
        height: 5,
        width: 5,
        stroke: $355c4f1a342696c9$export$1a2fb10b6c1fe2eb[0],
        strokeWidth: 1,
        orientation: [
            'diagonal'
        ]
    }),
    /*#__PURE__*/ (0, $l998X.jsx)((0, $d365da9fe92387d5$export$2e2bcd8739ae039), {
        id: "circles1",
        height: 5,
        width: 5,
        radius: 1,
        stroke: $355c4f1a342696c9$export$1a2fb10b6c1fe2eb[1],
        fill: $355c4f1a342696c9$export$1a2fb10b6c1fe2eb[1]
    }),
    /*#__PURE__*/ (0, $l998X.jsx)((0, $b0e7bd0c7501bb34$export$2e2bcd8739ae039), {
        id: "hexagons1",
        height: 3,
        size: 8,
        strokeWidth: 1,
        stroke: $355c4f1a342696c9$export$1a2fb10b6c1fe2eb[2]
    }),
    /*#__PURE__*/ (0, $l998X.jsx)((0, $15d09509e153dc90$export$2e2bcd8739ae039), {
        id: "waves",
        height: 4,
        width: 4,
        stroke: $355c4f1a342696c9$export$1a2fb10b6c1fe2eb[3],
        strokeWidth: 1
    }),
    /*#__PURE__*/ (0, $l998X.jsx)((0, $7e0c32794be81120$export$2e2bcd8739ae039), {
        id: "lines2",
        height: 5,
        width: 5,
        stroke: $355c4f1a342696c9$export$1a2fb10b6c1fe2eb[0],
        strokeWidth: 1
    })
];
const $355c4f1a342696c9$export$7b0a836186aa9014 = (0, $b538f68b241b6f7b$export$c66920886885446e)($355c4f1a342696c9$export$3b4caf16b18628d7);
const $355c4f1a342696c9$export$c533e33795ec3ca2 = (_ref)=>{
    let { fillStyles: fillStyles } = _ref;
    if (!fillStyles) return {
        range: [],
        domain: []
    };
    if (fillStyles.filter((d)=>typeof d !== 'string').length > 0) return {
        domain: fillStyles.map((d)=>typeof d === 'string' ? d : d.key),
        range: fillStyles.map((d)=>typeof d === 'string' ? d : d.value)
    };
    else return {
        range: fillStyles === null || fillStyles === void 0 ? void 0 : fillStyles.map((d)=>typeof d === 'string' ? d : d.value)
    };
};
const $355c4f1a342696c9$export$14faa19a0f3bbeb2 = (0, $eytdg.element)((_ref2)=>{
    let { children: children } = _ref2;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: children
    });
});
const $355c4f1a342696c9$export$569885e57444f84a = {
    accessibleCategorical: $355c4f1a342696c9$export$f32b764d072ed1b7,
    categorical: $355c4f1a342696c9$export$1a2fb10b6c1fe2eb,
    status: $355c4f1a342696c9$export$5d11cb9bccf8f5db,
    categorical20: $355c4f1a342696c9$export$f29a3c9071a2ca9
};
module.exports["DEFAULT_ORDINAL_COLORS"] = $355c4f1a342696c9$export$1a2fb10b6c1fe2eb;
module.exports["useThemeFillStyles"] = $355c4f1a342696c9$export$c533e33795ec3ca2;
module.exports["Theme"] = $355c4f1a342696c9$export$14faa19a0f3bbeb2;

});

parcelRegister("lKyMg", function(module, exports) {
$parcel$export(module.exports, "default", () => $fd58def3ccdface2$export$2e2bcd8739ae039);
function $b91170e95bca6148$export$2e2bcd8739ae039(n) {
    return {
        all: n = n || new Map,
        on: function(t, e) {
            var i = n.get(t);
            i ? i.push(e) : n.set(t, [
                e
            ]);
        },
        off: function(t, e) {
            var i = n.get(t);
            i && (e ? i.splice(i.indexOf(e) >>> 0, 1) : n.set(t, []));
        },
        emit: function(t, e) {
            var i = n.get(t);
            i && i.slice().map(function(n) {
                n(e);
            }), (i = n.get("*")) && i.slice().map(function(n) {
                n(t, e);
            });
        }
    };
}



var $42omo = parcelRequire("42omo");


var $bqrhG = parcelRequire("bqrhG");


var $l998X = parcelRequire("l998X");

function $fd58def3ccdface2$export$2e2bcd8739ae039(_ref) {
    let { children: children } = _ref;
    const emitter = (0, $42omo.useMemo)(()=>(0, $b91170e95bca6148$export$2e2bcd8739ae039)(), []);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $bqrhG.default).Provider, {
        value: emitter,
        children: children
    });
}

});

parcelRegister("7lOgj", function(module, exports) {
$parcel$export(module.exports, "default", () => $55a17b974198e062$export$2e2bcd8739ae039);

var $ldFTj = parcelRequire("ldFTj");


var $42omo = parcelRequire("42omo");




function $86acf85e869ae480$export$2e2bcd8739ae039(/** Optional initial TooltipState. */ initialTooltipState) {
    const [tooltipState, setTooltipState] = (0, $42omo.useState)({
        tooltipOpen: false,
        ...initialTooltipState
    });
    const showTooltip = (0, $42omo.useCallback)((showArgs)=>setTooltipState(typeof showArgs === 'function' ? (_ref)=>{
            let { tooltipOpen: tooltipOpen, ...show } = _ref;
            return {
                ...showArgs(show),
                tooltipOpen: true
            };
        } : {
            tooltipOpen: true,
            tooltipLeft: showArgs.tooltipLeft,
            tooltipTop: showArgs.tooltipTop,
            tooltipData: showArgs.tooltipData
        }), [
        setTooltipState
    ]);
    const hideTooltip = (0, $42omo.useCallback)(()=>setTooltipState({
            tooltipOpen: false,
            tooltipLeft: undefined,
            tooltipTop: undefined,
            tooltipData: undefined
        }), [
        setTooltipState
    ]);
    return {
        tooltipOpen: tooltipState.tooltipOpen,
        tooltipLeft: tooltipState.tooltipLeft,
        tooltipTop: tooltipState.tooltipTop,
        tooltipData: tooltipState.tooltipData,
        updateTooltip: setTooltipState,
        showTooltip: showTooltip,
        hideTooltip: hideTooltip
    };
}



var $lWRDd = parcelRequire("lWRDd");


var $l998X = parcelRequire("l998X");

function $55a17b974198e062$var$isValidNumber(_) {
    return _ != null && typeof _ === 'number' && !Number.isNaN(_) && Number.isFinite(_);
}
function $55a17b974198e062$export$2e2bcd8739ae039(_ref) {
    let { hideTooltipDebounceMs: hideTooltipDebounceMs = 200, children: children } = _ref;
    const { tooltipOpen: tooltipOpen, tooltipLeft: tooltipLeft, tooltipTop: tooltipTop, tooltipData: tooltipData, updateTooltip: updateTooltip, hideTooltip: privateHideTooltip } = (0, $86acf85e869ae480$export$2e2bcd8739ae039)(undefined);
    const debouncedHideTooltip = (0, $42omo.useRef)(null);
    function cancelDeboundedHideTooltip() {
        if (debouncedHideTooltip.current) {
            debouncedHideTooltip.current.cancel();
            debouncedHideTooltip.current = null;
        }
    }
    (0, $42omo.useEffect)(()=>cancelDeboundedHideTooltip, []);
    const showTooltip = (0, $42omo.useRef)((_ref2)=>{
        let { svgPoint: svgPoint, index: index, datum: datum, distanceX: distanceX, distanceY: distanceY, nearestSeriesData: nearestSeriesData, event: event } = _ref2;
        // cancel any hideTooltip calls so it won't hide after invoking the logic below
        cancelDeboundedHideTooltip();
        const cleanDistanceX = $55a17b974198e062$var$isValidNumber(distanceX) ? distanceX : Infinity;
        const cleanDistanceY = $55a17b974198e062$var$isValidNumber(distanceY) ? distanceY : Infinity;
        const distance = Math.sqrt(cleanDistanceX ** 2 + cleanDistanceY ** 2);
        // Event is valid up here. Hasn't been nullified yet.
        // We can call event.persist() but storing in a variable seems more elegant.
        const tooltipLeft = event && 'clientX' in event ? event === null || event === void 0 ? void 0 : event.clientX : svgPoint === null || svgPoint === void 0 ? void 0 : svgPoint.x;
        const tooltipTop = event && 'clientY' in event ? event === null || event === void 0 ? void 0 : event.clientY : svgPoint === null || svgPoint === void 0 ? void 0 : svgPoint.y;
        updateTooltip((_ref3)=>{
            let { tooltipData: tooltipData } = _ref3;
            // const currNearestDatumDistance =
            //     currData?.nearestDatum && isValidNumber(currData.nearestDatum.distance)
            //         ? currData.nearestDatum.distance
            //         : Infinity;
            return {
                tooltipOpen: true,
                tooltipLeft: tooltipLeft,
                tooltipTop: tooltipTop,
                tooltipData: {
                    // nearestDatum:
                    //     (currData?.nearestDatum?.key ?? '') !== key &&
                    //     currNearestDatumDistance < distance
                    //         ? currData?.nearestDatum
                    //         : {key, index, datum, distance},
                    nearestDatum: {
                        index: index,
                        datum: datum,
                        distance: distance
                    },
                    nearestSeriesData: nearestSeriesData
                }
            };
        });
    });
    const hideTooltip = (0, $42omo.useCallback)(()=>{
        debouncedHideTooltip.current = (0, (/*@__PURE__*/$parcel$interopDefault($ldFTj)))(privateHideTooltip, hideTooltipDebounceMs);
        debouncedHideTooltip.current();
    }, [
        privateHideTooltip,
        hideTooltipDebounceMs
    ]);
    const value = (0, $42omo.useMemo)(()=>({
            tooltipOpen: tooltipOpen,
            tooltipLeft: tooltipLeft,
            tooltipTop: tooltipTop,
            tooltipData: tooltipData,
            updateTooltip: updateTooltip,
            showTooltip: showTooltip.current,
            hideTooltip: hideTooltip
        }), [
        hideTooltip,
        tooltipData,
        tooltipLeft,
        tooltipOpen,
        tooltipTop,
        updateTooltip
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $lWRDd.default).Provider, {
        value: value,
        children: children
    });
}

});

parcelRegister("lWRDd", function(module, exports) {
/* eslint-disable @typescript-eslint/no-explicit-any */ 
var $42omo = parcelRequire("42omo");

const $ffa89dd94fc55d5a$var$TooltipContext = /*#__PURE__*/ (0, $42omo.createContext)({});
var $ffa89dd94fc55d5a$export$2e2bcd8739ae039 = $ffa89dd94fc55d5a$var$TooltipContext;
module.exports["default"] = $ffa89dd94fc55d5a$export$2e2bcd8739ae039;

});

parcelRegister("1MtIV", function(module, exports) {
/* TooltipRow.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $gMc0m = parcelRequire("gMc0m");


var $l998X = parcelRequire("l998X");

const $14c154a3f4d394b0$var$outerDivCss = null;
const $14c154a3f4d394b0$var$innerDivCss = null;
const $14c154a3f4d394b0$var$colorItemCss = null;
const $14c154a3f4d394b0$var$labelItemCss = null;
const $14c154a3f4d394b0$var$valueItemCss = null;
function $14c154a3f4d394b0$export$4cf463b4a9fc631a(_ref) {
    let { color: color, label: label, value: value } = _ref;
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        className: (0, $gMc0m.default)([
            "_1wpz1fhb _1bah1yb4 _4cvr1h6o _1e0c116y"
        ]),
        children: /*#__PURE__*/ (0, $l998X.jsxs)("div", {
            className: (0, $gMc0m.default)([
                "_u5f3ftgi _1bah1y6m _4cvr1h6o _zulpftgi _1e0c1txw"
            ]),
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)("div", {
                    className: (0, $gMc0m.default)([
                        "_1bah1y6m _4cvr1h6o _zulpftgi _1e0c1txw"
                    ]),
                    children: /*#__PURE__*/ (0, $l998X.jsx)("svg", {
                        style: {
                            width: 12,
                            height: 12,
                            borderRadius: 2
                        },
                        children: /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                            width: "100%",
                            height: "100%",
                            fill: color
                        })
                    })
                }),
                /*#__PURE__*/ (0, $l998X.jsx)("div", {
                    className: (0, $gMc0m.default)([
                        "_ect41wi2 _syaz13nv _1wybdlk8 _k48p1nn1 _slp31hna"
                    ]),
                    children: label
                }),
                /*#__PURE__*/ (0, $l998X.jsx)("div", {
                    className: (0, $gMc0m.default)([
                        "_ect41wi2 _syaz13nv _1wybdlk8 _k48p1nn1 _vwz41q5e _slp31hna"
                    ]),
                    children: value
                })
            ]
        })
    });
}
module.exports["TooltipRow"] = $14c154a3f4d394b0$export$4cf463b4a9fc631a;

});

parcelRegister("ft3QQ", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $f8200c15aeec67ae$var$TooltipPositionContext = /*#__PURE__*/ (0, $42omo.createContext)({
    isFlippedVertically: false,
    isFlippedHorizontally: false
});
const $f8200c15aeec67ae$export$c4495e18a4fda94d = $f8200c15aeec67ae$var$TooltipPositionContext.Provider;
const $f8200c15aeec67ae$export$1449c3910e5757a2 = $f8200c15aeec67ae$var$TooltipPositionContext.Consumer;
const $f8200c15aeec67ae$export$964a3aa90a7606c2 = ()=>(0, $42omo.useContext)($f8200c15aeec67ae$var$TooltipPositionContext);





function $ecebfdd61f83cdd1$export$f40669173e732c21() {
    const width = window.innerWidth;
    const height = window.innerHeight;
    const right = width;
    const bottom = height;
    const top = 0;
    const left = 0;
    return {
        top: top,
        right: right,
        bottom: bottom,
        left: left,
        width: width,
        height: height
    };
}


const $5319b2642ccbada5$var$emptyRect = {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    width: 0,
    height: 0
};
function $5319b2642ccbada5$export$e7ea57f71fc0320c(isWindow) {
    if (isWindow === void 0) isWindow = true;
    const [rect, setRect] = (0, $42omo.useState)($5319b2642ccbada5$var$emptyRect);
    const [parentRect, setParentRect] = (0, $42omo.useState)($5319b2642ccbada5$var$emptyRect);
    const nodeRef = (0, $42omo.useRef)(null);
    (0, $42omo.useEffect)(()=>{
        const node = nodeRef.current;
        if (node) {
            const calculateRects = ()=>{
                const rect = node.getBoundingClientRect();
                const parent = node.parentNode;
                let parentRect;
                if (isWindow) parentRect = (0, $ecebfdd61f83cdd1$export$f40669173e732c21)();
                else if (parent) parentRect = parent.getBoundingClientRect();
                else parentRect = $5319b2642ccbada5$var$emptyRect;
                setRect(rect);
                setParentRect(parentRect);
            };
            calculateRects();
        }
    }, [
        nodeRef,
        setRect,
        setParentRect
    ]);
    return {
        nodeRef: nodeRef,
        rect: rect,
        parentRect: parentRect
    };
}






var $jTxSS = parcelRequire("jTxSS");


var $l998X = parcelRequire("l998X");

const $6a7835d313f4cbad$export$214b055320e0bf32 = {
    position: 'absolute',
    backgroundColor: "var(--ds-surface-overlay, white)",
    padding: '.3rem .5rem',
    borderRadius: '3px',
    fontSize: '14px',
    boxShadow: `0px 8px 12px ${"var(--ds-shadow-overflow-perimeter, grey)"}`,
    lineHeight: '1em',
    pointerEvents: 'none',
    paddingLeft: 16,
    paddingRight: 16,
    paddingTop: 12,
    paddingBottom: 12,
    overflow: 'hidden',
    border: `1px ${"var(--ds-border, grey)"} solid`,
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    gap: 4,
    zIndex: 999,
    display: 'flex'
};
const $6a7835d313f4cbad$var$Tooltip = /*#__PURE__*/ (0, $42omo.forwardRef)((_ref, ref)=>{
    let { className: className, top: top, left: left, tooltipPortalElement: tooltipPortalElement, offsetLeft: offsetLeft = 0, offsetTop: offsetTop = 0, style: style = $6a7835d313f4cbad$export$214b055320e0bf32, children: children, unstyled: unstyled = false, applyPositionStyle: applyPositionStyle = false, ...restProps } = _ref;
    const elem = /*#__PURE__*/ (0, $l998X.jsx)("div", {
        // css={css(defaultStyles)}
        ref: ref,
        className: className,
        style: {
            transform: 'translateX(0%) translateY(-100%)',
            top: top == null || offsetTop == null ? top : top + offsetTop,
            left: left == null || offsetLeft == null ? left : left + offsetLeft,
            ...applyPositionStyle && {
                position: 'absolute'
            },
            ...!unstyled && style
        },
        ...restProps,
        children: children
    });
    // Render via portal
    if (tooltipPortalElement) return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: /*#__PURE__*/ (0, $jTxSS.createPortal)(elem, tooltipPortalElement)
    });
    return elem;
});
$6a7835d313f4cbad$var$Tooltip.displayName = 'Tooltip';
var $6a7835d313f4cbad$export$2e2bcd8739ae039 = $6a7835d313f4cbad$var$Tooltip;





function $b42c8d423c6010c9$var$TooltipWithBounds(_ref) {
    let { children: children, left: initialLeft = 0, offsetLeft: offsetLeft = 2, offsetTop: offsetTop = 2, style: style = (0, $6a7835d313f4cbad$export$214b055320e0bf32), top: initialTop = 0, unstyled: unstyled = false, ...otherProps } = _ref;
    let transform;
    let placeTooltipLeft = false;
    let placeTooltipUp = true;
    const { nodeRef: nodeRef, rect: ownBounds, parentRect: parentBounds } = (0, $5319b2642ccbada5$export$e7ea57f71fc0320c)();
    if (ownBounds && parentBounds) {
        let left = initialLeft;
        let top = initialTop;
        if (parentBounds.width) {
            const rightPlacementClippedPx = left + offsetLeft + ownBounds.width - parentBounds.width;
            const leftPlacementClippedPx = ownBounds.width - left - offsetLeft;
            placeTooltipLeft = rightPlacementClippedPx > 0 && rightPlacementClippedPx > leftPlacementClippedPx;
        } else {
            const rightPlacementClippedPx = left + offsetLeft + ownBounds.width - window.innerWidth;
            const leftPlacementClippedPx = ownBounds.width - left - offsetLeft;
            placeTooltipLeft = rightPlacementClippedPx > 0 && rightPlacementClippedPx > leftPlacementClippedPx;
        }
        if (parentBounds.height) {
            const bottomPlacementClippedPx = top + offsetTop + ownBounds.height - parentBounds.height;
            const topPlacementClippedPx = ownBounds.height - top - offsetTop;
            placeTooltipUp = !(topPlacementClippedPx > 0) && bottomPlacementClippedPx < topPlacementClippedPx;
        } else placeTooltipUp = top + offsetTop + ownBounds.height > window.innerHeight;
        left = placeTooltipLeft ? left - ownBounds.width - offsetLeft : left + offsetLeft;
        top = placeTooltipUp ? top - ownBounds.height - offsetTop : top + offsetTop;
        left = Math.round(left);
        top = Math.round(top);
        transform = `translate(${left}px, ${top}px)`;
    }
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6a7835d313f4cbad$export$2e2bcd8739ae039), {
        ref: nodeRef,
        style: {
            left: 0,
            top: 0,
            transform: transform,
            ...!unstyled && style
        },
        ...otherProps,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $f8200c15aeec67ae$export$c4495e18a4fda94d), {
            value: {
                isFlippedVertically: !placeTooltipUp,
                isFlippedHorizontally: !placeTooltipLeft
            },
            children: children
        })
    });
}
var $b42c8d423c6010c9$export$2e2bcd8739ae039 = $b42c8d423c6010c9$var$TooltipWithBounds;
module.exports["default"] = $b42c8d423c6010c9$export$2e2bcd8739ae039;

});

parcelRegister("3mlav", function(module, exports) {
$parcel$export(module.exports, "default", () => $2723d8c5c4a485f2$export$2e2bcd8739ae039);

var $gNpMV = parcelRequire("gNpMV");


var $ewsGH = parcelRequire("ewsGH");

var $2723d8c5c4a485f2$export$6c7fd0f60d1828d8 = (0, $ewsGH.default)('domain', 'range', 'reverse', 'unknown');
function $2723d8c5c4a485f2$export$2e2bcd8739ae039(config) {
    return $2723d8c5c4a485f2$export$6c7fd0f60d1828d8((0, $gNpMV.default)(), config);
}

});

parcelRegister("fPEWw", function(module, exports) {
const $02f9794dd01fab07$export$69b1818e3c4e83f9 = '__XY_EVENT_SOURCE__';
module.exports["XYCHART_EVENT_SOURCE"] = $02f9794dd01fab07$export$69b1818e3c4e83f9;

});

parcelRegister("6mMqq", function(module, exports) {
$parcel$export(module.exports, "default", () => $4a2a5c65eb406790$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");


var $iWLaT = parcelRequire("iWLaT");

function $4a2a5c65eb406790$export$2e2bcd8739ae039(_ref) {
    let { source: source, onPointerOut: onPointerOut = true, onPointerMove: onPointerMove = true, onPointerUp: onPointerUp = true, onPointerDown: onPointerDown = true, onFocus: onFocus = false, onBlur: onBlur = false } = _ref;
    const emit = (0, $iWLaT.default)();
    const emitPointerMove = (0, $42omo.useCallback)((event, datum)=>emit === null || emit === void 0 ? void 0 : emit('pointermove', event, source, datum), [
        emit,
        source
    ]);
    const emitPointerOut = (0, $42omo.useCallback)((event)=>emit === null || emit === void 0 ? void 0 : emit('pointerout', event, source), [
        emit,
        source
    ]);
    const emitPointerUp = (0, $42omo.useCallback)((event)=>emit === null || emit === void 0 ? void 0 : emit('pointerup', event, source), [
        emit,
        source
    ]);
    const emitPointerDown = (0, $42omo.useCallback)((event, datum)=>emit === null || emit === void 0 ? void 0 : emit('pointerdown', event, source, datum), [
        emit,
        source
    ]);
    const emitFocus = (0, $42omo.useCallback)((event)=>emit === null || emit === void 0 ? void 0 : emit('focus', event, source), [
        emit,
        source
    ]);
    const emitBlur = (0, $42omo.useCallback)((event)=>emit === null || emit === void 0 ? void 0 : emit('blur', event, source), [
        emit,
        source
    ]);
    return {
        onPointerMove: onPointerMove ? emitPointerMove : undefined,
        onFocus: onFocus ? emitFocus : undefined,
        onBlur: onBlur ? emitBlur : undefined,
        onPointerOut: onPointerOut ? emitPointerOut : undefined,
        onPointerUp: onPointerUp ? emitPointerUp : undefined,
        onPointerDown: onPointerDown ? emitPointerDown : undefined
    };
}

});

parcelRegister("5FE3o", function(module, exports) {
$parcel$export(module.exports, "default", () => $420fd9e994a930f2$export$2e2bcd8739ae039);
/* Plot.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $gMc0m = parcelRequire("gMc0m");


var $l998X = parcelRequire("l998X");

function $420fd9e994a930f2$export$2e2bcd8739ae039(_ref) {
    let { top: top = 0, left: left = 0, width: width = '100%', height: height = '100%', transform: transform, children: children, innerRef: innerRef, ...restProps } = _ref;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: /*#__PURE__*/ (0, $l998X.jsx)("svg", {
            ref: innerRef,
            width: width,
            height: height,
            transform: transform || `translate(${left}, ${top})`,
            ...restProps,
            className: (0, $gMc0m.default)([
                "_nd5lah6b _16jlkb7n _1ul9idpf _1tkeidpf _1reoewfl _18m9ewfl _1pbyidpf"
            ]),
            children: children
        })
    });
}

});

parcelRegister("ak0BM", function(module, exports) {
$parcel$export(module.exports, "default", () => $783c3e71bfbbb992$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");

function $783c3e71bfbbb992$export$2e2bcd8739ae039(_ref) {
    let { top: top = 0, left: left = 0, transform: transform, children: children, innerRef: innerRef, ...restProps } = _ref;
    return /*#__PURE__*/ (0, $l998X.jsx)("g", {
        ref: innerRef,
        transform: transform || `translate(${left}, ${top})`,
        ...restProps,
        children: children
    });
}

});

parcelRegister("hGekP", function(module, exports) {
function $cdf17a86dcc5330f$export$227cf200245550ef(accessor) {
    if (typeof accessor === 'string') {
        function s(d) {
            try {
                return d[accessor];
            } catch  {
                return 0;
            }
        }
        return s;
    } else if (typeof accessor === 'number') {
        function s1(d) {
            try {
                return d[accessor];
            } catch  {
                return 0;
            }
        }
        return s1;
    }
    function s2(d) {
        try {
            return accessor instanceof Function ? accessor(d) : 0;
        } catch  {
            return 0;
        }
    }
    return s2;
}
function $cdf17a86dcc5330f$export$1ff31c13ab3c61e1() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return args.map((d)=>$cdf17a86dcc5330f$export$227cf200245550ef(d));
}
function $cdf17a86dcc5330f$export$3a667a3b7e4d6701(l) {
    return typeof (l === null || l === void 0 ? void 0 : l.x) === 'number' ? l === null || l === void 0 ? void 0 : l.x : 0;
}
function $cdf17a86dcc5330f$export$337238c011325465(l) {
    return typeof (l === null || l === void 0 ? void 0 : l.y) === 'number' ? l === null || l === void 0 ? void 0 : l.y : 0;
}
function $cdf17a86dcc5330f$export$dd2b6e807fb37ba3(l) {
    return l === null || l === void 0 ? void 0 : l.source;
}
function $cdf17a86dcc5330f$export$c22522a4dfa48e9c(l) {
    return l === null || l === void 0 ? void 0 : l.target;
}
function $cdf17a86dcc5330f$export$fbdeaa6a76694f71(d) {
    return d === null || d === void 0 ? void 0 : d[0];
}
function $cdf17a86dcc5330f$export$18f9732b2021233c(d) {
    return d === null || d === void 0 ? void 0 : d[1];
}
module.exports["useSafeAccessors"] = $cdf17a86dcc5330f$export$1ff31c13ab3c61e1;

});

parcelRegister("ezYGr", function(module, exports) {
const $02bd375b29cc61dc$export$6475e56bfff61883 = {
    top: 0,
    bottom: 0,
    left: 0,
    right: 0
};
const $02bd375b29cc61dc$export$601d4a48e295711b = 150;
const $02bd375b29cc61dc$export$a15d94c34ecbca08 = {
    SMALL: 2,
    MEDIUM: 5,
    LARGE: 10,
    NONE: 0
};
module.exports["DEFAULT_MARGIN"] = $02bd375b29cc61dc$export$6475e56bfff61883;

});

parcelRegister("ddut0", function(module, exports) {

let $99f41f5b84b036ac$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $99f41f5b84b036ac$var$load("7rXIX"),
    $99f41f5b84b036ac$var$load("8HE0m"),
    $99f41f5b84b036ac$var$load("6wr18"),
    $99f41f5b84b036ac$var$load("ffEVr"),
    $99f41f5b84b036ac$var$load("gd51m")
]).then(()=>parcelRequire('9HUEs'));

});

parcelRegister("4mJKd", function(module, exports) {
"use strict";


let $32dcb3648bfd454e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve(id), maxShards));
    };
module.exports = $32dcb3648bfd454e$var$load;

});

parcelRegister("8tirZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $62af5803f3d08114$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $62af5803f3d08114$var$getDomainShardIndex;
module.exports.shardUrl = $62af5803f3d08114$var$shardUrl;
module.exports.shardUrlUnchecked = $62af5803f3d08114$var$shardUrlUnchecked;
const $62af5803f3d08114$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $62af5803f3d08114$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $62af5803f3d08114$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $62af5803f3d08114$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $62af5803f3d08114$var$removeTrailingShard(subdomain) {
    if (!$62af5803f3d08114$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $62af5803f3d08114$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$62af5803f3d08114$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $62af5803f3d08114$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $62af5803f3d08114$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $62af5803f3d08114$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $62af5803f3d08114$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $62af5803f3d08114$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$62af5803f3d08114$var$globalKeyName]) return url;
    return $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards);
}
const $62af5803f3d08114$var$domainShardingKey = module.exports.domainShardingKey = $62af5803f3d08114$var$globalKeyName;

});

parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});

parcelRegister("aLnAA", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $6f0Oj = parcelRequire("6f0Oj");

var $bUlM5 = parcelRequire("bUlM5");

var $ecnYn = parcelRequire("ecnYn");

const $a068a9057ebf0299$var$overlayContainerStyles = (0, $ecnYn.xcss)({
    position: 'relative'
});
const $a068a9057ebf0299$var$overlayStyles = (0, $ecnYn.xcss)({
    position: 'absolute',
    zIndex: 'card',
    width: '100%',
    height: '100%'
});
const $a068a9057ebf0299$var$overlayInnerStyles = (0, $ecnYn.xcss)({
    width: '50%',
    textAlign: 'center'
});
const $a068a9057ebf0299$export$b47c3594eab58386 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $a068a9057ebf0299$var$overlayContainerStyles,
        testId: testId
    }, children);
const $a068a9057ebf0299$export$c6fdb837b070b4ff = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
        justifyContent: "center",
        alignItems: "center",
        xcss: $a068a9057ebf0299$var$overlayStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
        direction: "column",
        alignItems: "center",
        gap: "space.100",
        xcss: $a068a9057ebf0299$var$overlayInnerStyles
    }, children));
module.exports["OverlayContainer"] = $a068a9057ebf0299$export$b47c3594eab58386;
module.exports["Overlay"] = $a068a9057ebf0299$export$c6fdb837b070b4ff;

});

parcelRegister("1vsPO", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $febb826d5d7352ad$export$27a9d66a0067424c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "142",
        height: "92",
        viewBox: "0 0 142 92",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M138.516 49.5305H132.43L129.503 42.1551H113.014C113.273 26.9035 114.828 12.7771 117.621 0.046875H37.5868C37.3511 2.35611 37.1391 4.6948 36.9388 7.04528H13.8641L16.7919 14.4266H45.9578L48.8855 21.8079H35.9314C35.9314 21.9021 35.9196 21.9964 35.9138 22.0907L35.8018 21.8079H0.556519L3.4843 29.1892H13.87L16.7978 36.5705H35.4248C35.36 39.7516 35.3247 42.9504 35.3247 46.1845C35.3247 56.7704 35.6487 67.0206 36.2672 76.9409H22.3764L25.3042 84.3222H16.4973L19.4251 91.7035H117.42C116.048 85.3296 114.993 78.608 114.251 71.5625H101.432L98.5047 64.1812H108.743L105.815 56.7999L141.449 56.9059L138.522 49.5246L138.516 49.5305Z",
        fill: "#DDDEE1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M35.4189 36.5708H52.3965L49.4688 29.1895H35.4189V36.5708Z",
        fill: "#B7B9BE"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M37.734 91.7095H54.7116L51.7838 84.3223H37.2097L37.734 91.7095Z",
        fill: "#B7B9BE"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M112.584 49.4307H101.815L104.743 56.8179H107.441H112.584V49.4307Z",
        fill: "#B7B9BE"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M75.6361 23.1396V52.5117",
        stroke: "white",
        strokeWidth: "5.94",
        strokeMiterlimit: "10"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M77.9042 62.608C77.9336 62.4548 77.9454 62.2899 77.9454 62.119C77.9454 61.9482 77.9336 61.7774 77.9042 61.6242C77.7392 60.6993 77.0971 60.1338 76.1958 59.9865C76.0426 59.963 75.8836 59.9512 75.7127 59.9512C75.5419 59.9512 75.3711 59.9629 75.212 59.9924C74.3107 60.1397 73.6745 60.7111 73.5036 61.6301C73.4742 61.7832 73.4624 61.9482 73.4624 62.1249C73.4624 62.2958 73.4742 62.4607 73.5036 62.6139C73.6686 63.5328 74.3107 64.0984 75.212 64.2515C75.3711 64.281 75.5419 64.2928 75.7127 64.2928C75.8836 64.2928 76.0426 64.281 76.1958 64.2574C77.0971 64.1102 77.7392 63.5387 77.9042 62.6198V62.608Z",
        stroke: "white",
        strokeWidth: "7.33",
        strokeMiterlimit: "10"
    }));
module.exports["EmptyStateIcon"] = $febb826d5d7352ad$export$27a9d66a0067424c;

});

parcelRegister("1dra0", function(module, exports) {
/**
 * This is the same exact formatter that AVP uses, but we make two changes:
 * 1. We only apply the formatting if the value is greater than 1,000,000,000 rather than all values.
 * 2. We format using commas / periods depending on locale.
 * @param value the value to format
 * @param locale the locale to use for formatting
 */ const $80c64d9c9ca56405$export$abfe5ddaa9daffe8 = (value, locale)=>{
    let numberValue;
    if (typeof value === 'string') {
        const parsedValue = Number(value);
        if (isNaN(parsedValue)) return value;
        numberValue = parsedValue;
    } else numberValue = value;
    try {
        // if the value is greater than 1,000,000,000, format it to compact
        if (numberValue >= 1000000000) return new Intl.NumberFormat(locale, {
            notation: 'compact',
            compactDisplay: 'short'
        }).format(numberValue);
        else return new Intl.NumberFormat(locale).format(numberValue);
    } catch (e) {
        // if anything went wrong, just return the value as is
        return value.toString();
    }
};
module.exports["formatNumberAbbreviated"] = $80c64d9c9ca56405$export$abfe5ddaa9daffe8;

});

parcelRegister("juKGe", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");

var $8C5kA = parcelRequire("8C5kA");


var $6f0Oj = parcelRequire("6f0Oj");

var $dcJ7R = parcelRequire("dcJ7R");

var $ecnYn = parcelRequire("ecnYn");


var $ccHMk = parcelRequire("ccHMk");

const $134f1d40fab76c6c$var$i18n = (0, $cgtv4.defineMessages)({
    legendColorAriaLabel: {
        id: "confluence-analytics.metric-selector.legend-color-aria-label",
        defaultMessage: "Color legend for {metric}"
    }
});
const $134f1d40fab76c6c$var$legendSquareStyle = (0, $ecnYn.xcss)({
    width: '10px',
    height: '10px',
    marginInlineEnd: 'space.075',
    borderRadius: 'radius.xsmall'
});
const $134f1d40fab76c6c$var$LegendSquare = ({ backgroundColor: backgroundColor, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        ...props,
        xcss: $134f1d40fab76c6c$var$legendSquareStyle,
        style: {
            backgroundColor: backgroundColor
        }
    });
const $134f1d40fab76c6c$export$dfb2de216ad628a8 = ({ value: value, onChange: onChange })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const selectedMetrics = Object.keys(value).filter((key)=>value[key].enabled);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, Object.entries(value).map(([key, config])=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
            key: key,
            isSelected: config.enabled,
            isDisabled: selectedMetrics.length === 1 && selectedMetrics[0] === key,
            onClick: ()=>{
                onChange(key, {
                    ...value,
                    [key]: {
                        ...value[key],
                        enabled: !value[key].enabled
                    }
                });
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
            alignBlock: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($134f1d40fab76c6c$var$LegendSquare, {
            backgroundColor: config.color,
            "aria-label": formatMessage($134f1d40fab76c6c$var$i18n.legendColorAriaLabel, {
                metric: formatMessage(config.title)
            })
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), config.title)))));
};
module.exports["MetricSelector"] = $134f1d40fab76c6c$export$dfb2de216ad628a8;

});

parcelRegister("czlRF", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");

var $8C5kA = parcelRequire("8C5kA");


var $917iu = parcelRequire("917iu");


var $52EPl = parcelRequire("52EPl");

var $3sMdn = parcelRequire("3sMdn");

const $88f243490596614a$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    dateOptionHourly: {
        id: "confluence-analytics.period-selector.date-option-hourly",
        defaultMessage: "Hourly"
    },
    dateOptionDaily: {
        id: "confluence-analytics.period-selector.date-option-daily",
        defaultMessage: "Daily"
    },
    dateOptionWeekly: {
        id: "confluence-analytics.period-selector.date-option-weekly",
        defaultMessage: "Weekly"
    },
    dateOptionMonthly: {
        id: "confluence-analytics.period-selector.date-option-monthly",
        defaultMessage: "Monthly"
    }
});
const $88f243490596614a$export$a40b280c06fb7dd6 = ({ value: value, onChange: onChange, fromDate: fromDate, toDate: toDate, isHourlyPeriodAllowed: isHourlyPeriodAllowed = false // not allowed by default as it only works for page analytics
 })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const getPeriodTriggerTitle = (0, $42omo.useCallback)((period)=>{
        switch(period){
            case 'hour':
                return formatMessage($88f243490596614a$export$a7357cdd1f0b0168.dateOptionHourly);
            case 'day':
                return formatMessage($88f243490596614a$export$a7357cdd1f0b0168.dateOptionDaily);
            case 'week':
                return formatMessage($88f243490596614a$export$a7357cdd1f0b0168.dateOptionWeekly);
            case 'month':
                return formatMessage($88f243490596614a$export$a7357cdd1f0b0168.dateOptionMonthly);
            default:
                return formatMessage($88f243490596614a$export$a7357cdd1f0b0168.dateOptionDaily);
        }
    }, [
        formatMessage
    ]);
    const isHourPeriodDisabled = (0, $917iu.default)(toDate, fromDate) > 14;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $52EPl.default), {
        shouldRenderToParent: true,
        trigger: getPeriodTriggerTitle(value)
    }, isHourlyPeriodAllowed && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3sMdn.default), {
        id: "date-hourly",
        onClick: ()=>onChange('hour'),
        isSelected: value === 'hour',
        isDisabled: isHourPeriodDisabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $88f243490596614a$export$a7357cdd1f0b0168.dateOptionHourly)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3sMdn.default), {
        id: "date-daily",
        onClick: ()=>onChange('day'),
        isSelected: value === 'day'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $88f243490596614a$export$a7357cdd1f0b0168.dateOptionDaily)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3sMdn.default), {
        id: "date-weekly",
        onClick: ()=>onChange('week'),
        isSelected: value === 'week'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $88f243490596614a$export$a7357cdd1f0b0168.dateOptionWeekly)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3sMdn.default), {
        id: "date-monthly",
        onClick: ()=>onChange('month'),
        isSelected: value === 'month'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $88f243490596614a$export$a7357cdd1f0b0168.dateOptionMonthly)));
};
module.exports["PeriodSelector"] = $88f243490596614a$export$a40b280c06fb7dd6;

});

parcelRegister("fUbA4", function(module, exports) {
// Matches the color palette mission control uses for their charts.
// We have made the intentional choice to use these colors instead of the default palette provided by the AVP chart library.
// FROM: next/packages/admin-center/src/admin-center-core/base-components/ChartBase/ChartBase.tsx
const $8bd93bca176415a7$export$3cf19b137e802bf1 = [
    "var(--ds-chart-categorical-1, #2898BD)",
    "var(--ds-chart-categorical-2, #5E4DB2)",
    "var(--ds-chart-categorical-3, #E56910)",
    "var(--ds-chart-categorical-4, #943D73)",
    "var(--ds-chart-categorical-5, #09326C)",
    "var(--ds-chart-categorical-6, #8F7EE7)",
    "var(--ds-chart-categorical-7, #50253F)",
    "var(--ds-chart-categorical-8, #A54800)"
];
module.exports["chartColorPalette"] = $8bd93bca176415a7$export$3cf19b137e802bf1;

});

parcelRegister("lgUca", function(module, exports) {
// if all numbers are less than 5, return a default range [0, 5], otherwise return [null, null] letting the chart decide the domain
const $622942db07e81766$export$63a1f71429f5694b = (numbers)=>{
    const max = Math.max(...numbers);
    return max < 5 ? [
        0,
        5
    ] : [
        null,
        null
    ];
};
const $622942db07e81766$export$710d83c4dc02fbad = (data)=>{
    return $622942db07e81766$export$63a1f71429f5694b(data.map((d)=>d.value));
};
module.exports["yDomainForChartData"] = $622942db07e81766$export$710d83c4dc02fbad;

});

parcelRegister("lcegu", function(module, exports) {

var $917iu = parcelRequire("917iu");

var $7HtfM = parcelRequire("7HtfM");

var $lvvx5 = parcelRequire("lvvx5");


var $7MSLi = parcelRequire("7MSLi");

const $c9f54cc3e97c35bb$export$d7209033085afc = (fromDate, toDate, analyticsContainer)=>{
    if (analyticsContainer === (0, $7MSLi.AnalyticsContainer).PAGE) {
        if ((0, $917iu.default)(toDate, fromDate) <= 2) return 'hour';
    }
    if ((0, $lvvx5.default)(toDate, fromDate) <= 6) return 'day';
    if ((0, $7HtfM.default)(toDate, fromDate) <= 6) return 'week';
    return 'month';
};
const $c9f54cc3e97c35bb$export$7cb7216efe85577e = (rangeType)=>{
    if (rangeType === 'AllTime' || rangeType === '7D') return 'week';
    return 'month';
};
module.exports["getDefaultPeriodBasedOnDateRange"] = $c9f54cc3e97c35bb$export$d7209033085afc;
module.exports["getDefaultPeriodBasedOnRangeType"] = $c9f54cc3e97c35bb$export$7cb7216efe85577e;

});

parcelRegister("i3tMH", function(module, exports) {

var $917iu = parcelRequire("917iu");

var $egXhZ = parcelRequire("egXhZ");


var $b5utg = parcelRequire("b5utg");

function $ac01975ec4e3e637$export$2e2bcd8739ae039(dirtyDate) {
    (0, $b5utg.default)(1, arguments);
    var date = (0, $egXhZ.default)(dirtyDate);
    var month = date.getMonth();
    return month;
}


var $eTlxX = parcelRequire("eTlxX");

var $1mWqm = parcelRequire("1mWqm");

const $e6af0582fd55704c$export$f6d4d0550a498631 = (period, fromDate, toDate, data)=>{
    if (!data || !data.date) return false;
    const dateOfData = new Date(data.date);
    // Regardless of period, if the date falls within the requested range, it is valid
    const isDateWithinInterval = (0, $1mWqm.default)(dateOfData, {
        start: fromDate,
        end: toDate
    });
    if (isDateWithinInterval) return true;
    if (period === 'month') {
        const monthOfFromDate = (0, $ac01975ec4e3e637$export$2e2bcd8739ae039)(fromDate);
        const monthOfToDate = (0, $ac01975ec4e3e637$export$2e2bcd8739ae039)(toDate);
        const monthOfDataDate = (0, $ac01975ec4e3e637$export$2e2bcd8739ae039)(dateOfData);
        // We already checked for dates within the range, so we don't need to check that here.
        // So just check if the month of the data is the same as the month of the from or to date
        if (monthOfFromDate == monthOfDataDate || monthOfToDate == monthOfDataDate) return true;
        return false;
    } else if (period === 'week') {
        const weekOfFromDate = (0, $eTlxX.default)(fromDate);
        const weekOfToDate = (0, $eTlxX.default)(toDate);
        const weekOfDataDate = (0, $eTlxX.default)(dateOfData);
        // We already checked for dates within the range, so we don't need to check that here.
        // So just check if the week of the data is the same as the week of the from or to date
        if (weekOfFromDate == weekOfDataDate || weekOfToDate == weekOfDataDate) return true;
        return false;
    } else if (period === 'day') {
        const fromDaysDifference = (0, $917iu.default)(fromDate, dateOfData);
        const toDaysDifference = (0, $917iu.default)(toDate, dateOfData);
        // Can't be more than a day before the from date, or a day after the to date
        if (fromDaysDifference < 0 || toDaysDifference > 0) return false;
        return true;
    }
    return true;
};
const $e6af0582fd55704c$export$b899d55eaca7ec1b = (contentType)=>contentType === 'blogpost' ? 'blog' : contentType;
module.exports["_filterOutOfRangeNodesFromResponse"] = $e6af0582fd55704c$export$f6d4d0550a498631;
module.exports["_convertBlogpostToBlogParam"] = $e6af0582fd55704c$export$b899d55eaca7ec1b;

});

parcelRegister("2Xot7", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $6f0Oj = parcelRequire("6f0Oj");

var $1GzhS = parcelRequire("1GzhS");

var $5dK2X = parcelRequire("5dK2X");

var $ecnYn = parcelRequire("ecnYn");


var $9QMji = parcelRequire("9QMji");


var $33kwL = parcelRequire("33kwL");

const $bd09e3e8d3dd31d5$var$EmojiStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'hidden',
    width: '24px',
    height: '24px'
});
const $bd09e3e8d3dd31d5$export$aaf6264d06ddc4ce = ({ emojiId: emojiId, title: title, subTitle: subTitle, isLink: isLink })=>{
    const titleComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
        color: isLink ? 'color.link' : 'color.text',
        maxLines: 1
    }, title);
    const subTitleComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
        size: "small",
        maxLines: 1
    }, subTitle);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, emojiId ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9QMji.LazyEmojiComponentLoader), {
        emoji: emojiId,
        height: 24,
        context: "pageCard",
        wrapper: ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                xcss: $bd09e3e8d3dd31d5$var$EmojiStyles
            }, children)
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $33kwL.LegacyContentIcon), {
        size: "medium",
        label: ""
    }), subTitle ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), null, titleComponent, subTitleComponent) : titleComponent);
};
module.exports["ContentTitle"] = $bd09e3e8d3dd31d5$export$aaf6264d06ddc4ce;

});

parcelRegister("cHr05", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $jSnXV = parcelRequire("jSnXV");


var $gdv5Z = parcelRequire("gdv5Z");


var $4noo5 = parcelRequire("4noo5");


var $jluld = parcelRequire("jluld");


var $7yDmn = parcelRequire("7yDmn");


var $1qfLF = parcelRequire("1qfLF");


var $gm3T5 = parcelRequire("gm3T5");

const $9f05e88ef3511bb8$var$i18n = (0, $cgtv4.defineMessages)({
    analyticsSearchFieldSearchIconLabel: {
        id: "confluence-analytics.search-field.search-icon-label",
        defaultMessage: "Search by text"
    },
    analyticsSearchFieldClearIconLabel: {
        id: "confluence-analytics.search-field.clear-icon-label",
        defaultMessage: "Clear the search field"
    },
    analyticsSearchFieldAriaLabel: {
        id: "confluence-analytics.search-field.aria-label",
        defaultMessage: "Search"
    }
});
const $9f05e88ef3511bb8$export$7fc27999c9317ff9 = ({ onSearch: onSearch, isDisabled: isDisabled, isClearable: isClearable, isCompact: isCompact, appearance: appearance, placeholder: placeholder, tableName: tableName, level: level, tabName: tabName, source: source })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { fireTableSearchFilterChangedEvent: fireTableSearchFilterChangedEvent } = (0, $gm3T5.useEventUtils)();
    const [searchTerm, setSearchTerm] = (0, $42omo.useState)('');
    const debouncedSearch = (0, $42omo.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))(onSearch, 250), [
        onSearch
    ]);
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            debouncedSearch.cancel();
        };
    }, [
        debouncedSearch
    ]);
    const setNewSearchFilter = (0, $42omo.useCallback)((newValue)=>{
        const isCleared = !newValue;
        fireTableSearchFilterChangedEvent({
            isCleared: isCleared,
            tableName: tableName,
            level: level,
            tabName: tabName,
            source: source
        });
        setSearchTerm(newValue);
        debouncedSearch(newValue);
    }, [
        fireTableSearchFilterChangedEvent,
        level,
        source,
        tableName,
        tabName,
        debouncedSearch
    ]);
    const handleSearchFilterChange = (0, $42omo.useCallback)((e)=>{
        setNewSearchFilter(e.target.value);
    }, [
        setNewSearchFilter
    ]);
    const handleClearSearchFilter = (0, $42omo.useCallback)(()=>{
        setNewSearchFilter('');
    }, [
        setNewSearchFilter
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4noo5.default), {
        "aria-label": formatMessage($9f05e88ef3511bb8$var$i18n.analyticsSearchFieldAriaLabel),
        isCompact: isCompact,
        appearance: appearance,
        isDisabled: isDisabled,
        placeholder: placeholder,
        value: searchTerm,
        onChange: handleSearchFilterChange,
        elemBeforeInput: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            paddingInlineStart: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jluld))), {
            label: formatMessage($9f05e88ef3511bb8$var$i18n.analyticsSearchFieldSearchIconLabel)
        })),
        elemAfterInput: isClearable && Boolean(searchTerm) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            paddingInlineEnd: "space.050"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
            spacing: "compact",
            appearance: "subtle",
            label: formatMessage($9f05e88ef3511bb8$var$i18n.analyticsSearchFieldClearIconLabel),
            icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7yDmn))), iconProps),
            onClick: handleClearSearchFilter
        })) : undefined
    });
};
module.exports["AnalyticsSearchField"] = $9f05e88ef3511bb8$export$7fc27999c9317ff9;

});

parcelRegister("9w7Hi", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");

var $8C5kA = parcelRequire("8C5kA");


var $6R5uz = parcelRequire("6R5uz");


var $laHi9 = parcelRequire("laHi9");


var $u9agA = parcelRequire("u9agA");


var $ccHMk = parcelRequire("ccHMk");

const $c94e1dc5f31694a2$var$i18n = (0, $cgtv4.defineMessages)({
    previousButtonLabel: {
        id: "confluence-analytics.analytics-table.pagination-previous-button-label",
        defaultMessage: "Previous"
    },
    nextButtonLabel: {
        id: "confluence-analytics.analytics-table.pagination-next-button-label",
        defaultMessage: "Next"
    },
    pageResultsCountLabel: {
        id: "confluence-analytics.analytics-table.pagination-page-results-count-label",
        defaultMessage: "{start} - {end} of all results"
    },
    pageResultsCountWithTotalLabel: {
        id: "confluence-analytics.analytics-table.pagination-page-results-count-with-total-label",
        defaultMessage: "{start} - {end} of {total, plural, one {# result} other {# results}}"
    }
});
const $c94e1dc5f31694a2$export$a013e211c981920f = ({ paginationState: paginationState, onPageChange: onPageChange })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { offset: offset, limit: limit, total: total, hasPrev: hasPrev, hasNext: hasNext } = paginationState;
    let nextOffset = offset + limit;
    if (total && nextOffset > total) nextOffset = total;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        alignBlock: "center",
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        spacing: "compact",
        iconBefore: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($laHi9))), {
                ...iconProps,
                size: "small"
            }),
        isDisabled: !Boolean(hasPrev),
        "aria-label": formatMessage($c94e1dc5f31694a2$var$i18n.previousButtonLabel),
        onClick: ()=>{
            onPageChange({
                ...paginationState,
                offset: offset - limit
            });
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $c94e1dc5f31694a2$var$i18n.previousButtonLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        spacing: "compact",
        iconAfter: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6R5uz))), {
                ...iconProps,
                size: "small"
            }),
        isDisabled: !Boolean(hasNext),
        "aria-label": formatMessage($c94e1dc5f31694a2$var$i18n.nextButtonLabel),
        onClick: ()=>{
            onPageChange({
                ...paginationState,
                offset: nextOffset
            });
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $c94e1dc5f31694a2$var$i18n.nextButtonLabel)), total ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        ...$c94e1dc5f31694a2$var$i18n.pageResultsCountWithTotalLabel,
        values: {
            start: offset,
            end: nextOffset,
            total: total
        }
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        ...$c94e1dc5f31694a2$var$i18n.pageResultsCountLabel,
        values: {
            start: offset,
            end: nextOffset
        }
    }));
};
var $c94e1dc5f31694a2$export$ead5563d594dd893 = /*#__PURE__*/ function(PageChangeDirection) {
    PageChangeDirection[PageChangeDirection["PREV"] = 0] = "PREV";
    PageChangeDirection[PageChangeDirection["NEXT"] = 1] = "NEXT";
    return PageChangeDirection;
}({});
const $c94e1dc5f31694a2$export$d01ff3be460a01a8 = ({ hasPrev: hasPrev, hasNext: hasNext, pageStart: pageStart, pageEnd: pageEnd, onPageChange: onPageChange })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        alignBlock: "center",
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        spacing: "compact",
        iconBefore: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($laHi9))), {
                ...iconProps,
                size: "small"
            }),
        isDisabled: !hasPrev,
        "aria-label": formatMessage($c94e1dc5f31694a2$var$i18n.previousButtonLabel),
        onClick: ()=>onPageChange(0)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $c94e1dc5f31694a2$var$i18n.previousButtonLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        spacing: "compact",
        iconAfter: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6R5uz))), {
                ...iconProps,
                size: "small"
            }),
        isDisabled: !hasNext,
        "aria-label": formatMessage($c94e1dc5f31694a2$var$i18n.nextButtonLabel),
        onClick: ()=>onPageChange(1)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $c94e1dc5f31694a2$var$i18n.nextButtonLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        ...$c94e1dc5f31694a2$var$i18n.pageResultsCountLabel,
        values: {
            start: pageStart,
            end: pageEnd
        }
    }));
};
module.exports["AnalyticsTableOffsetPagination"] = $c94e1dc5f31694a2$export$a013e211c981920f;
module.exports["PageChangeDirection"] = $c94e1dc5f31694a2$export$ead5563d594dd893;
module.exports["AnalyticsTablePagination"] = $c94e1dc5f31694a2$export$d01ff3be460a01a8;

});

parcelRegister("fivq6", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fpGTa = parcelRequire("fpGTa");

var $ecnYn = parcelRequire("ecnYn");

const $75c115811e8344d6$var$LinkStyle = (0, $ecnYn.xcss)({
    ':focus-visible': {
        outlineStyle: 'auto'
    }
});
const $75c115811e8344d6$export$6875e26484920510 = ({ children: children, href: href, target: target = '_top', onClick: onClick })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fpGTa.default), {
        href: href,
        target: target,
        xcss: $75c115811e8344d6$var$LinkStyle,
        onClick: onClick
    }, children);
};
module.exports["TableCellDataLink"] = $75c115811e8344d6$export$6875e26484920510;

});

parcelRegister("cplqD", function(module, exports) {

var $c24fw = parcelRequire("c24fw");


});

parcelRegister("4dZMr", function(module, exports) {
$parcel$export(module.exports, "interrupt", () => (parcelRequire("5Dd1S")).default);

var $kWPfg = parcelRequire("kWPfg");


var $5Dd1S = parcelRequire("5Dd1S");

function $2677905bc5b4f3c3$export$2e2bcd8739ae039(name) {
    return this.each(function() {
        (0, $5Dd1S.default)(this, name);
    });
}






var $7YDEy = parcelRequire("7YDEy");

var $142c0af5fb4f7065$var$degrees = 180 / Math.PI;
var $142c0af5fb4f7065$export$f0954fd7d5368655 = {
    translateX: 0,
    translateY: 0,
    rotate: 0,
    skewX: 0,
    scaleX: 1,
    scaleY: 1
};
function $142c0af5fb4f7065$export$2e2bcd8739ae039(a, b, c, d, e, f) {
    var scaleX, scaleY, skewX;
    if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
    if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
    if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
    if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
    return {
        translateX: e,
        translateY: f,
        rotate: Math.atan2(b, a) * $142c0af5fb4f7065$var$degrees,
        skewX: Math.atan(skewX) * $142c0af5fb4f7065$var$degrees,
        scaleX: scaleX,
        scaleY: scaleY
    };
}


var $149a75684d44eeb6$var$svgNode;
function $149a75684d44eeb6$export$59ad369bf4938177(value) {
    const m = new (typeof DOMMatrix === "function" ? DOMMatrix : WebKitCSSMatrix)(value + "");
    return m.isIdentity ? (0, $142c0af5fb4f7065$export$f0954fd7d5368655) : (0, $142c0af5fb4f7065$export$2e2bcd8739ae039)(m.a, m.b, m.c, m.d, m.e, m.f);
}
function $149a75684d44eeb6$export$f9ef43f9a1d89a18(value) {
    if (value == null) return 0, $142c0af5fb4f7065$export$f0954fd7d5368655;
    if (!$149a75684d44eeb6$var$svgNode) $149a75684d44eeb6$var$svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
    $149a75684d44eeb6$var$svgNode.setAttribute("transform", value);
    if (!(value = $149a75684d44eeb6$var$svgNode.transform.baseVal.consolidate())) return 0, $142c0af5fb4f7065$export$f0954fd7d5368655;
    value = value.matrix;
    return (0, $142c0af5fb4f7065$export$2e2bcd8739ae039)(value.a, value.b, value.c, value.d, value.e, value.f);
}


function $f5a7a6b89b885d3c$var$interpolateTransform(parse, pxComma, pxParen, degParen) {
    function pop(s) {
        return s.length ? s.pop() + " " : "";
    }
    function translate(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push("translate(", null, pxComma, null, pxParen);
            q.push({
                i: i - 4,
                x: (0, $7YDEy.default)(xa, xb)
            }, {
                i: i - 2,
                x: (0, $7YDEy.default)(ya, yb)
            });
        } else if (xb || yb) s.push("translate(" + xb + pxComma + yb + pxParen);
    }
    function rotate(a, b, s, q) {
        if (a !== b) {
            if (a - b > 180) b += 360;
            else if (b - a > 180) a += 360; // shortest path
            q.push({
                i: s.push(pop(s) + "rotate(", null, degParen) - 2,
                x: (0, $7YDEy.default)(a, b)
            });
        } else if (b) s.push(pop(s) + "rotate(" + b + degParen);
    }
    function skewX(a, b, s, q) {
        if (a !== b) q.push({
            i: s.push(pop(s) + "skewX(", null, degParen) - 2,
            x: (0, $7YDEy.default)(a, b)
        });
        else if (b) s.push(pop(s) + "skewX(" + b + degParen);
    }
    function scale(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push(pop(s) + "scale(", null, ",", null, ")");
            q.push({
                i: i - 4,
                x: (0, $7YDEy.default)(xa, xb)
            }, {
                i: i - 2,
                x: (0, $7YDEy.default)(ya, yb)
            });
        } else if (xb !== 1 || yb !== 1) s.push(pop(s) + "scale(" + xb + "," + yb + ")");
    }
    return function(a, b) {
        var s = [], q = []; // number interpolators
        a = parse(a), b = parse(b);
        translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
        rotate(a.rotate, b.rotate, s, q);
        skewX(a.skewX, b.skewX, s, q);
        scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
        a = b = null; // gc
        return function(t) {
            var i = -1, n = q.length, o;
            while(++i < n)s[(o = q[i]).i] = o.x(t);
            return s.join("");
        };
    };
}
var $f5a7a6b89b885d3c$export$56bec7123bb3589a = $f5a7a6b89b885d3c$var$interpolateTransform((0, $149a75684d44eeb6$export$59ad369bf4938177), "px, ", "px)", "deg)");
var $f5a7a6b89b885d3c$export$da8cba906d64c082 = $f5a7a6b89b885d3c$var$interpolateTransform((0, $149a75684d44eeb6$export$f9ef43f9a1d89a18), ", ", ")", ")");



var $1IOzU = parcelRequire("1IOzU");


var $ibDxT = parcelRequire("ibDxT");

function $b2afff1221e75f3e$var$tweenRemove(id, name) {
    var tween0, tween1;
    return function() {
        var schedule = (0, $ibDxT.set)(this, id), tween = schedule.tween;
        // If this node shared tween with the previous node,
        // just assign the updated shared tween and we’re done!
        // Otherwise, copy-on-write.
        if (tween !== tween0) {
            tween1 = tween0 = tween;
            for(var i = 0, n = tween1.length; i < n; ++i)if (tween1[i].name === name) {
                tween1 = tween1.slice();
                tween1.splice(i, 1);
                break;
            }
        }
        schedule.tween = tween1;
    };
}
function $b2afff1221e75f3e$var$tweenFunction(id, name, value) {
    var tween0, tween1;
    if (typeof value !== "function") throw new Error;
    return function() {
        var schedule = (0, $ibDxT.set)(this, id), tween = schedule.tween;
        // If this node shared tween with the previous node,
        // just assign the updated shared tween and we’re done!
        // Otherwise, copy-on-write.
        if (tween !== tween0) {
            tween1 = (tween0 = tween).slice();
            for(var t = {
                name: name,
                value: value
            }, i = 0, n = tween1.length; i < n; ++i)if (tween1[i].name === name) {
                tween1[i] = t;
                break;
            }
            if (i === n) tween1.push(t);
        }
        schedule.tween = tween1;
    };
}
function $b2afff1221e75f3e$export$2e2bcd8739ae039(name, value) {
    var id = this._id;
    name += "";
    if (arguments.length < 2) {
        var tween = (0, $ibDxT.get)(this.node(), id).tween;
        for(var i = 0, n = tween.length, t; i < n; ++i){
            if ((t = tween[i]).name === name) return t.value;
        }
        return null;
    }
    return this.each((value == null ? $b2afff1221e75f3e$var$tweenRemove : $b2afff1221e75f3e$var$tweenFunction)(id, name, value));
}
function $b2afff1221e75f3e$export$f78ce6ab10405d82(transition, name, value) {
    var id = transition._id;
    transition.each(function() {
        var schedule = (0, $ibDxT.set)(this, id);
        (schedule.value || (schedule.value = {}))[name] = value.apply(this, arguments);
    });
    return function(node) {
        return (0, $ibDxT.get)(node, id).value[name];
    };
}



var $bHK4A = parcelRequire("bHK4A");




var $fdjUQ = parcelRequire("fdjUQ");

var $cBevb = parcelRequire("cBevb");

function $fdc1067e6cdece6b$export$2e2bcd8739ae039(a, b) {
    var c;
    return (typeof b === "number" ? (0, $7YDEy.default) : b instanceof (0, $bHK4A.default) ? (0, $fdjUQ.default) : (c = (0, $bHK4A.default)(b)) ? (b = c, $fdjUQ.default) : (0, $cBevb.default))(a, b);
}


function $1af3a9d47391a20b$var$attrRemove(name) {
    return function() {
        this.removeAttribute(name);
    };
}
function $1af3a9d47391a20b$var$attrRemoveNS(fullname) {
    return function() {
        this.removeAttributeNS(fullname.space, fullname.local);
    };
}
function $1af3a9d47391a20b$var$attrConstant(name, interpolate, value1) {
    var string00, string1 = value1 + "", interpolate0;
    return function() {
        var string0 = this.getAttribute(name);
        return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate(string00 = string0, value1);
    };
}
function $1af3a9d47391a20b$var$attrConstantNS(fullname, interpolate, value1) {
    var string00, string1 = value1 + "", interpolate0;
    return function() {
        var string0 = this.getAttributeNS(fullname.space, fullname.local);
        return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate(string00 = string0, value1);
    };
}
function $1af3a9d47391a20b$var$attrFunction(name, interpolate, value) {
    var string00, string10, interpolate0;
    return function() {
        var string0, value1 = value(this), string1;
        if (value1 == null) return void this.removeAttribute(name);
        string0 = this.getAttribute(name);
        string1 = value1 + "";
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
    };
}
function $1af3a9d47391a20b$var$attrFunctionNS(fullname, interpolate, value) {
    var string00, string10, interpolate0;
    return function() {
        var string0, value1 = value(this), string1;
        if (value1 == null) return void this.removeAttributeNS(fullname.space, fullname.local);
        string0 = this.getAttributeNS(fullname.space, fullname.local);
        string1 = value1 + "";
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
    };
}
function $1af3a9d47391a20b$export$2e2bcd8739ae039(name, value) {
    var fullname = (0, $1IOzU.default)(name), i = fullname === "transform" ? (0, $f5a7a6b89b885d3c$export$da8cba906d64c082) : (0, $fdc1067e6cdece6b$export$2e2bcd8739ae039);
    return this.attrTween(name, typeof value === "function" ? (fullname.local ? $1af3a9d47391a20b$var$attrFunctionNS : $1af3a9d47391a20b$var$attrFunction)(fullname, i, (0, $b2afff1221e75f3e$export$f78ce6ab10405d82)(this, "attr." + name, value)) : value == null ? (fullname.local ? $1af3a9d47391a20b$var$attrRemoveNS : $1af3a9d47391a20b$var$attrRemove)(fullname) : (fullname.local ? $1af3a9d47391a20b$var$attrConstantNS : $1af3a9d47391a20b$var$attrConstant)(fullname, i, value));
}





function $c641fb44b3cad04b$var$attrInterpolate(name, i) {
    return function(t) {
        this.setAttribute(name, i.call(this, t));
    };
}
function $c641fb44b3cad04b$var$attrInterpolateNS(fullname, i) {
    return function(t) {
        this.setAttributeNS(fullname.space, fullname.local, i.call(this, t));
    };
}
function $c641fb44b3cad04b$var$attrTweenNS(fullname, value) {
    var t0, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t0 = (i0 = i) && $c641fb44b3cad04b$var$attrInterpolateNS(fullname, i);
        return t0;
    }
    tween._value = value;
    return tween;
}
function $c641fb44b3cad04b$var$attrTween(name, value) {
    var t0, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t0 = (i0 = i) && $c641fb44b3cad04b$var$attrInterpolate(name, i);
        return t0;
    }
    tween._value = value;
    return tween;
}
function $c641fb44b3cad04b$export$2e2bcd8739ae039(name, value) {
    var key = "attr." + name;
    if (arguments.length < 2) return (key = this.tween(key)) && key._value;
    if (value == null) return this.tween(key, null);
    if (typeof value !== "function") throw new Error;
    var fullname = (0, $1IOzU.default)(name);
    return this.tween(key, (fullname.local ? $c641fb44b3cad04b$var$attrTweenNS : $c641fb44b3cad04b$var$attrTween)(fullname, value));
}





function $cc91e7c791fc3e4d$var$delayFunction(id, value) {
    return function() {
        (0, $ibDxT.init)(this, id).delay = +value.apply(this, arguments);
    };
}
function $cc91e7c791fc3e4d$var$delayConstant(id, value) {
    return value = +value, function() {
        (0, $ibDxT.init)(this, id).delay = value;
    };
}
function $cc91e7c791fc3e4d$export$2e2bcd8739ae039(value) {
    var id = this._id;
    return arguments.length ? this.each((typeof value === "function" ? $cc91e7c791fc3e4d$var$delayFunction : $cc91e7c791fc3e4d$var$delayConstant)(id, value)) : (0, $ibDxT.get)(this.node(), id).delay;
}





function $5c6b3d157b614c68$var$durationFunction(id, value) {
    return function() {
        (0, $ibDxT.set)(this, id).duration = +value.apply(this, arguments);
    };
}
function $5c6b3d157b614c68$var$durationConstant(id, value) {
    return value = +value, function() {
        (0, $ibDxT.set)(this, id).duration = value;
    };
}
function $5c6b3d157b614c68$export$2e2bcd8739ae039(value) {
    var id = this._id;
    return arguments.length ? this.each((typeof value === "function" ? $5c6b3d157b614c68$var$durationFunction : $5c6b3d157b614c68$var$durationConstant)(id, value)) : (0, $ibDxT.get)(this.node(), id).duration;
}





function $ec2335e0d596229a$var$easeConstant(id, value) {
    if (typeof value !== "function") throw new Error;
    return function() {
        (0, $ibDxT.set)(this, id).ease = value;
    };
}
function $ec2335e0d596229a$export$2e2bcd8739ae039(value) {
    var id = this._id;
    return arguments.length ? this.each($ec2335e0d596229a$var$easeConstant(id, value)) : (0, $ibDxT.get)(this.node(), id).ease;
}





function $a95491d6e4fb0554$var$easeVarying(id, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (typeof v !== "function") throw new Error;
        (0, $ibDxT.set)(this, id).ease = v;
    };
}
function $a95491d6e4fb0554$export$2e2bcd8739ae039(value) {
    if (typeof value !== "function") throw new Error;
    return this.each($a95491d6e4fb0554$var$easeVarying(this._id, value));
}



var $9B7Qm = parcelRequire("9B7Qm");


function $04f419bd9488a88f$export$2e2bcd8739ae039(match) {
    if (typeof match !== "function") match = (0, $9B7Qm.default)(match);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i)if ((node = group[i]) && match.call(node, node.__data__, i, group)) subgroup.push(node);
    }
    return new (0, $b8670e3a5a0947d0$export$be58926105124dd4)(subgroups, this._parents, this._name, this._id);
}



function $29177d0a42050c54$export$2e2bcd8739ae039(transition) {
    if (transition._id !== this._id) throw new Error;
    for(var groups0 = this._groups, groups1 = transition._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j){
        for(var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group0[i] || group1[i]) merge[i] = node;
    }
    for(; j < m0; ++j)merges[j] = groups0[j];
    return new (0, $b8670e3a5a0947d0$export$be58926105124dd4)(merges, this._parents, this._name, this._id);
}





function $21f7ad351ef67b15$var$start(name) {
    return (name + "").trim().split(/^|\s+/).every(function(t) {
        var i = t.indexOf(".");
        if (i >= 0) t = t.slice(0, i);
        return !t || t === "start";
    });
}
function $21f7ad351ef67b15$var$onFunction(id, name, listener) {
    var on0, on1, sit = $21f7ad351ef67b15$var$start(name) ? (0, $ibDxT.init) : (0, $ibDxT.set);
    return function() {
        var schedule = sit(this, id), on = schedule.on;
        // If this node shared a dispatch with the previous node,
        // just assign the updated shared dispatch and we’re done!
        // Otherwise, copy-on-write.
        if (on !== on0) (on1 = (on0 = on).copy()).on(name, listener);
        schedule.on = on1;
    };
}
function $21f7ad351ef67b15$export$2e2bcd8739ae039(name, listener) {
    var id = this._id;
    return arguments.length < 2 ? (0, $ibDxT.get)(this.node(), id).on.on(name) : this.each($21f7ad351ef67b15$var$onFunction(id, name, listener));
}


function $4aa89e6a5b47a52d$var$removeFunction(id) {
    return function() {
        var parent = this.parentNode;
        for(var i in this.__transition)if (+i !== id) return;
        if (parent) parent.removeChild(this);
    };
}
function $4aa89e6a5b47a52d$export$2e2bcd8739ae039() {
    return this.on("end.remove", $4aa89e6a5b47a52d$var$removeFunction(this._id));
}



var $4PaSL = parcelRequire("4PaSL");





function $d4becf059e52de35$export$2e2bcd8739ae039(select) {
    var name = this._name, id = this._id;
    if (typeof select !== "function") select = (0, $4PaSL.default)(select);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i)if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
            if ("__data__" in node) subnode.__data__ = node.__data__;
            subgroup[i] = subnode;
            (0, $ibDxT.default)(subgroup[i], name, id, i, subgroup, (0, $ibDxT.get)(node, id));
        }
    }
    return new (0, $b8670e3a5a0947d0$export$be58926105124dd4)(subgroups, this._parents, name, id);
}



var $g3K2y = parcelRequire("g3K2y");





function $fe2db18cc5a8617c$export$2e2bcd8739ae039(select) {
    var name = this._name, id = this._id;
    if (typeof select !== "function") select = (0, $g3K2y.default)(select);
    for(var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) {
            for(var children = select.call(node, node.__data__, i, group), child, inherit = (0, $ibDxT.get)(node, id), k = 0, l = children.length; k < l; ++k)if (child = children[k]) (0, $ibDxT.default)(child, name, id, k, children, inherit);
            subgroups.push(children);
            parents.push(node);
        }
    }
    return new (0, $b8670e3a5a0947d0$export$be58926105124dd4)(subgroups, parents, name, id);
}





var $db914292efaa52ea$var$Selection = (0, $kWPfg.default).prototype.constructor;
function $db914292efaa52ea$export$2e2bcd8739ae039() {
    return new $db914292efaa52ea$var$Selection(this._groups, this._parents);
}




var $fzcnR = parcelRequire("fzcnR");






function $2465c66db1f4a198$var$styleNull(name, interpolate) {
    var string00, string10, interpolate0;
    return function() {
        var string0 = (0, $fzcnR.styleValue)(this, name), string1 = (this.style.removeProperty(name), (0, $fzcnR.styleValue)(this, name));
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : interpolate0 = interpolate(string00 = string0, string10 = string1);
    };
}
function $2465c66db1f4a198$var$styleRemove(name) {
    return function() {
        this.style.removeProperty(name);
    };
}
function $2465c66db1f4a198$var$styleConstant(name, interpolate, value1) {
    var string00, string1 = value1 + "", interpolate0;
    return function() {
        var string0 = (0, $fzcnR.styleValue)(this, name);
        return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate(string00 = string0, value1);
    };
}
function $2465c66db1f4a198$var$styleFunction(name, interpolate, value) {
    var string00, string10, interpolate0;
    return function() {
        var string0 = (0, $fzcnR.styleValue)(this, name), value1 = value(this), string1 = value1 + "";
        if (value1 == null) string1 = value1 = (this.style.removeProperty(name), (0, $fzcnR.styleValue)(this, name));
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
    };
}
function $2465c66db1f4a198$var$styleMaybeRemove(id, name) {
    var on0, on1, listener0, key = "style." + name, event = "end." + key, remove;
    return function() {
        var schedule = (0, $ibDxT.set)(this, id), on = schedule.on, listener = schedule.value[key] == null ? remove || (remove = $2465c66db1f4a198$var$styleRemove(name)) : undefined;
        // If this node shared a dispatch with the previous node,
        // just assign the updated shared dispatch and we’re done!
        // Otherwise, copy-on-write.
        if (on !== on0 || listener0 !== listener) (on1 = (on0 = on).copy()).on(event, listener0 = listener);
        schedule.on = on1;
    };
}
function $2465c66db1f4a198$export$2e2bcd8739ae039(name, value, priority) {
    var i = (name += "") === "transform" ? (0, $f5a7a6b89b885d3c$export$56bec7123bb3589a) : (0, $fdc1067e6cdece6b$export$2e2bcd8739ae039);
    return value == null ? this.styleTween(name, $2465c66db1f4a198$var$styleNull(name, i)).on("end.style." + name, $2465c66db1f4a198$var$styleRemove(name)) : typeof value === "function" ? this.styleTween(name, $2465c66db1f4a198$var$styleFunction(name, i, (0, $b2afff1221e75f3e$export$f78ce6ab10405d82)(this, "style." + name, value))).each($2465c66db1f4a198$var$styleMaybeRemove(this._id, name)) : this.styleTween(name, $2465c66db1f4a198$var$styleConstant(name, i, value), priority).on("end.style." + name, null);
}


function $0dae2e7f5559f3e2$var$styleInterpolate(name, i, priority) {
    return function(t) {
        this.style.setProperty(name, i.call(this, t), priority);
    };
}
function $0dae2e7f5559f3e2$var$styleTween(name, value, priority) {
    var t, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t = (i0 = i) && $0dae2e7f5559f3e2$var$styleInterpolate(name, i, priority);
        return t;
    }
    tween._value = value;
    return tween;
}
function $0dae2e7f5559f3e2$export$2e2bcd8739ae039(name, value, priority) {
    var key = "style." + (name += "");
    if (arguments.length < 2) return (key = this.tween(key)) && key._value;
    if (value == null) return this.tween(key, null);
    if (typeof value !== "function") throw new Error;
    return this.tween(key, $0dae2e7f5559f3e2$var$styleTween(name, value, priority == null ? "" : priority));
}



function $7184cc7e361bb4db$var$textConstant(value) {
    return function() {
        this.textContent = value;
    };
}
function $7184cc7e361bb4db$var$textFunction(value) {
    return function() {
        var value1 = value(this);
        this.textContent = value1 == null ? "" : value1;
    };
}
function $7184cc7e361bb4db$export$2e2bcd8739ae039(value) {
    return this.tween("text", typeof value === "function" ? $7184cc7e361bb4db$var$textFunction((0, $b2afff1221e75f3e$export$f78ce6ab10405d82)(this, "text", value)) : $7184cc7e361bb4db$var$textConstant(value == null ? "" : value + ""));
}


function $e1722adaa819c584$var$textInterpolate(i) {
    return function(t) {
        this.textContent = i.call(this, t);
    };
}
function $e1722adaa819c584$var$textTween(value) {
    var t0, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t0 = (i0 = i) && $e1722adaa819c584$var$textInterpolate(i);
        return t0;
    }
    tween._value = value;
    return tween;
}
function $e1722adaa819c584$export$2e2bcd8739ae039(value) {
    var key = "text";
    if (arguments.length < 1) return (key = this.tween(key)) && key._value;
    if (value == null) return this.tween(key, null);
    if (typeof value !== "function") throw new Error;
    return this.tween(key, $e1722adaa819c584$var$textTween(value));
}






function $d1b0404e33c4b799$export$2e2bcd8739ae039() {
    var name = this._name, id0 = this._id, id1 = (0, $b8670e3a5a0947d0$export$9ffd10a3fbdc175b)();
    for(var groups = this._groups, m = groups.length, j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) {
            var inherit = (0, $ibDxT.get)(node, id0);
            (0, $ibDxT.default)(node, name, id1, i, group, {
                time: inherit.time + inherit.delay + inherit.duration,
                delay: 0,
                duration: inherit.duration,
                ease: inherit.ease
            });
        }
    }
    return new (0, $b8670e3a5a0947d0$export$be58926105124dd4)(groups, this._parents, name, id1);
}






function $9b7260bb5a578278$export$2e2bcd8739ae039() {
    var on0, on1, that = this, id = that._id, size = that.size();
    return new Promise(function(resolve, reject) {
        var cancel = {
            value: reject
        }, end = {
            value: function() {
                if (--size === 0) resolve();
            }
        };
        that.each(function() {
            var schedule = (0, $ibDxT.set)(this, id), on = schedule.on;
            // If this node shared a dispatch with the previous node,
            // just assign the updated shared dispatch and we’re done!
            // Otherwise, copy-on-write.
            if (on !== on0) {
                on1 = (on0 = on).copy();
                on1._.cancel.push(cancel);
                on1._.interrupt.push(cancel);
                on1._.end.push(end);
            }
            schedule.on = on1;
        });
        // The selection was empty, resolve end immediately
        if (size === 0) resolve();
    });
}


var $b8670e3a5a0947d0$var$id = 0;
function $b8670e3a5a0947d0$export$be58926105124dd4(groups, parents, name, id) {
    this._groups = groups;
    this._parents = parents;
    this._name = name;
    this._id = id;
}
function $b8670e3a5a0947d0$export$2e2bcd8739ae039(name) {
    return (0, $kWPfg.default)().transition(name);
}
function $b8670e3a5a0947d0$export$9ffd10a3fbdc175b() {
    return ++$b8670e3a5a0947d0$var$id;
}
var $b8670e3a5a0947d0$var$selection_prototype = (0, $kWPfg.default).prototype;
$b8670e3a5a0947d0$export$be58926105124dd4.prototype = $b8670e3a5a0947d0$export$2e2bcd8739ae039.prototype = {
    constructor: $b8670e3a5a0947d0$export$be58926105124dd4,
    select: (0, $d4becf059e52de35$export$2e2bcd8739ae039),
    selectAll: (0, $fe2db18cc5a8617c$export$2e2bcd8739ae039),
    selectChild: $b8670e3a5a0947d0$var$selection_prototype.selectChild,
    selectChildren: $b8670e3a5a0947d0$var$selection_prototype.selectChildren,
    filter: (0, $04f419bd9488a88f$export$2e2bcd8739ae039),
    merge: (0, $29177d0a42050c54$export$2e2bcd8739ae039),
    selection: (0, $db914292efaa52ea$export$2e2bcd8739ae039),
    transition: (0, $d1b0404e33c4b799$export$2e2bcd8739ae039),
    call: $b8670e3a5a0947d0$var$selection_prototype.call,
    nodes: $b8670e3a5a0947d0$var$selection_prototype.nodes,
    node: $b8670e3a5a0947d0$var$selection_prototype.node,
    size: $b8670e3a5a0947d0$var$selection_prototype.size,
    empty: $b8670e3a5a0947d0$var$selection_prototype.empty,
    each: $b8670e3a5a0947d0$var$selection_prototype.each,
    on: (0, $21f7ad351ef67b15$export$2e2bcd8739ae039),
    attr: (0, $1af3a9d47391a20b$export$2e2bcd8739ae039),
    attrTween: (0, $c641fb44b3cad04b$export$2e2bcd8739ae039),
    style: (0, $2465c66db1f4a198$export$2e2bcd8739ae039),
    styleTween: (0, $0dae2e7f5559f3e2$export$2e2bcd8739ae039),
    text: (0, $7184cc7e361bb4db$export$2e2bcd8739ae039),
    textTween: (0, $e1722adaa819c584$export$2e2bcd8739ae039),
    remove: (0, $4aa89e6a5b47a52d$export$2e2bcd8739ae039),
    tween: (0, $b2afff1221e75f3e$export$2e2bcd8739ae039),
    delay: (0, $cc91e7c791fc3e4d$export$2e2bcd8739ae039),
    duration: (0, $5c6b3d157b614c68$export$2e2bcd8739ae039),
    ease: (0, $ec2335e0d596229a$export$2e2bcd8739ae039),
    easeVarying: (0, $a95491d6e4fb0554$export$2e2bcd8739ae039),
    end: (0, $9b7260bb5a578278$export$2e2bcd8739ae039),
    [Symbol.iterator]: $b8670e3a5a0947d0$var$selection_prototype[Symbol.iterator]
};





function $86a58d7ec1d5b66c$export$b1a09cb1b71f86aa(t) {
    return t * t * t;
}
function $86a58d7ec1d5b66c$export$68d528839c701b6(t) {
    return --t * t * t + 1;
}
function $86a58d7ec1d5b66c$export$89238d3bc79d3ada(t) {
    return ((t *= 2) <= 1 ? t * t * t : (t -= 2) * t * t + 2) / 2;
}



var $i7zWP = parcelRequire("i7zWP");

var $b40538e12df27399$var$defaultTiming = {
    time: null,
    delay: 0,
    duration: 250,
    ease: (0, $86a58d7ec1d5b66c$export$89238d3bc79d3ada)
};
function $b40538e12df27399$var$inherit(node, id) {
    var timing;
    while(!(timing = node.__transition) || !(timing = timing[id])){
        if (!(node = node.parentNode)) throw new Error(`transition ${id} not found`);
    }
    return timing;
}
function $b40538e12df27399$export$2e2bcd8739ae039(name) {
    var id, timing;
    if (name instanceof (0, $b8670e3a5a0947d0$export$be58926105124dd4)) id = name._id, name = name._name;
    else id = (0, $b8670e3a5a0947d0$export$9ffd10a3fbdc175b)(), (timing = $b40538e12df27399$var$defaultTiming).time = (0, $i7zWP.now)(), name = name == null ? null : name + "";
    for(var groups = this._groups, m = groups.length, j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) (0, $ibDxT.default)(node, name, id, i, group, timing || $b40538e12df27399$var$inherit(node, id));
    }
    return new (0, $b8670e3a5a0947d0$export$be58926105124dd4)(groups, this._parents, name, id);
}


(0, $kWPfg.default).prototype.interrupt = (0, $2677905bc5b4f3c3$export$2e2bcd8739ae039);
(0, $kWPfg.default).prototype.transition = (0, $b40538e12df27399$export$2e2bcd8739ae039);








});

parcelRegister("ckcOL", function(module, exports) {

var $2ne3H = parcelRequire("2ne3H");


var $giZwp = parcelRequire("giZwp");


});

parcelRegister("jsixF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e29f03ea1fb44f1d$var$_react = $e29f03ea1fb44f1d$var$_interopRequireDefault((parcelRequire("42omo")));

var $bw1Fx = parcelRequire("bw1Fx");

function $e29f03ea1fb44f1d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $e29f03ea1fb44f1d$var$MoreIcon = (props)=>/*#__PURE__*/ $e29f03ea1fb44f1d$var$_react.default.createElement($bw1Fx.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor" fill-rule="evenodd"><circle cx="5" cy="12" r="2"/><circle cx="12" cy="12" r="2"/><circle cx="19" cy="12" r="2"/></g></svg>`
    }, props));
$e29f03ea1fb44f1d$var$MoreIcon.displayName = 'MoreIcon';
var $e29f03ea1fb44f1d$var$_default = $e29f03ea1fb44f1d$var$MoreIcon;
module.exports.default = $e29f03ea1fb44f1d$var$_default;

});

parcelRegister("bqrhG", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $8517497acd47c8d7$var$EventEmitterContext = /*#__PURE__*/ (0, $42omo.createContext)(null);
var $8517497acd47c8d7$export$2e2bcd8739ae039 = $8517497acd47c8d7$var$EventEmitterContext;
module.exports["default"] = $8517497acd47c8d7$export$2e2bcd8739ae039;

});

parcelRegister("ewsGH", function(module, exports) {
$parcel$export(module.exports, "default", () => $a92a4e9d54b9c537$export$2e2bcd8739ae039);

var $74das = parcelRequire("74das");


var $gXiD8 = parcelRequire("gXiD8");


var $eocb8 = parcelRequire("eocb8");


var $1PbfN = parcelRequire("1PbfN");


var $ffqCS = parcelRequire("ffqCS");


var $byzof = parcelRequire("byzof");


var $amc1O = parcelRequire("amc1O");


var $cTRy3 = parcelRequire("cTRy3");


var $5LVHX = parcelRequire("5LVHX");


var $iWKJ0 = parcelRequire("iWKJ0");


var $gSwrG = parcelRequire("gSwrG");


var $ePFyi = parcelRequire("ePFyi");


var $niTBZ = parcelRequire("niTBZ");


var $u9DVt = parcelRequire("u9DVt");

var $a92a4e9d54b9c537$export$5f274da11658f617 = [
    // domain => nice => zero
    'domain',
    'nice',
    'zero',
    // interpolate before round
    'interpolate',
    'round',
    // set range then reverse
    'range',
    'reverse',
    // Order does not matter for these operators
    'align',
    'base',
    'clamp',
    'constant',
    'exponent',
    'padding',
    'unknown'
];
// Use Record to enforce that all keys in OperatorType must exist.
var $a92a4e9d54b9c537$var$operators = {
    domain: (0, $74das.default),
    nice: (0, $5LVHX.default),
    zero: (0, $u9DVt.default),
    interpolate: (0, $cTRy3.default),
    round: (0, $ePFyi.default),
    align: (0, $eocb8.default),
    base: (0, $1PbfN.default),
    clamp: (0, $ffqCS.default),
    constant: (0, $byzof.default),
    exponent: (0, $amc1O.default),
    padding: (0, $iWKJ0.default),
    range: (0, $gXiD8.default),
    reverse: (0, $gSwrG.default),
    unknown: (0, $niTBZ.default)
};
function $a92a4e9d54b9c537$export$2e2bcd8739ae039() {
    for(var _len = arguments.length, ops = new Array(_len), _key = 0; _key < _len; _key++)ops[_key] = arguments[_key];
    var selection = new Set(ops);
    var selectedOps = $a92a4e9d54b9c537$export$5f274da11658f617.filter(function(o) {
        return selection.has(o);
    });
    return function applyOperators(scale, config) {
        if (typeof config !== 'undefined') selectedOps.forEach(function(op) {
            $a92a4e9d54b9c537$var$operators[op](scale, config);
        });
        return scale;
    };
}

});

parcelRegister("c24fw", function(module, exports) {

var $114HK = parcelRequire("114HK");


var $2sQ2T = parcelRequire("2sQ2T");


var $a864F = parcelRequire("a864F");


var $imgG1 = parcelRequire("imgG1");

var $jvB2H = parcelRequire("jvB2H");

parcelRequire("4dZMr");
var $5Dd1S = parcelRequire("5Dd1S");

var $459f714a8c3db696$export$2e2bcd8739ae039 = (x)=>()=>x;


function $8fd52042d5bbe2b4$export$2e2bcd8739ae039(type, { sourceEvent: sourceEvent, target: target, selection: selection, mode: mode, dispatch: dispatch }) {
    Object.defineProperties(this, {
        type: {
            value: type,
            enumerable: true,
            configurable: true
        },
        sourceEvent: {
            value: sourceEvent,
            enumerable: true,
            configurable: true
        },
        target: {
            value: target,
            enumerable: true,
            configurable: true
        },
        selection: {
            value: selection,
            enumerable: true,
            configurable: true
        },
        mode: {
            value: mode,
            enumerable: true,
            configurable: true
        },
        _: {
            value: dispatch
        }
    });
}


function $693591bac4b5f073$export$2e2561858db9bf47(event) {
    event.stopImmediatePropagation();
}
function $693591bac4b5f073$export$2e2bcd8739ae039(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
}


var $8c28f7c9edec7bdb$var$MODE_DRAG = {
    name: "drag"
}, $8c28f7c9edec7bdb$var$MODE_SPACE = {
    name: "space"
}, $8c28f7c9edec7bdb$var$MODE_HANDLE = {
    name: "handle"
}, $8c28f7c9edec7bdb$var$MODE_CENTER = {
    name: "center"
};
const { abs: $8c28f7c9edec7bdb$var$abs, max: $8c28f7c9edec7bdb$var$max, min: $8c28f7c9edec7bdb$var$min } = Math;
function $8c28f7c9edec7bdb$var$number1(e) {
    return [
        +e[0],
        +e[1]
    ];
}
function $8c28f7c9edec7bdb$var$number2(e) {
    return [
        $8c28f7c9edec7bdb$var$number1(e[0]),
        $8c28f7c9edec7bdb$var$number1(e[1])
    ];
}
var $8c28f7c9edec7bdb$var$X = {
    name: "x",
    handles: [
        "w",
        "e"
    ].map($8c28f7c9edec7bdb$var$type),
    input: function(x, e) {
        return x == null ? null : [
            [
                +x[0],
                e[0][1]
            ],
            [
                +x[1],
                e[1][1]
            ]
        ];
    },
    output: function(xy) {
        return xy && [
            xy[0][0],
            xy[1][0]
        ];
    }
};
var $8c28f7c9edec7bdb$var$Y = {
    name: "y",
    handles: [
        "n",
        "s"
    ].map($8c28f7c9edec7bdb$var$type),
    input: function(y, e) {
        return y == null ? null : [
            [
                e[0][0],
                +y[0]
            ],
            [
                e[1][0],
                +y[1]
            ]
        ];
    },
    output: function(xy) {
        return xy && [
            xy[0][1],
            xy[1][1]
        ];
    }
};
var $8c28f7c9edec7bdb$var$XY = {
    name: "xy",
    handles: [
        "n",
        "w",
        "e",
        "s",
        "nw",
        "ne",
        "sw",
        "se"
    ].map($8c28f7c9edec7bdb$var$type),
    input: function(xy) {
        return xy == null ? null : $8c28f7c9edec7bdb$var$number2(xy);
    },
    output: function(xy) {
        return xy;
    }
};
var $8c28f7c9edec7bdb$var$cursors = {
    overlay: "crosshair",
    selection: "move",
    n: "ns-resize",
    e: "ew-resize",
    s: "ns-resize",
    w: "ew-resize",
    nw: "nwse-resize",
    ne: "nesw-resize",
    se: "nwse-resize",
    sw: "nesw-resize"
};
var $8c28f7c9edec7bdb$var$flipX = {
    e: "w",
    w: "e",
    nw: "ne",
    ne: "nw",
    se: "sw",
    sw: "se"
};
var $8c28f7c9edec7bdb$var$flipY = {
    n: "s",
    s: "n",
    nw: "sw",
    ne: "se",
    se: "ne",
    sw: "nw"
};
var $8c28f7c9edec7bdb$var$signsX = {
    overlay: 1,
    selection: 1,
    n: null,
    e: 1,
    s: null,
    w: -1,
    nw: -1,
    ne: 1,
    se: 1,
    sw: -1
};
var $8c28f7c9edec7bdb$var$signsY = {
    overlay: 1,
    selection: 1,
    n: -1,
    e: null,
    s: 1,
    w: null,
    nw: -1,
    ne: -1,
    se: 1,
    sw: 1
};
function $8c28f7c9edec7bdb$var$type(t) {
    return {
        type: t
    };
}
// Ignore right-click, since that should open the context menu.
function $8c28f7c9edec7bdb$var$defaultFilter(event) {
    return !event.ctrlKey && !event.button;
}
function $8c28f7c9edec7bdb$var$defaultExtent() {
    var svg = this.ownerSVGElement || this;
    if (svg.hasAttribute("viewBox")) {
        svg = svg.viewBox.baseVal;
        return [
            [
                svg.x,
                svg.y
            ],
            [
                svg.x + svg.width,
                svg.y + svg.height
            ]
        ];
    }
    return [
        [
            0,
            0
        ],
        [
            svg.width.baseVal.value,
            svg.height.baseVal.value
        ]
    ];
}
function $8c28f7c9edec7bdb$var$defaultTouchable() {
    return navigator.maxTouchPoints || "ontouchstart" in this;
}
// Like d3.local, but with the name “__brush” rather than auto-generated.
function $8c28f7c9edec7bdb$var$local(node) {
    while(!node.__brush)if (!(node = node.parentNode)) return;
    return node.__brush;
}
function $8c28f7c9edec7bdb$var$empty(extent) {
    return extent[0][0] === extent[1][0] || extent[0][1] === extent[1][1];
}
function $8c28f7c9edec7bdb$export$69760394fc76f689(node) {
    var state = node.__brush;
    return state ? state.dim.output(state.selection) : null;
}
function $8c28f7c9edec7bdb$export$979ace6c88860aa8() {
    return $8c28f7c9edec7bdb$var$brush($8c28f7c9edec7bdb$var$X);
}
function $8c28f7c9edec7bdb$export$468748b530991c54() {
    return $8c28f7c9edec7bdb$var$brush($8c28f7c9edec7bdb$var$Y);
}
function $8c28f7c9edec7bdb$export$2e2bcd8739ae039() {
    return $8c28f7c9edec7bdb$var$brush($8c28f7c9edec7bdb$var$XY);
}
function $8c28f7c9edec7bdb$var$brush(dim) {
    var extent = $8c28f7c9edec7bdb$var$defaultExtent, filter = $8c28f7c9edec7bdb$var$defaultFilter, touchable = $8c28f7c9edec7bdb$var$defaultTouchable, keys = true, listeners = (0, $114HK.default)("start", "brush", "end"), handleSize = 6, touchending;
    function brush(group) {
        var overlay = group.property("__brush", initialize).selectAll(".overlay").data([
            $8c28f7c9edec7bdb$var$type("overlay")
        ]);
        overlay.enter().append("rect").attr("class", "overlay").attr("pointer-events", "all").attr("cursor", $8c28f7c9edec7bdb$var$cursors.overlay).merge(overlay).each(function() {
            var extent = $8c28f7c9edec7bdb$var$local(this).extent;
            (0, $jvB2H.default)(this).attr("x", extent[0][0]).attr("y", extent[0][1]).attr("width", extent[1][0] - extent[0][0]).attr("height", extent[1][1] - extent[0][1]);
        });
        group.selectAll(".selection").data([
            $8c28f7c9edec7bdb$var$type("selection")
        ]).enter().append("rect").attr("class", "selection").attr("cursor", $8c28f7c9edec7bdb$var$cursors.selection).attr("fill", "#777").attr("fill-opacity", 0.3).attr("stroke", "#fff").attr("shape-rendering", "crispEdges");
        var handle = group.selectAll(".handle").data(dim.handles, function(d) {
            return d.type;
        });
        handle.exit().remove();
        handle.enter().append("rect").attr("class", function(d) {
            return "handle handle--" + d.type;
        }).attr("cursor", function(d) {
            return $8c28f7c9edec7bdb$var$cursors[d.type];
        });
        group.each(redraw).attr("fill", "none").attr("pointer-events", "all").on("mousedown.brush", started).filter(touchable).on("touchstart.brush", started).on("touchmove.brush", touchmoved).on("touchend.brush touchcancel.brush", touchended).style("touch-action", "none").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
    }
    brush.move = function(group, selection, event) {
        if (group.tween) group.on("start.brush", function(event) {
            emitter(this, arguments).beforestart().start(event);
        }).on("interrupt.brush end.brush", function(event) {
            emitter(this, arguments).end(event);
        }).tween("brush", function() {
            var that = this, state = that.__brush, emit = emitter(that, arguments), selection0 = state.selection, selection1 = dim.input(typeof selection === "function" ? selection.apply(this, arguments) : selection, state.extent), i = (0, $a864F.default)(selection0, selection1);
            function tween(t) {
                state.selection = t === 1 && selection1 === null ? null : i(t);
                redraw.call(that);
                emit.brush();
            }
            return selection0 !== null && selection1 !== null ? tween : tween(1);
        });
        else group.each(function() {
            var that = this, args = arguments, state = that.__brush, selection1 = dim.input(typeof selection === "function" ? selection.apply(that, args) : selection, state.extent), emit = emitter(that, args).beforestart();
            (0, $5Dd1S.default)(that);
            state.selection = selection1 === null ? null : selection1;
            redraw.call(that);
            emit.start(event).brush(event).end(event);
        });
    };
    brush.clear = function(group, event) {
        brush.move(group, null, event);
    };
    function redraw() {
        var group = (0, $jvB2H.default)(this), selection = $8c28f7c9edec7bdb$var$local(this).selection;
        if (selection) {
            group.selectAll(".selection").style("display", null).attr("x", selection[0][0]).attr("y", selection[0][1]).attr("width", selection[1][0] - selection[0][0]).attr("height", selection[1][1] - selection[0][1]);
            group.selectAll(".handle").style("display", null).attr("x", function(d) {
                return d.type[d.type.length - 1] === "e" ? selection[1][0] - handleSize / 2 : selection[0][0] - handleSize / 2;
            }).attr("y", function(d) {
                return d.type[0] === "s" ? selection[1][1] - handleSize / 2 : selection[0][1] - handleSize / 2;
            }).attr("width", function(d) {
                return d.type === "n" || d.type === "s" ? selection[1][0] - selection[0][0] + handleSize : handleSize;
            }).attr("height", function(d) {
                return d.type === "e" || d.type === "w" ? selection[1][1] - selection[0][1] + handleSize : handleSize;
            });
        } else group.selectAll(".selection,.handle").style("display", "none").attr("x", null).attr("y", null).attr("width", null).attr("height", null);
    }
    function emitter(that, args, clean) {
        var emit = that.__brush.emitter;
        return emit && (!clean || !emit.clean) ? emit : new Emitter(that, args, clean);
    }
    function Emitter(that, args, clean) {
        this.that = that;
        this.args = args;
        this.state = that.__brush;
        this.active = 0;
        this.clean = clean;
    }
    Emitter.prototype = {
        beforestart: function() {
            if (++this.active === 1) this.state.emitter = this, this.starting = true;
            return this;
        },
        start: function(event, mode) {
            if (this.starting) this.starting = false, this.emit("start", event, mode);
            else this.emit("brush", event);
            return this;
        },
        brush: function(event, mode) {
            this.emit("brush", event, mode);
            return this;
        },
        end: function(event, mode) {
            if (--this.active === 0) delete this.state.emitter, this.emit("end", event, mode);
            return this;
        },
        emit: function(type, event, mode) {
            var d = (0, $jvB2H.default)(this.that).datum();
            listeners.call(type, this.that, new (0, $8fd52042d5bbe2b4$export$2e2bcd8739ae039)(type, {
                sourceEvent: event,
                target: brush,
                selection: dim.output(this.state.selection),
                mode: mode,
                dispatch: listeners
            }), d);
        }
    };
    function started(event) {
        if (touchending && !event.touches) return;
        if (!filter.apply(this, arguments)) return;
        var that = this, type = event.target.__data__.type, mode = (keys && event.metaKey ? type = "overlay" : type) === "selection" ? $8c28f7c9edec7bdb$var$MODE_DRAG : keys && event.altKey ? $8c28f7c9edec7bdb$var$MODE_CENTER : $8c28f7c9edec7bdb$var$MODE_HANDLE, signX = dim === $8c28f7c9edec7bdb$var$Y ? null : $8c28f7c9edec7bdb$var$signsX[type], signY = dim === $8c28f7c9edec7bdb$var$X ? null : $8c28f7c9edec7bdb$var$signsY[type], state = $8c28f7c9edec7bdb$var$local(that), extent = state.extent, selection = state.selection, W = extent[0][0], w0, w1, N = extent[0][1], n0, n1, E = extent[1][0], e0, e1, S = extent[1][1], s0, s1, dx = 0, dy = 0, moving, shifting = signX && signY && keys && event.shiftKey, lockX, lockY, points = Array.from(event.touches || [
            event
        ], (t)=>{
            const i = t.identifier;
            t = (0, $imgG1.default)(t, that);
            t.point0 = t.slice();
            t.identifier = i;
            return t;
        });
        (0, $5Dd1S.default)(that);
        var emit = emitter(that, arguments, true).beforestart();
        if (type === "overlay") {
            if (selection) moving = true;
            const pts = [
                points[0],
                points[1] || points[0]
            ];
            state.selection = selection = [
                [
                    w0 = dim === $8c28f7c9edec7bdb$var$Y ? W : $8c28f7c9edec7bdb$var$min(pts[0][0], pts[1][0]),
                    n0 = dim === $8c28f7c9edec7bdb$var$X ? N : $8c28f7c9edec7bdb$var$min(pts[0][1], pts[1][1])
                ],
                [
                    e0 = dim === $8c28f7c9edec7bdb$var$Y ? E : $8c28f7c9edec7bdb$var$max(pts[0][0], pts[1][0]),
                    s0 = dim === $8c28f7c9edec7bdb$var$X ? S : $8c28f7c9edec7bdb$var$max(pts[0][1], pts[1][1])
                ]
            ];
            if (points.length > 1) move(event);
        } else {
            w0 = selection[0][0];
            n0 = selection[0][1];
            e0 = selection[1][0];
            s0 = selection[1][1];
        }
        w1 = w0;
        n1 = n0;
        e1 = e0;
        s1 = s0;
        var group = (0, $jvB2H.default)(that).attr("pointer-events", "none");
        var overlay = group.selectAll(".overlay").attr("cursor", $8c28f7c9edec7bdb$var$cursors[type]);
        if (event.touches) {
            emit.moved = moved;
            emit.ended = ended;
        } else {
            var view = (0, $jvB2H.default)(event.view).on("mousemove.brush", moved, true).on("mouseup.brush", ended, true);
            if (keys) view.on("keydown.brush", keydowned, true).on("keyup.brush", keyupped, true);
            (0, $2sQ2T.default)(event.view);
        }
        redraw.call(that);
        emit.start(event, mode.name);
        function moved(event) {
            for (const p of event.changedTouches || [
                event
            ]){
                for (const d of points)if (d.identifier === p.identifier) d.cur = (0, $imgG1.default)(p, that);
            }
            if (shifting && !lockX && !lockY && points.length === 1) {
                const point = points[0];
                if ($8c28f7c9edec7bdb$var$abs(point.cur[0] - point[0]) > $8c28f7c9edec7bdb$var$abs(point.cur[1] - point[1])) lockY = true;
                else lockX = true;
            }
            for (const point of points)if (point.cur) point[0] = point.cur[0], point[1] = point.cur[1];
            moving = true;
            (0, $693591bac4b5f073$export$2e2bcd8739ae039)(event);
            move(event);
        }
        function move(event) {
            const point = points[0], point0 = point.point0;
            var t;
            dx = point[0] - point0[0];
            dy = point[1] - point0[1];
            switch(mode){
                case $8c28f7c9edec7bdb$var$MODE_SPACE:
                case $8c28f7c9edec7bdb$var$MODE_DRAG:
                    if (signX) dx = $8c28f7c9edec7bdb$var$max(W - w0, $8c28f7c9edec7bdb$var$min(E - e0, dx)), w1 = w0 + dx, e1 = e0 + dx;
                    if (signY) dy = $8c28f7c9edec7bdb$var$max(N - n0, $8c28f7c9edec7bdb$var$min(S - s0, dy)), n1 = n0 + dy, s1 = s0 + dy;
                    break;
                case $8c28f7c9edec7bdb$var$MODE_HANDLE:
                    if (points[1]) {
                        if (signX) w1 = $8c28f7c9edec7bdb$var$max(W, $8c28f7c9edec7bdb$var$min(E, points[0][0])), e1 = $8c28f7c9edec7bdb$var$max(W, $8c28f7c9edec7bdb$var$min(E, points[1][0])), signX = 1;
                        if (signY) n1 = $8c28f7c9edec7bdb$var$max(N, $8c28f7c9edec7bdb$var$min(S, points[0][1])), s1 = $8c28f7c9edec7bdb$var$max(N, $8c28f7c9edec7bdb$var$min(S, points[1][1])), signY = 1;
                    } else {
                        if (signX < 0) dx = $8c28f7c9edec7bdb$var$max(W - w0, $8c28f7c9edec7bdb$var$min(E - w0, dx)), w1 = w0 + dx, e1 = e0;
                        else if (signX > 0) dx = $8c28f7c9edec7bdb$var$max(W - e0, $8c28f7c9edec7bdb$var$min(E - e0, dx)), w1 = w0, e1 = e0 + dx;
                        if (signY < 0) dy = $8c28f7c9edec7bdb$var$max(N - n0, $8c28f7c9edec7bdb$var$min(S - n0, dy)), n1 = n0 + dy, s1 = s0;
                        else if (signY > 0) dy = $8c28f7c9edec7bdb$var$max(N - s0, $8c28f7c9edec7bdb$var$min(S - s0, dy)), n1 = n0, s1 = s0 + dy;
                    }
                    break;
                case $8c28f7c9edec7bdb$var$MODE_CENTER:
                    if (signX) w1 = $8c28f7c9edec7bdb$var$max(W, $8c28f7c9edec7bdb$var$min(E, w0 - dx * signX)), e1 = $8c28f7c9edec7bdb$var$max(W, $8c28f7c9edec7bdb$var$min(E, e0 + dx * signX));
                    if (signY) n1 = $8c28f7c9edec7bdb$var$max(N, $8c28f7c9edec7bdb$var$min(S, n0 - dy * signY)), s1 = $8c28f7c9edec7bdb$var$max(N, $8c28f7c9edec7bdb$var$min(S, s0 + dy * signY));
                    break;
            }
            if (e1 < w1) {
                signX *= -1;
                t = w0, w0 = e0, e0 = t;
                t = w1, w1 = e1, e1 = t;
                if (type in $8c28f7c9edec7bdb$var$flipX) overlay.attr("cursor", $8c28f7c9edec7bdb$var$cursors[type = $8c28f7c9edec7bdb$var$flipX[type]]);
            }
            if (s1 < n1) {
                signY *= -1;
                t = n0, n0 = s0, s0 = t;
                t = n1, n1 = s1, s1 = t;
                if (type in $8c28f7c9edec7bdb$var$flipY) overlay.attr("cursor", $8c28f7c9edec7bdb$var$cursors[type = $8c28f7c9edec7bdb$var$flipY[type]]);
            }
            if (state.selection) selection = state.selection; // May be set by brush.move!
            if (lockX) w1 = selection[0][0], e1 = selection[1][0];
            if (lockY) n1 = selection[0][1], s1 = selection[1][1];
            if (selection[0][0] !== w1 || selection[0][1] !== n1 || selection[1][0] !== e1 || selection[1][1] !== s1) {
                state.selection = [
                    [
                        w1,
                        n1
                    ],
                    [
                        e1,
                        s1
                    ]
                ];
                redraw.call(that);
                emit.brush(event, mode.name);
            }
        }
        function ended(event) {
            (0, $693591bac4b5f073$export$2e2561858db9bf47)(event);
            if (event.touches) {
                if (event.touches.length) return;
                if (touchending) clearTimeout(touchending);
                touchending = setTimeout(function() {
                    touchending = null;
                }, 500); // Ghost clicks are delayed!
            } else {
                (0, $2sQ2T.yesdrag)(event.view, moving);
                view.on("keydown.brush keyup.brush mousemove.brush mouseup.brush", null);
            }
            group.attr("pointer-events", "all");
            overlay.attr("cursor", $8c28f7c9edec7bdb$var$cursors.overlay);
            if (state.selection) selection = state.selection; // May be set by brush.move (on start)!
            if ($8c28f7c9edec7bdb$var$empty(selection)) state.selection = null, redraw.call(that);
            emit.end(event, mode.name);
        }
        function keydowned(event) {
            switch(event.keyCode){
                case 16:
                    shifting = signX && signY;
                    break;
                case 18:
                    if (mode === $8c28f7c9edec7bdb$var$MODE_HANDLE) {
                        if (signX) e0 = e1 - dx * signX, w0 = w1 + dx * signX;
                        if (signY) s0 = s1 - dy * signY, n0 = n1 + dy * signY;
                        mode = $8c28f7c9edec7bdb$var$MODE_CENTER;
                        move(event);
                    }
                    break;
                case 32:
                    if (mode === $8c28f7c9edec7bdb$var$MODE_HANDLE || mode === $8c28f7c9edec7bdb$var$MODE_CENTER) {
                        if (signX < 0) e0 = e1 - dx;
                        else if (signX > 0) w0 = w1 - dx;
                        if (signY < 0) s0 = s1 - dy;
                        else if (signY > 0) n0 = n1 - dy;
                        mode = $8c28f7c9edec7bdb$var$MODE_SPACE;
                        overlay.attr("cursor", $8c28f7c9edec7bdb$var$cursors.selection);
                        move(event);
                    }
                    break;
                default:
                    return;
            }
            (0, $693591bac4b5f073$export$2e2bcd8739ae039)(event);
        }
        function keyupped(event) {
            switch(event.keyCode){
                case 16:
                    if (shifting) {
                        lockX = lockY = shifting = false;
                        move(event);
                    }
                    break;
                case 18:
                    if (mode === $8c28f7c9edec7bdb$var$MODE_CENTER) {
                        if (signX < 0) e0 = e1;
                        else if (signX > 0) w0 = w1;
                        if (signY < 0) s0 = s1;
                        else if (signY > 0) n0 = n1;
                        mode = $8c28f7c9edec7bdb$var$MODE_HANDLE;
                        move(event);
                    }
                    break;
                case 32:
                    if (mode === $8c28f7c9edec7bdb$var$MODE_SPACE) {
                        if (event.altKey) {
                            if (signX) e0 = e1 - dx * signX, w0 = w1 + dx * signX;
                            if (signY) s0 = s1 - dy * signY, n0 = n1 + dy * signY;
                            mode = $8c28f7c9edec7bdb$var$MODE_CENTER;
                        } else {
                            if (signX < 0) e0 = e1;
                            else if (signX > 0) w0 = w1;
                            if (signY < 0) s0 = s1;
                            else if (signY > 0) n0 = n1;
                            mode = $8c28f7c9edec7bdb$var$MODE_HANDLE;
                        }
                        overlay.attr("cursor", $8c28f7c9edec7bdb$var$cursors[type]);
                        move(event);
                    }
                    break;
                default:
                    return;
            }
            (0, $693591bac4b5f073$export$2e2bcd8739ae039)(event);
        }
    }
    function touchmoved(event) {
        emitter(this, arguments).moved(event);
    }
    function touchended(event) {
        emitter(this, arguments).ended(event);
    }
    function initialize() {
        var state = this.__brush || {
            selection: null
        };
        state.extent = $8c28f7c9edec7bdb$var$number2(extent.apply(this, arguments));
        state.dim = dim;
        return state;
    }
    brush.extent = function(_) {
        return arguments.length ? (extent = typeof _ === "function" ? _ : (0, $459f714a8c3db696$export$2e2bcd8739ae039)($8c28f7c9edec7bdb$var$number2(_)), brush) : extent;
    };
    brush.filter = function(_) {
        return arguments.length ? (filter = typeof _ === "function" ? _ : (0, $459f714a8c3db696$export$2e2bcd8739ae039)(!!_), brush) : filter;
    };
    brush.touchable = function(_) {
        return arguments.length ? (touchable = typeof _ === "function" ? _ : (0, $459f714a8c3db696$export$2e2bcd8739ae039)(!!_), brush) : touchable;
    };
    brush.handleSize = function(_) {
        return arguments.length ? (handleSize = +_, brush) : handleSize;
    };
    brush.keyModifiers = function(_) {
        return arguments.length ? (keys = !!_, brush) : keys;
    };
    brush.on = function() {
        var value = listeners.on.apply(listeners, arguments);
        return value === listeners ? brush : value;
    };
    return brush;
}

});

parcelRegister("5Dd1S", function(module, exports) {
$parcel$export(module.exports, "default", () => $419ab39e9817fcd8$export$2e2bcd8739ae039);

var $ibDxT = parcelRequire("ibDxT");

function $419ab39e9817fcd8$export$2e2bcd8739ae039(node, name) {
    var schedules = node.__transition, schedule, active, empty = true, i;
    if (!schedules) return;
    name = name == null ? null : name + "";
    for(i in schedules){
        if ((schedule = schedules[i]).name !== name) {
            empty = false;
            continue;
        }
        active = schedule.state > (0, $ibDxT.STARTING) && schedule.state < (0, $ibDxT.ENDING);
        schedule.state = (0, $ibDxT.ENDED);
        schedule.timer.stop();
        schedule.on.call(active ? "interrupt" : "cancel", node, node.__data__, schedule.index, schedule.group);
        delete schedules[i];
    }
    if (empty) delete node.__transition;
}

});

parcelRegister("2ne3H", function(module, exports) {

var $114HK = parcelRequire("114HK");


var $2sQ2T = parcelRequire("2sQ2T");

var $a974baca30305cf6$var$epsilon2 = 1e-12;
function $a974baca30305cf6$var$cosh(x) {
    return ((x = Math.exp(x)) + 1 / x) / 2;
}
function $a974baca30305cf6$var$sinh(x) {
    return ((x = Math.exp(x)) - 1 / x) / 2;
}
function $a974baca30305cf6$var$tanh(x) {
    return ((x = Math.exp(2 * x)) - 1) / (x + 1);
}
var $a974baca30305cf6$export$2e2bcd8739ae039 = function zoomRho(rho, rho2, rho4) {
    // p0 = [ux0, uy0, w0]
    // p1 = [ux1, uy1, w1]
    function zoom(p0, p1) {
        var ux0 = p0[0], uy0 = p0[1], w0 = p0[2], ux1 = p1[0], uy1 = p1[1], w1 = p1[2], dx = ux1 - ux0, dy = uy1 - uy0, d2 = dx * dx + dy * dy, i, S;
        // Special case for u0 ≅ u1.
        if (d2 < $a974baca30305cf6$var$epsilon2) {
            S = Math.log(w1 / w0) / rho;
            i = function(t) {
                return [
                    ux0 + t * dx,
                    uy0 + t * dy,
                    w0 * Math.exp(rho * t * S)
                ];
            };
        } else {
            var d1 = Math.sqrt(d2), b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1), b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1), r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0), r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
            S = (r1 - r0) / rho;
            i = function(t) {
                var s = t * S, coshr0 = $a974baca30305cf6$var$cosh(r0), u = w0 / (rho2 * d1) * (coshr0 * $a974baca30305cf6$var$tanh(rho * s + r0) - $a974baca30305cf6$var$sinh(r0));
                return [
                    ux0 + u * dx,
                    uy0 + u * dy,
                    w0 * coshr0 / $a974baca30305cf6$var$cosh(rho * s + r0)
                ];
            };
        }
        i.duration = S * 1000 * rho / Math.SQRT2;
        return i;
    }
    zoom.rho = function(_) {
        var _1 = Math.max(1e-3, +_), _2 = _1 * _1, _4 = _2 * _2;
        return zoomRho(_1, _2, _4);
    };
    return zoom;
}(Math.SQRT2, 2, 4);



var $imgG1 = parcelRequire("imgG1");

var $jvB2H = parcelRequire("jvB2H");

parcelRequire("4dZMr");
var $5Dd1S = parcelRequire("5Dd1S");

var $7257e6e28f4d6c7e$export$2e2bcd8739ae039 = (x)=>()=>x;


function $c22a0616d48d2c82$export$2e2bcd8739ae039(type, { sourceEvent: sourceEvent, target: target, transform: transform, dispatch: dispatch }) {
    Object.defineProperties(this, {
        type: {
            value: type,
            enumerable: true,
            configurable: true
        },
        sourceEvent: {
            value: sourceEvent,
            enumerable: true,
            configurable: true
        },
        target: {
            value: target,
            enumerable: true,
            configurable: true
        },
        transform: {
            value: transform,
            enumerable: true,
            configurable: true
        },
        _: {
            value: dispatch
        }
    });
}



var $giZwp = parcelRequire("giZwp");

function $a526a29f4ca3cd1b$export$2e2561858db9bf47(event) {
    event.stopImmediatePropagation();
}
function $a526a29f4ca3cd1b$export$2e2bcd8739ae039(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
}


// Ignore right-click, since that should open the context menu.
// except for pinch-to-zoom, which is sent as a wheel+ctrlKey event
function $1ba8a27fb4d5b6cf$var$defaultFilter(event) {
    return (!event.ctrlKey || event.type === 'wheel') && !event.button;
}
function $1ba8a27fb4d5b6cf$var$defaultExtent() {
    var e = this;
    if (e instanceof SVGElement) {
        e = e.ownerSVGElement || e;
        if (e.hasAttribute("viewBox")) {
            e = e.viewBox.baseVal;
            return [
                [
                    e.x,
                    e.y
                ],
                [
                    e.x + e.width,
                    e.y + e.height
                ]
            ];
        }
        return [
            [
                0,
                0
            ],
            [
                e.width.baseVal.value,
                e.height.baseVal.value
            ]
        ];
    }
    return [
        [
            0,
            0
        ],
        [
            e.clientWidth,
            e.clientHeight
        ]
    ];
}
function $1ba8a27fb4d5b6cf$var$defaultTransform() {
    return this.__zoom || (0, $giZwp.identity);
}
function $1ba8a27fb4d5b6cf$var$defaultWheelDelta(event) {
    return -event.deltaY * (event.deltaMode === 1 ? 0.05 : event.deltaMode ? 1 : 0.002) * (event.ctrlKey ? 10 : 1);
}
function $1ba8a27fb4d5b6cf$var$defaultTouchable() {
    return navigator.maxTouchPoints || "ontouchstart" in this;
}
function $1ba8a27fb4d5b6cf$var$defaultConstrain(transform, extent, translateExtent) {
    var dx0 = transform.invertX(extent[0][0]) - translateExtent[0][0], dx1 = transform.invertX(extent[1][0]) - translateExtent[1][0], dy0 = transform.invertY(extent[0][1]) - translateExtent[0][1], dy1 = transform.invertY(extent[1][1]) - translateExtent[1][1];
    return transform.translate(dx1 > dx0 ? (dx0 + dx1) / 2 : Math.min(0, dx0) || Math.max(0, dx1), dy1 > dy0 ? (dy0 + dy1) / 2 : Math.min(0, dy0) || Math.max(0, dy1));
}
function $1ba8a27fb4d5b6cf$export$2e2bcd8739ae039() {
    var filter = $1ba8a27fb4d5b6cf$var$defaultFilter, extent = $1ba8a27fb4d5b6cf$var$defaultExtent, constrain = $1ba8a27fb4d5b6cf$var$defaultConstrain, wheelDelta = $1ba8a27fb4d5b6cf$var$defaultWheelDelta, touchable = $1ba8a27fb4d5b6cf$var$defaultTouchable, scaleExtent = [
        0,
        Infinity
    ], translateExtent = [
        [
            -Infinity,
            -Infinity
        ],
        [
            Infinity,
            Infinity
        ]
    ], duration = 250, interpolate = (0, $a974baca30305cf6$export$2e2bcd8739ae039), listeners = (0, $114HK.default)("start", "zoom", "end"), touchstarting, touchfirst, touchending, touchDelay = 500, wheelDelay = 150, clickDistance2 = 0, tapDistance = 10;
    function zoom(selection) {
        selection.property("__zoom", $1ba8a27fb4d5b6cf$var$defaultTransform).on("wheel.zoom", wheeled, {
            passive: false
        }).on("mousedown.zoom", mousedowned).on("dblclick.zoom", dblclicked).filter(touchable).on("touchstart.zoom", touchstarted).on("touchmove.zoom", touchmoved).on("touchend.zoom touchcancel.zoom", touchended).style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
    }
    zoom.transform = function(collection, transform, point, event) {
        var selection = collection.selection ? collection.selection() : collection;
        selection.property("__zoom", $1ba8a27fb4d5b6cf$var$defaultTransform);
        if (collection !== selection) schedule(collection, transform, point, event);
        else selection.interrupt().each(function() {
            gesture(this, arguments).event(event).start().zoom(null, typeof transform === "function" ? transform.apply(this, arguments) : transform).end();
        });
    };
    zoom.scaleBy = function(selection, k, p, event) {
        zoom.scaleTo(selection, function() {
            var k0 = this.__zoom.k, k1 = typeof k === "function" ? k.apply(this, arguments) : k;
            return k0 * k1;
        }, p, event);
    };
    zoom.scaleTo = function(selection, k, p, event) {
        zoom.transform(selection, function() {
            var e = extent.apply(this, arguments), t0 = this.__zoom, p0 = p == null ? centroid(e) : typeof p === "function" ? p.apply(this, arguments) : p, p1 = t0.invert(p0), k1 = typeof k === "function" ? k.apply(this, arguments) : k;
            return constrain(translate(scale(t0, k1), p0, p1), e, translateExtent);
        }, p, event);
    };
    zoom.translateBy = function(selection, x, y, event) {
        zoom.transform(selection, function() {
            return constrain(this.__zoom.translate(typeof x === "function" ? x.apply(this, arguments) : x, typeof y === "function" ? y.apply(this, arguments) : y), extent.apply(this, arguments), translateExtent);
        }, null, event);
    };
    zoom.translateTo = function(selection, x, y, p, event) {
        zoom.transform(selection, function() {
            var e = extent.apply(this, arguments), t = this.__zoom, p0 = p == null ? centroid(e) : typeof p === "function" ? p.apply(this, arguments) : p;
            return constrain((0, $giZwp.identity).translate(p0[0], p0[1]).scale(t.k).translate(typeof x === "function" ? -x.apply(this, arguments) : -x, typeof y === "function" ? -y.apply(this, arguments) : -y), e, translateExtent);
        }, p, event);
    };
    function scale(transform, k) {
        k = Math.max(scaleExtent[0], Math.min(scaleExtent[1], k));
        return k === transform.k ? transform : new (0, $giZwp.Transform)(k, transform.x, transform.y);
    }
    function translate(transform, p0, p1) {
        var x = p0[0] - p1[0] * transform.k, y = p0[1] - p1[1] * transform.k;
        return x === transform.x && y === transform.y ? transform : new (0, $giZwp.Transform)(transform.k, x, y);
    }
    function centroid(extent) {
        return [
            (+extent[0][0] + +extent[1][0]) / 2,
            (+extent[0][1] + +extent[1][1]) / 2
        ];
    }
    function schedule(transition, transform, point, event) {
        transition.on("start.zoom", function() {
            gesture(this, arguments).event(event).start();
        }).on("interrupt.zoom end.zoom", function() {
            gesture(this, arguments).event(event).end();
        }).tween("zoom", function() {
            var that = this, args = arguments, g = gesture(that, args).event(event), e = extent.apply(that, args), p = point == null ? centroid(e) : typeof point === "function" ? point.apply(that, args) : point, w = Math.max(e[1][0] - e[0][0], e[1][1] - e[0][1]), a = that.__zoom, b = typeof transform === "function" ? transform.apply(that, args) : transform, i = interpolate(a.invert(p).concat(w / a.k), b.invert(p).concat(w / b.k));
            return function(t) {
                if (t === 1) t = b; // Avoid rounding error on end.
                else {
                    var l = i(t), k = w / l[2];
                    t = new (0, $giZwp.Transform)(k, p[0] - l[0] * k, p[1] - l[1] * k);
                }
                g.zoom(null, t);
            };
        });
    }
    function gesture(that, args, clean) {
        return !clean && that.__zooming || new Gesture(that, args);
    }
    function Gesture(that, args) {
        this.that = that;
        this.args = args;
        this.active = 0;
        this.sourceEvent = null;
        this.extent = extent.apply(that, args);
        this.taps = 0;
    }
    Gesture.prototype = {
        event: function(event) {
            if (event) this.sourceEvent = event;
            return this;
        },
        start: function() {
            if (++this.active === 1) {
                this.that.__zooming = this;
                this.emit("start");
            }
            return this;
        },
        zoom: function(key, transform) {
            if (this.mouse && key !== "mouse") this.mouse[1] = transform.invert(this.mouse[0]);
            if (this.touch0 && key !== "touch") this.touch0[1] = transform.invert(this.touch0[0]);
            if (this.touch1 && key !== "touch") this.touch1[1] = transform.invert(this.touch1[0]);
            this.that.__zoom = transform;
            this.emit("zoom");
            return this;
        },
        end: function() {
            if (--this.active === 0) {
                delete this.that.__zooming;
                this.emit("end");
            }
            return this;
        },
        emit: function(type) {
            var d = (0, $jvB2H.default)(this.that).datum();
            listeners.call(type, this.that, new (0, $c22a0616d48d2c82$export$2e2bcd8739ae039)(type, {
                sourceEvent: this.sourceEvent,
                target: zoom,
                type: type,
                transform: this.that.__zoom,
                dispatch: listeners
            }), d);
        }
    };
    function wheeled(event, ...args) {
        if (!filter.apply(this, arguments)) return;
        var g = gesture(this, args).event(event), t = this.__zoom, k = Math.max(scaleExtent[0], Math.min(scaleExtent[1], t.k * Math.pow(2, wheelDelta.apply(this, arguments)))), p = (0, $imgG1.default)(event);
        // If the mouse is in the same location as before, reuse it.
        // If there were recent wheel events, reset the wheel idle timeout.
        if (g.wheel) {
            if (g.mouse[0][0] !== p[0] || g.mouse[0][1] !== p[1]) g.mouse[1] = t.invert(g.mouse[0] = p);
            clearTimeout(g.wheel);
        } else if (t.k === k) return;
        else {
            g.mouse = [
                p,
                t.invert(p)
            ];
            (0, $5Dd1S.default)(this);
            g.start();
        }
        (0, $a526a29f4ca3cd1b$export$2e2bcd8739ae039)(event);
        g.wheel = setTimeout(wheelidled, wheelDelay);
        g.zoom("mouse", constrain(translate(scale(t, k), g.mouse[0], g.mouse[1]), g.extent, translateExtent));
        function wheelidled() {
            g.wheel = null;
            g.end();
        }
    }
    function mousedowned(event, ...args) {
        if (touchending || !filter.apply(this, arguments)) return;
        var currentTarget = event.currentTarget, g = gesture(this, args, true).event(event), v = (0, $jvB2H.default)(event.view).on("mousemove.zoom", mousemoved, true).on("mouseup.zoom", mouseupped, true), p = (0, $imgG1.default)(event, currentTarget), x0 = event.clientX, y0 = event.clientY;
        (0, $2sQ2T.default)(event.view);
        (0, $a526a29f4ca3cd1b$export$2e2561858db9bf47)(event);
        g.mouse = [
            p,
            this.__zoom.invert(p)
        ];
        (0, $5Dd1S.default)(this);
        g.start();
        function mousemoved(event) {
            (0, $a526a29f4ca3cd1b$export$2e2bcd8739ae039)(event);
            if (!g.moved) {
                var dx = event.clientX - x0, dy = event.clientY - y0;
                g.moved = dx * dx + dy * dy > clickDistance2;
            }
            g.event(event).zoom("mouse", constrain(translate(g.that.__zoom, g.mouse[0] = (0, $imgG1.default)(event, currentTarget), g.mouse[1]), g.extent, translateExtent));
        }
        function mouseupped(event) {
            v.on("mousemove.zoom mouseup.zoom", null);
            (0, $2sQ2T.yesdrag)(event.view, g.moved);
            (0, $a526a29f4ca3cd1b$export$2e2bcd8739ae039)(event);
            g.event(event).end();
        }
    }
    function dblclicked(event, ...args) {
        if (!filter.apply(this, arguments)) return;
        var t0 = this.__zoom, p0 = (0, $imgG1.default)(event.changedTouches ? event.changedTouches[0] : event, this), p1 = t0.invert(p0), k1 = t0.k * (event.shiftKey ? 0.5 : 2), t1 = constrain(translate(scale(t0, k1), p0, p1), extent.apply(this, args), translateExtent);
        (0, $a526a29f4ca3cd1b$export$2e2bcd8739ae039)(event);
        if (duration > 0) (0, $jvB2H.default)(this).transition().duration(duration).call(schedule, t1, p0, event);
        else (0, $jvB2H.default)(this).call(zoom.transform, t1, p0, event);
    }
    function touchstarted(event, ...args) {
        if (!filter.apply(this, arguments)) return;
        var touches = event.touches, n = touches.length, g = gesture(this, args, event.changedTouches.length === n).event(event), started, i, t, p;
        (0, $a526a29f4ca3cd1b$export$2e2561858db9bf47)(event);
        for(i = 0; i < n; ++i){
            t = touches[i], p = (0, $imgG1.default)(t, this);
            p = [
                p,
                this.__zoom.invert(p),
                t.identifier
            ];
            if (!g.touch0) g.touch0 = p, started = true, g.taps = 1 + !!touchstarting;
            else if (!g.touch1 && g.touch0[2] !== p[2]) g.touch1 = p, g.taps = 0;
        }
        if (touchstarting) touchstarting = clearTimeout(touchstarting);
        if (started) {
            if (g.taps < 2) touchfirst = p[0], touchstarting = setTimeout(function() {
                touchstarting = null;
            }, touchDelay);
            (0, $5Dd1S.default)(this);
            g.start();
        }
    }
    function touchmoved(event, ...args) {
        if (!this.__zooming) return;
        var g = gesture(this, args).event(event), touches = event.changedTouches, n = touches.length, i, t, p, l;
        (0, $a526a29f4ca3cd1b$export$2e2bcd8739ae039)(event);
        for(i = 0; i < n; ++i){
            t = touches[i], p = (0, $imgG1.default)(t, this);
            if (g.touch0 && g.touch0[2] === t.identifier) g.touch0[0] = p;
            else if (g.touch1 && g.touch1[2] === t.identifier) g.touch1[0] = p;
        }
        t = g.that.__zoom;
        if (g.touch1) {
            var p0 = g.touch0[0], l0 = g.touch0[1], p1 = g.touch1[0], l1 = g.touch1[1], dp = (dp = p1[0] - p0[0]) * dp + (dp = p1[1] - p0[1]) * dp, dl = (dl = l1[0] - l0[0]) * dl + (dl = l1[1] - l0[1]) * dl;
            t = scale(t, Math.sqrt(dp / dl));
            p = [
                (p0[0] + p1[0]) / 2,
                (p0[1] + p1[1]) / 2
            ];
            l = [
                (l0[0] + l1[0]) / 2,
                (l0[1] + l1[1]) / 2
            ];
        } else if (g.touch0) p = g.touch0[0], l = g.touch0[1];
        else return;
        g.zoom("touch", constrain(translate(t, p, l), g.extent, translateExtent));
    }
    function touchended(event, ...args) {
        if (!this.__zooming) return;
        var g = gesture(this, args).event(event), touches = event.changedTouches, n = touches.length, i, t;
        (0, $a526a29f4ca3cd1b$export$2e2561858db9bf47)(event);
        if (touchending) clearTimeout(touchending);
        touchending = setTimeout(function() {
            touchending = null;
        }, touchDelay);
        for(i = 0; i < n; ++i){
            t = touches[i];
            if (g.touch0 && g.touch0[2] === t.identifier) delete g.touch0;
            else if (g.touch1 && g.touch1[2] === t.identifier) delete g.touch1;
        }
        if (g.touch1 && !g.touch0) g.touch0 = g.touch1, delete g.touch1;
        if (g.touch0) g.touch0[1] = this.__zoom.invert(g.touch0[0]);
        else {
            g.end();
            // If this was a dbltap, reroute to the (optional) dblclick.zoom handler.
            if (g.taps === 2) {
                t = (0, $imgG1.default)(t, this);
                if (Math.hypot(touchfirst[0] - t[0], touchfirst[1] - t[1]) < tapDistance) {
                    var p = (0, $jvB2H.default)(this).on("dblclick.zoom");
                    if (p) p.apply(this, arguments);
                }
            }
        }
    }
    zoom.wheelDelta = function(_) {
        return arguments.length ? (wheelDelta = typeof _ === "function" ? _ : (0, $7257e6e28f4d6c7e$export$2e2bcd8739ae039)(+_), zoom) : wheelDelta;
    };
    zoom.filter = function(_) {
        return arguments.length ? (filter = typeof _ === "function" ? _ : (0, $7257e6e28f4d6c7e$export$2e2bcd8739ae039)(!!_), zoom) : filter;
    };
    zoom.touchable = function(_) {
        return arguments.length ? (touchable = typeof _ === "function" ? _ : (0, $7257e6e28f4d6c7e$export$2e2bcd8739ae039)(!!_), zoom) : touchable;
    };
    zoom.extent = function(_) {
        return arguments.length ? (extent = typeof _ === "function" ? _ : (0, $7257e6e28f4d6c7e$export$2e2bcd8739ae039)([
            [
                +_[0][0],
                +_[0][1]
            ],
            [
                +_[1][0],
                +_[1][1]
            ]
        ]), zoom) : extent;
    };
    zoom.scaleExtent = function(_) {
        return arguments.length ? (scaleExtent[0] = +_[0], scaleExtent[1] = +_[1], zoom) : [
            scaleExtent[0],
            scaleExtent[1]
        ];
    };
    zoom.translateExtent = function(_) {
        return arguments.length ? (translateExtent[0][0] = +_[0][0], translateExtent[1][0] = +_[1][0], translateExtent[0][1] = +_[0][1], translateExtent[1][1] = +_[1][1], zoom) : [
            [
                translateExtent[0][0],
                translateExtent[0][1]
            ],
            [
                translateExtent[1][0],
                translateExtent[1][1]
            ]
        ];
    };
    zoom.constrain = function(_) {
        return arguments.length ? (constrain = _, zoom) : constrain;
    };
    zoom.duration = function(_) {
        return arguments.length ? (duration = +_, zoom) : duration;
    };
    zoom.interpolate = function(_) {
        return arguments.length ? (interpolate = _, zoom) : interpolate;
    };
    zoom.on = function() {
        var value = listeners.on.apply(listeners, arguments);
        return value === listeners ? zoom : value;
    };
    zoom.clickDistance = function(_) {
        return arguments.length ? (clickDistance2 = (_ = +_) * _, zoom) : Math.sqrt(clickDistance2);
    };
    zoom.tapDistance = function(_) {
        return arguments.length ? (tapDistance = +_, zoom) : tapDistance;
    };
    return zoom;
}

});

parcelRegister("giZwp", function(module, exports) {
function $bdee0cb8bd4e2a0e$export$563a914cafbdc389(k, x, y) {
    this.k = k;
    this.x = x;
    this.y = y;
}
$bdee0cb8bd4e2a0e$export$563a914cafbdc389.prototype = {
    constructor: $bdee0cb8bd4e2a0e$export$563a914cafbdc389,
    scale: function(k) {
        return k === 1 ? this : new $bdee0cb8bd4e2a0e$export$563a914cafbdc389(this.k * k, this.x, this.y);
    },
    translate: function(x, y) {
        return x === 0 & y === 0 ? this : new $bdee0cb8bd4e2a0e$export$563a914cafbdc389(this.k, this.x + this.k * x, this.y + this.k * y);
    },
    apply: function(point) {
        return [
            point[0] * this.k + this.x,
            point[1] * this.k + this.y
        ];
    },
    applyX: function(x) {
        return x * this.k + this.x;
    },
    applyY: function(y) {
        return y * this.k + this.y;
    },
    invert: function(location) {
        return [
            (location[0] - this.x) / this.k,
            (location[1] - this.y) / this.k
        ];
    },
    invertX: function(x) {
        return (x - this.x) / this.k;
    },
    invertY: function(y) {
        return (y - this.y) / this.k;
    },
    rescaleX: function(x) {
        return x.copy().domain(x.range().map(this.invertX, this).map(x.invert, x));
    },
    rescaleY: function(y) {
        return y.copy().domain(y.range().map(this.invertY, this).map(y.invert, y));
    },
    toString: function() {
        return "translate(" + this.x + "," + this.y + ") scale(" + this.k + ")";
    }
};
var $bdee0cb8bd4e2a0e$export$f0954fd7d5368655 = new $bdee0cb8bd4e2a0e$export$563a914cafbdc389(1, 0, 0);
$bdee0cb8bd4e2a0e$export$2e2bcd8739ae039.prototype = $bdee0cb8bd4e2a0e$export$563a914cafbdc389.prototype;
function $bdee0cb8bd4e2a0e$export$2e2bcd8739ae039(node) {
    while(!node.__zoom)if (!(node = node.parentNode)) return $bdee0cb8bd4e2a0e$export$f0954fd7d5368655;
    return node.__zoom;
}
module.exports["Transform"] = $bdee0cb8bd4e2a0e$export$563a914cafbdc389;
module.exports["identity"] = $bdee0cb8bd4e2a0e$export$f0954fd7d5368655;

});

parcelRegister("74das", function(module, exports) {
$parcel$export(module.exports, "default", () => $52531ef62fafd5f6$export$2e2bcd8739ae039);
function $52531ef62fafd5f6$export$2e2bcd8739ae039(scale, config) {
    if (config.domain) {
        if ('nice' in scale || 'quantiles' in scale) // continuous input scales
        scale.domain(config.domain);
        else if ('padding' in scale) // point and band scales
        scale.domain(config.domain);
        else // ordinal and threshold scale
        scale.domain(config.domain);
    }
}

});

parcelRegister("gXiD8", function(module, exports) {
$parcel$export(module.exports, "default", () => $c5809b9a7647c621$export$2e2bcd8739ae039);
function $c5809b9a7647c621$export$2e2bcd8739ae039(scale, config) {
    if (config.range) {
        if ('padding' in scale) // point and band scales
        scale.range(config.range);
        else // the rest
        scale.range(config.range);
    }
}

});

parcelRegister("eocb8", function(module, exports) {
$parcel$export(module.exports, "default", () => $a79cc100faefb43b$export$2e2bcd8739ae039);
function $a79cc100faefb43b$export$2e2bcd8739ae039(scale, config) {
    if ('align' in scale && 'align' in config && typeof config.align !== 'undefined') scale.align(config.align);
}

});

parcelRegister("1PbfN", function(module, exports) {
$parcel$export(module.exports, "default", () => $154348a0cb20df64$export$2e2bcd8739ae039);
function $154348a0cb20df64$export$2e2bcd8739ae039(scale, config) {
    if ('base' in scale && 'base' in config && typeof config.base !== 'undefined') scale.base(config.base);
}

});

parcelRegister("ffqCS", function(module, exports) {
$parcel$export(module.exports, "default", () => $b19ce91b5a7edcbe$export$2e2bcd8739ae039);
function $b19ce91b5a7edcbe$export$2e2bcd8739ae039(scale, config) {
    if ('clamp' in scale && 'clamp' in config && typeof config.clamp !== 'undefined') scale.clamp(config.clamp);
}

});

parcelRegister("byzof", function(module, exports) {
$parcel$export(module.exports, "default", () => $869e526b7bf42adb$export$2e2bcd8739ae039);
function $869e526b7bf42adb$export$2e2bcd8739ae039(scale, config) {
    if ('constant' in scale && 'constant' in config && typeof config.constant !== 'undefined') scale.constant(config.constant);
}

});

parcelRegister("amc1O", function(module, exports) {
$parcel$export(module.exports, "default", () => $78a54a086417f3fe$export$2e2bcd8739ae039);
function $78a54a086417f3fe$export$2e2bcd8739ae039(scale, config) {
    if ('exponent' in scale && 'exponent' in config && typeof config.exponent !== 'undefined') scale.exponent(config.exponent);
}

});

parcelRegister("cTRy3", function(module, exports) {
$parcel$export(module.exports, "default", () => $964428a55d11c1b7$export$2e2bcd8739ae039);

var $7LxXr = parcelRequire("7LxXr");

function $964428a55d11c1b7$export$2e2bcd8739ae039(scale, config) {
    if ('interpolate' in config && 'interpolate' in scale && typeof config.interpolate !== 'undefined') {
        var interpolator = (0, $7LxXr.default)(config.interpolate);
        scale.interpolate(interpolator);
    }
}

});

parcelRegister("5LVHX", function(module, exports) {
$parcel$export(module.exports, "default", () => $433e1b225311bfe5$export$2e2bcd8739ae039);

var $h3ay2 = parcelRequire("h3ay2");


var $K7JGK = parcelRequire("K7JGK");

var $433e1b225311bfe5$var$localTimeIntervals = {
    day: (0, $h3ay2.timeDay),
    hour: (0, $h3ay2.timeHour),
    minute: (0, $h3ay2.timeMinute),
    month: (0, $h3ay2.timeMonth),
    second: (0, $h3ay2.timeSecond),
    week: (0, $h3ay2.timeWeek),
    year: (0, $h3ay2.timeYear)
};
var $433e1b225311bfe5$var$utcIntervals = {
    day: (0, $h3ay2.utcDay),
    hour: (0, $h3ay2.utcHour),
    minute: (0, $h3ay2.utcMinute),
    month: (0, $h3ay2.utcMonth),
    second: (0, $h3ay2.utcSecond),
    week: (0, $h3ay2.utcWeek),
    year: (0, $h3ay2.utcYear)
};
function $433e1b225311bfe5$export$2e2bcd8739ae039(scale, config) {
    if ('nice' in config && typeof config.nice !== 'undefined' && 'nice' in scale) {
        var nice = config.nice;
        if (typeof nice === 'boolean') {
            if (nice) scale.nice();
        } else if (typeof nice === 'number') scale.nice(nice);
        else {
            var timeScale = scale;
            var isUtc = (0, $K7JGK.default)(timeScale);
            if (typeof nice === 'string') timeScale.nice(isUtc ? $433e1b225311bfe5$var$utcIntervals[nice] : $433e1b225311bfe5$var$localTimeIntervals[nice]);
            else {
                var interval = nice.interval, step = nice.step;
                var parsedInterval = (isUtc ? $433e1b225311bfe5$var$utcIntervals[interval] : $433e1b225311bfe5$var$localTimeIntervals[interval]).every(step);
                if (parsedInterval != null) timeScale.nice(parsedInterval);
            }
        }
    }
}

});

parcelRegister("iWKJ0", function(module, exports) {
$parcel$export(module.exports, "default", () => $dcb1e35ec47a178a$export$2e2bcd8739ae039);
function $dcb1e35ec47a178a$export$2e2bcd8739ae039(scale, config) {
    if ('padding' in scale && 'padding' in config && typeof config.padding !== 'undefined') scale.padding(config.padding);
    if ('paddingInner' in scale && 'paddingInner' in config && typeof config.paddingInner !== 'undefined') scale.paddingInner(config.paddingInner);
    if ('paddingOuter' in scale && 'paddingOuter' in config && typeof config.paddingOuter !== 'undefined') scale.paddingOuter(config.paddingOuter);
}

});

parcelRegister("gSwrG", function(module, exports) {
$parcel$export(module.exports, "default", () => $c49adb78b9c6b1b5$export$2e2bcd8739ae039);
function $c49adb78b9c6b1b5$export$2e2bcd8739ae039(scale, config) {
    if (config.reverse) {
        var reversedRange = scale.range().slice().reverse();
        if ('padding' in scale) // point and band scales
        scale.range(reversedRange);
        else // the rest
        scale.range(reversedRange);
    }
}

});

parcelRegister("ePFyi", function(module, exports) {
$parcel$export(module.exports, "default", () => $acc60f824bbc3adc$export$2e2bcd8739ae039);

var $3Mkgl = parcelRequire("3Mkgl");

function $acc60f824bbc3adc$export$2e2bcd8739ae039(scale, config) {
    if ('round' in config && typeof config.round !== 'undefined') {
        if (config.round && 'interpolate' in config && typeof config.interpolate !== 'undefined') console.warn("[visx/scale/applyRound] ignoring round: scale config contains round and interpolate. only applying interpolate. config:", config);
        else if ('round' in scale) // for point and band scales
        scale.round(config.round);
        else if ('interpolate' in scale && config.round) // for continuous output scales
        // setting config.round = true
        // is actually setting interpolator to interpolateRound
        // as these scales do not have scale.round() function
        scale.interpolate((0, $3Mkgl.default));
    }
}

});

parcelRegister("niTBZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $0460ce7121b5aa8c$export$2e2bcd8739ae039);
function $0460ce7121b5aa8c$export$2e2bcd8739ae039(scale, config) {
    if ('unknown' in scale && 'unknown' in config && typeof config.unknown !== 'undefined') scale.unknown(config.unknown);
}

});

parcelRegister("u9DVt", function(module, exports) {
$parcel$export(module.exports, "default", () => $05aa4859736c14c2$export$2e2bcd8739ae039);
function $05aa4859736c14c2$export$2e2bcd8739ae039(scale, config) {
    if ('zero' in config && config.zero === true) {
        var domain = scale.domain();
        var a = domain[0], b = domain[1];
        var isDescending = b < a;
        var _ref = isDescending ? [
            b,
            a
        ] : [
            a,
            b
        ], min = _ref[0], max = _ref[1];
        var domainWithZero = [
            Math.min(0, min),
            Math.max(0, max)
        ];
        scale.domain(isDescending ? domainWithZero.reverse() : domainWithZero);
    }
}

});

parcelRegister("114HK", function(module, exports) {
var $0bd988a9efed91d4$var$noop = {
    value: ()=>{}
};
function $0bd988a9efed91d4$var$dispatch() {
    for(var i = 0, n = arguments.length, _ = {}, t; i < n; ++i){
        if (!(t = arguments[i] + "") || t in _ || /[\s.]/.test(t)) throw new Error("illegal type: " + t);
        _[t] = [];
    }
    return new $0bd988a9efed91d4$var$Dispatch(_);
}
function $0bd988a9efed91d4$var$Dispatch(_) {
    this._ = _;
}
function $0bd988a9efed91d4$var$parseTypenames(typenames, types) {
    return typenames.trim().split(/^|\s+/).map(function(t) {
        var name = "", i = t.indexOf(".");
        if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
        if (t && !types.hasOwnProperty(t)) throw new Error("unknown type: " + t);
        return {
            type: t,
            name: name
        };
    });
}
$0bd988a9efed91d4$var$Dispatch.prototype = $0bd988a9efed91d4$var$dispatch.prototype = {
    constructor: $0bd988a9efed91d4$var$Dispatch,
    on: function(typename, callback) {
        var _ = this._, T = $0bd988a9efed91d4$var$parseTypenames(typename + "", _), t, i = -1, n = T.length;
        // If no callback was specified, return the callback of the given type and name.
        if (arguments.length < 2) {
            while(++i < n)if ((t = (typename = T[i]).type) && (t = $0bd988a9efed91d4$var$get(_[t], typename.name))) return t;
            return;
        }
        // If a type was specified, set the callback for the given type and name.
        // Otherwise, if a null callback was specified, remove callbacks of the given name.
        if (callback != null && typeof callback !== "function") throw new Error("invalid callback: " + callback);
        while(++i < n){
            if (t = (typename = T[i]).type) _[t] = $0bd988a9efed91d4$var$set(_[t], typename.name, callback);
            else if (callback == null) for(t in _)_[t] = $0bd988a9efed91d4$var$set(_[t], typename.name, null);
        }
        return this;
    },
    copy: function() {
        var copy = {}, _ = this._;
        for(var t in _)copy[t] = _[t].slice();
        return new $0bd988a9efed91d4$var$Dispatch(copy);
    },
    call: function(type, that) {
        if ((n = arguments.length - 2) > 0) for(var args = new Array(n), i = 0, n, t; i < n; ++i)args[i] = arguments[i + 2];
        if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
        for(t = this._[type], i = 0, n = t.length; i < n; ++i)t[i].value.apply(that, args);
    },
    apply: function(type, that, args) {
        if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
        for(var t = this._[type], i = 0, n = t.length; i < n; ++i)t[i].value.apply(that, args);
    }
};
function $0bd988a9efed91d4$var$get(type, name) {
    for(var i = 0, n = type.length, c; i < n; ++i){
        if ((c = type[i]).name === name) return c.value;
    }
}
function $0bd988a9efed91d4$var$set(type, name, callback) {
    for(var i = 0, n = type.length; i < n; ++i)if (type[i].name === name) {
        type[i] = $0bd988a9efed91d4$var$noop, type = type.slice(0, i).concat(type.slice(i + 1));
        break;
    }
    if (callback != null) type.push({
        name: name,
        value: callback
    });
    return type;
}
var $0bd988a9efed91d4$export$2e2bcd8739ae039 = $0bd988a9efed91d4$var$dispatch;
module.exports["default"] = $0bd988a9efed91d4$export$2e2bcd8739ae039;

});

parcelRegister("kWPfg", function(module, exports) {

var $fD6GM = parcelRequire("fD6GM");


var $bW2jc = parcelRequire("bW2jc");


var $cHbwj = parcelRequire("cHbwj");


var $4CWDw = parcelRequire("4CWDw");


var $1W15W = parcelRequire("1W15W");


var $fmO4W = parcelRequire("fmO4W");


var $lQhCK = parcelRequire("lQhCK");


var $iL6CZ = parcelRequire("iL6CZ");


var $klrzo = parcelRequire("klrzo");


var $5Q9Rs = parcelRequire("5Q9Rs");


var $kZaOC = parcelRequire("kZaOC");


var $dIof9 = parcelRequire("dIof9");


var $lB2gh = parcelRequire("lB2gh");


var $knJ5b = parcelRequire("knJ5b");


var $eNUkl = parcelRequire("eNUkl");


var $hOsVn = parcelRequire("hOsVn");


var $4rBkn = parcelRequire("4rBkn");


var $8rLdU = parcelRequire("8rLdU");


var $7vL0Q = parcelRequire("7vL0Q");


var $fzcnR = parcelRequire("fzcnR");


var $gnwzD = parcelRequire("gnwzD");


var $2fBRw = parcelRequire("2fBRw");


var $9D8wD = parcelRequire("9D8wD");


var $aWan2 = parcelRequire("aWan2");


var $jziEI = parcelRequire("jziEI");


var $7QXYj = parcelRequire("7QXYj");


var $1KLa6 = parcelRequire("1KLa6");


var $bDuSP = parcelRequire("bDuSP");


var $hQqIf = parcelRequire("hQqIf");


var $38Ggx = parcelRequire("38Ggx");


var $0Zxzu = parcelRequire("0Zxzu");


var $9jjFR = parcelRequire("9jjFR");


var $305yy = parcelRequire("305yy");


var $bDl0i = parcelRequire("bDl0i");

var $f400f9a6a385569c$export$e8e78c978b129247 = [
    null
];
function $f400f9a6a385569c$export$52baac22726c72bf(groups, parents) {
    this._groups = groups;
    this._parents = parents;
}
function $f400f9a6a385569c$var$selection() {
    return new $f400f9a6a385569c$export$52baac22726c72bf([
        [
            document.documentElement
        ]
    ], $f400f9a6a385569c$export$e8e78c978b129247);
}
function $f400f9a6a385569c$var$selection_selection() {
    return this;
}
$f400f9a6a385569c$export$52baac22726c72bf.prototype = $f400f9a6a385569c$var$selection.prototype = {
    constructor: $f400f9a6a385569c$export$52baac22726c72bf,
    select: (0, $fD6GM.default),
    selectAll: (0, $bW2jc.default),
    selectChild: (0, $cHbwj.default),
    selectChildren: (0, $4CWDw.default),
    filter: (0, $1W15W.default),
    data: (0, $fmO4W.default),
    enter: (0, $lQhCK.default),
    exit: (0, $iL6CZ.default),
    join: (0, $klrzo.default),
    merge: (0, $5Q9Rs.default),
    selection: $f400f9a6a385569c$var$selection_selection,
    order: (0, $kZaOC.default),
    sort: (0, $dIof9.default),
    call: (0, $lB2gh.default),
    nodes: (0, $knJ5b.default),
    node: (0, $eNUkl.default),
    size: (0, $hOsVn.default),
    empty: (0, $4rBkn.default),
    each: (0, $8rLdU.default),
    attr: (0, $7vL0Q.default),
    style: (0, $fzcnR.default),
    property: (0, $gnwzD.default),
    classed: (0, $2fBRw.default),
    text: (0, $9D8wD.default),
    html: (0, $aWan2.default),
    raise: (0, $jziEI.default),
    lower: (0, $7QXYj.default),
    append: (0, $1KLa6.default),
    insert: (0, $bDuSP.default),
    remove: (0, $hQqIf.default),
    clone: (0, $38Ggx.default),
    datum: (0, $0Zxzu.default),
    on: (0, $9jjFR.default),
    dispatch: (0, $305yy.default),
    [Symbol.iterator]: (0, $bDl0i.default)
};
var $f400f9a6a385569c$export$2e2bcd8739ae039 = $f400f9a6a385569c$var$selection;
module.exports["root"] = $f400f9a6a385569c$export$e8e78c978b129247;
module.exports["Selection"] = $f400f9a6a385569c$export$52baac22726c72bf;
module.exports["default"] = $f400f9a6a385569c$export$2e2bcd8739ae039;

});

parcelRegister("ibDxT", function(module, exports) {
$parcel$export(module.exports, "default", () => $d3d7ee082748109e$export$2e2bcd8739ae039);

var $114HK = parcelRequire("114HK");


var $lV8JW = parcelRequire("lV8JW");

var $i7zWP = parcelRequire("i7zWP");

var $d3d7ee082748109e$var$emptyOn = (0, $114HK.default)("start", "end", "cancel", "interrupt");
var $d3d7ee082748109e$var$emptyTween = [];
var $d3d7ee082748109e$export$ff39ebd4bb12b718 = 0;
var $d3d7ee082748109e$export$584530fe98d14a84 = 1;
var $d3d7ee082748109e$export$a5d151aee16efd42 = 2;
var $d3d7ee082748109e$export$fb935ab5849a0db9 = 3;
var $d3d7ee082748109e$export$1573e22b087389af = 4;
var $d3d7ee082748109e$export$a2e792214ded83b2 = 5;
var $d3d7ee082748109e$export$9d38167254403955 = 6;
function $d3d7ee082748109e$export$2e2bcd8739ae039(node, name, id, index, group, timing) {
    var schedules = node.__transition;
    if (!schedules) node.__transition = {};
    else if (id in schedules) return;
    $d3d7ee082748109e$var$create(node, id, {
        name: name,
        index: index,
        group: group,
        on: $d3d7ee082748109e$var$emptyOn,
        tween: $d3d7ee082748109e$var$emptyTween,
        time: timing.time,
        delay: timing.delay,
        duration: timing.duration,
        ease: timing.ease,
        timer: null,
        state: $d3d7ee082748109e$export$ff39ebd4bb12b718
    });
}
function $d3d7ee082748109e$export$2cd8252107eb640b(node, id) {
    var schedule = $d3d7ee082748109e$export$3988ae62b71be9a3(node, id);
    if (schedule.state > $d3d7ee082748109e$export$ff39ebd4bb12b718) throw new Error("too late; already scheduled");
    return schedule;
}
function $d3d7ee082748109e$export$adaa4cf7ef1b65be(node, id) {
    var schedule = $d3d7ee082748109e$export$3988ae62b71be9a3(node, id);
    if (schedule.state > $d3d7ee082748109e$export$fb935ab5849a0db9) throw new Error("too late; already running");
    return schedule;
}
function $d3d7ee082748109e$export$3988ae62b71be9a3(node, id) {
    var schedule = node.__transition;
    if (!schedule || !(schedule = schedule[id])) throw new Error("transition not found");
    return schedule;
}
function $d3d7ee082748109e$var$create(node, id, self) {
    var schedules = node.__transition, tween;
    // Initialize the self timer when the transition is created.
    // Note the actual delay is not known until the first callback!
    schedules[id] = self;
    self.timer = (0, $i7zWP.timer)(schedule, 0, self.time);
    function schedule(elapsed) {
        self.state = $d3d7ee082748109e$export$584530fe98d14a84;
        self.timer.restart(start, self.delay, self.time);
        // If the elapsed delay is less than our first sleep, start immediately.
        if (self.delay <= elapsed) start(elapsed - self.delay);
    }
    function start(elapsed) {
        var i, j, n, o;
        // If the state is not SCHEDULED, then we previously errored on start.
        if (self.state !== $d3d7ee082748109e$export$584530fe98d14a84) return stop();
        for(i in schedules){
            o = schedules[i];
            if (o.name !== self.name) continue;
            // While this element already has a starting transition during this frame,
            // defer starting an interrupting transition until that transition has a
            // chance to tick (and possibly end); see d3/d3-transition#54!
            if (o.state === $d3d7ee082748109e$export$fb935ab5849a0db9) return (0, $lV8JW.default)(start);
            // Interrupt the active transition, if any.
            if (o.state === $d3d7ee082748109e$export$1573e22b087389af) {
                o.state = $d3d7ee082748109e$export$9d38167254403955;
                o.timer.stop();
                o.on.call("interrupt", node, node.__data__, o.index, o.group);
                delete schedules[i];
            } else if (+i < id) {
                o.state = $d3d7ee082748109e$export$9d38167254403955;
                o.timer.stop();
                o.on.call("cancel", node, node.__data__, o.index, o.group);
                delete schedules[i];
            }
        }
        // Defer the first tick to end of the current frame; see d3/d3#1576.
        // Note the transition may be canceled after start and before the first tick!
        // Note this must be scheduled before the start event; see d3/d3-transition#16!
        // Assuming this is successful, subsequent callbacks go straight to tick.
        (0, $lV8JW.default)(function() {
            if (self.state === $d3d7ee082748109e$export$fb935ab5849a0db9) {
                self.state = $d3d7ee082748109e$export$1573e22b087389af;
                self.timer.restart(tick, self.delay, self.time);
                tick(elapsed);
            }
        });
        // Dispatch the start event.
        // Note this must be done before the tween are initialized.
        self.state = $d3d7ee082748109e$export$a5d151aee16efd42;
        self.on.call("start", node, node.__data__, self.index, self.group);
        if (self.state !== $d3d7ee082748109e$export$a5d151aee16efd42) return; // interrupted
        self.state = $d3d7ee082748109e$export$fb935ab5849a0db9;
        // Initialize the tween, deleting null tween.
        tween = new Array(n = self.tween.length);
        for(i = 0, j = -1; i < n; ++i)if (o = self.tween[i].value.call(node, node.__data__, self.index, self.group)) tween[++j] = o;
        tween.length = j + 1;
    }
    function tick(elapsed) {
        var t = elapsed < self.duration ? self.ease.call(null, elapsed / self.duration) : (self.timer.restart(stop), self.state = $d3d7ee082748109e$export$a2e792214ded83b2, 1), i = -1, n = tween.length;
        while(++i < n)tween[i].call(node, t);
        // Dispatch the end event.
        if (self.state === $d3d7ee082748109e$export$a2e792214ded83b2) {
            self.on.call("end", node, node.__data__, self.index, self.group);
            stop();
        }
    }
    function stop() {
        self.state = $d3d7ee082748109e$export$9d38167254403955;
        self.timer.stop();
        delete schedules[id];
        for(var i in schedules)return; // eslint-disable-line no-unused-vars
        delete node.__transition;
    }
}
module.exports["STARTING"] = $d3d7ee082748109e$export$a5d151aee16efd42;
module.exports["ENDING"] = $d3d7ee082748109e$export$a2e792214ded83b2;
module.exports["ENDED"] = $d3d7ee082748109e$export$9d38167254403955;
module.exports["init"] = $d3d7ee082748109e$export$2cd8252107eb640b;
module.exports["get"] = $d3d7ee082748109e$export$3988ae62b71be9a3;
module.exports["set"] = $d3d7ee082748109e$export$adaa4cf7ef1b65be;

});

parcelRegister("2sQ2T", function(module, exports) {
$parcel$export(module.exports, "default", () => $1cb6917ef5bd949c$export$2e2bcd8739ae039);

var $jvB2H = parcelRequire("jvB2H");


var $bXFEI = parcelRequire("bXFEI");

function $1cb6917ef5bd949c$export$2e2bcd8739ae039(view) {
    var root = view.document.documentElement, selection = (0, $jvB2H.default)(view).on("dragstart.drag", (0, $bXFEI.default), (0, $bXFEI.nonpassivecapture));
    if ("onselectstart" in root) selection.on("selectstart.drag", (0, $bXFEI.default), (0, $bXFEI.nonpassivecapture));
    else {
        root.__noselect = root.style.MozUserSelect;
        root.style.MozUserSelect = "none";
    }
}
function $1cb6917ef5bd949c$export$833237748009e1e1(view, noclick) {
    var root = view.document.documentElement, selection = (0, $jvB2H.default)(view).on("dragstart.drag", null);
    if (noclick) {
        selection.on("click.drag", (0, $bXFEI.default), (0, $bXFEI.nonpassivecapture));
        setTimeout(function() {
            selection.on("click.drag", null);
        }, 0);
    }
    if ("onselectstart" in root) selection.on("selectstart.drag", null);
    else {
        root.style.MozUserSelect = root.__noselect;
        delete root.__noselect;
    }
}
module.exports["yesdrag"] = $1cb6917ef5bd949c$export$833237748009e1e1;

});

parcelRegister("imgG1", function(module, exports) {
$parcel$export(module.exports, "default", () => $d5d737b49a03414d$export$2e2bcd8739ae039);

var $5rNAx = parcelRequire("5rNAx");

function $d5d737b49a03414d$export$2e2bcd8739ae039(event, node) {
    event = (0, $5rNAx.default)(event);
    if (node === undefined) node = event.currentTarget;
    if (node) {
        var svg = node.ownerSVGElement || node;
        if (svg.createSVGPoint) {
            var point = svg.createSVGPoint();
            point.x = event.clientX, point.y = event.clientY;
            point = point.matrixTransform(node.getScreenCTM().inverse());
            return [
                point.x,
                point.y
            ];
        }
        if (node.getBoundingClientRect) {
            var rect = node.getBoundingClientRect();
            return [
                event.clientX - rect.left - node.clientLeft,
                event.clientY - rect.top - node.clientTop
            ];
        }
    }
    return [
        event.pageX,
        event.pageY
    ];
}

});

parcelRegister("jvB2H", function(module, exports) {
$parcel$export(module.exports, "default", () => $e33da573f71f5ea9$export$2e2bcd8739ae039);

var $kWPfg = parcelRequire("kWPfg");

function $e33da573f71f5ea9$export$2e2bcd8739ae039(selector) {
    return typeof selector === "string" ? new (0, $kWPfg.Selection)([
        [
            document.querySelector(selector)
        ]
    ], [
        document.documentElement
    ]) : new (0, $kWPfg.Selection)([
        [
            selector
        ]
    ], (0, $kWPfg.root));
}

});

parcelRegister("7LxXr", function(module, exports) {
$parcel$export(module.exports, "default", () => $5a7743765411e69a$export$2e2bcd8739ae039);

var $fOwio = parcelRequire("fOwio");

var $8IfoZ = parcelRequire("8IfoZ");

var $aXzLK = parcelRequire("aXzLK");

var $5AGeG = parcelRequire("5AGeG");

var $fdjUQ = parcelRequire("fdjUQ");

var $5a7743765411e69a$var$interpolatorMap = {
    lab: (0, $5AGeG.default),
    hcl: (0, $8IfoZ.default),
    'hcl-long': (0, $8IfoZ.hclLong),
    hsl: (0, $aXzLK.default),
    'hsl-long': (0, $aXzLK.hslLong),
    cubehelix: (0, $fOwio.default),
    'cubehelix-long': (0, $fOwio.cubehelixLong),
    rgb: (0, $fdjUQ.default)
};
function $5a7743765411e69a$export$2e2bcd8739ae039(interpolate) {
    switch(interpolate){
        case 'lab':
        case 'hcl':
        case 'hcl-long':
        case 'hsl':
        case 'hsl-long':
        case 'cubehelix':
        case 'cubehelix-long':
        case 'rgb':
            return $5a7743765411e69a$var$interpolatorMap[interpolate];
        default:
    }
    var type = interpolate.type, gamma = interpolate.gamma;
    var interpolator = $5a7743765411e69a$var$interpolatorMap[type];
    return typeof gamma === 'undefined' ? interpolator : interpolator.gamma(gamma);
}

});

parcelRegister("K7JGK", function(module, exports) {
$parcel$export(module.exports, "default", () => $08aa4c2ef57b456b$export$2e2bcd8739ae039);
var $08aa4c2ef57b456b$var$TEST_TIME = new Date(Date.UTC(2020, 1, 2, 3, 4, 5));
var $08aa4c2ef57b456b$var$TEST_FORMAT = '%Y-%m-%d %H:%M';
function $08aa4c2ef57b456b$export$2e2bcd8739ae039(scale) {
    // The only difference between time and utc scale is
    // whether the tick format function is utcFormat or timeFormat
    var output = scale.tickFormat(1, $08aa4c2ef57b456b$var$TEST_FORMAT)($08aa4c2ef57b456b$var$TEST_TIME);
    return output === '2020-02-02 03:04';
}

});

parcelRegister("fD6GM", function(module, exports) {
$parcel$export(module.exports, "default", () => $b60fafce27deaaf8$export$2e2bcd8739ae039);

var $kWPfg = parcelRequire("kWPfg");


var $4PaSL = parcelRequire("4PaSL");

function $b60fafce27deaaf8$export$2e2bcd8739ae039(select) {
    if (typeof select !== "function") select = (0, $4PaSL.default)(select);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i)if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
            if ("__data__" in node) subnode.__data__ = node.__data__;
            subgroup[i] = subnode;
        }
    }
    return new (0, $kWPfg.Selection)(subgroups, this._parents);
}

});

parcelRegister("bW2jc", function(module, exports) {
$parcel$export(module.exports, "default", () => $8b06e6f0a816b4cd$export$2e2bcd8739ae039);

var $kWPfg = parcelRequire("kWPfg");


var $d7CCZ = parcelRequire("d7CCZ");


var $g3K2y = parcelRequire("g3K2y");

function $8b06e6f0a816b4cd$var$arrayAll(select) {
    return function() {
        return (0, $d7CCZ.default)(select.apply(this, arguments));
    };
}
function $8b06e6f0a816b4cd$export$2e2bcd8739ae039(select) {
    if (typeof select === "function") select = $8b06e6f0a816b4cd$var$arrayAll(select);
    else select = (0, $g3K2y.default)(select);
    for(var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) {
            subgroups.push(select.call(node, node.__data__, i, group));
            parents.push(node);
        }
    }
    return new (0, $kWPfg.Selection)(subgroups, parents);
}

});

parcelRegister("cHbwj", function(module, exports) {
$parcel$export(module.exports, "default", () => $93e26fe0e3cd0bb5$export$2e2bcd8739ae039);

var $9B7Qm = parcelRequire("9B7Qm");

var $93e26fe0e3cd0bb5$var$find = Array.prototype.find;
function $93e26fe0e3cd0bb5$var$childFind(match) {
    return function() {
        return $93e26fe0e3cd0bb5$var$find.call(this.children, match);
    };
}
function $93e26fe0e3cd0bb5$var$childFirst() {
    return this.firstElementChild;
}
function $93e26fe0e3cd0bb5$export$2e2bcd8739ae039(match) {
    return this.select(match == null ? $93e26fe0e3cd0bb5$var$childFirst : $93e26fe0e3cd0bb5$var$childFind(typeof match === "function" ? match : (0, $9B7Qm.childMatcher)(match)));
}

});

parcelRegister("4CWDw", function(module, exports) {
$parcel$export(module.exports, "default", () => $35e832031af6ae7e$export$2e2bcd8739ae039);

var $9B7Qm = parcelRequire("9B7Qm");

var $35e832031af6ae7e$var$filter = Array.prototype.filter;
function $35e832031af6ae7e$var$children() {
    return Array.from(this.children);
}
function $35e832031af6ae7e$var$childrenFilter(match) {
    return function() {
        return $35e832031af6ae7e$var$filter.call(this.children, match);
    };
}
function $35e832031af6ae7e$export$2e2bcd8739ae039(match) {
    return this.selectAll(match == null ? $35e832031af6ae7e$var$children : $35e832031af6ae7e$var$childrenFilter(typeof match === "function" ? match : (0, $9B7Qm.childMatcher)(match)));
}

});

parcelRegister("1W15W", function(module, exports) {
$parcel$export(module.exports, "default", () => $168c0e9e76009167$export$2e2bcd8739ae039);

var $kWPfg = parcelRequire("kWPfg");


var $9B7Qm = parcelRequire("9B7Qm");

function $168c0e9e76009167$export$2e2bcd8739ae039(match) {
    if (typeof match !== "function") match = (0, $9B7Qm.default)(match);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i)if ((node = group[i]) && match.call(node, node.__data__, i, group)) subgroup.push(node);
    }
    return new (0, $kWPfg.Selection)(subgroups, this._parents);
}

});

parcelRegister("fmO4W", function(module, exports) {
$parcel$export(module.exports, "default", () => $b2ffc1aed51412a0$export$2e2bcd8739ae039);

var $kWPfg = parcelRequire("kWPfg");


var $lQhCK = parcelRequire("lQhCK");


var $fBk0q = parcelRequire("fBk0q");

function $b2ffc1aed51412a0$var$bindIndex(parent, group, enter, update, exit, data) {
    var i = 0, node, groupLength = group.length, dataLength = data.length;
    // Put any non-null nodes that fit into update.
    // Put any null nodes into enter.
    // Put any remaining data into enter.
    for(; i < dataLength; ++i)if (node = group[i]) {
        node.__data__ = data[i];
        update[i] = node;
    } else enter[i] = new (0, $lQhCK.EnterNode)(parent, data[i]);
    // Put any non-null nodes that don’t fit into exit.
    for(; i < groupLength; ++i)if (node = group[i]) exit[i] = node;
}
function $b2ffc1aed51412a0$var$bindKey(parent, group, enter, update, exit, data, key) {
    var i, node, nodeByKeyValue = new Map, groupLength = group.length, dataLength = data.length, keyValues = new Array(groupLength), keyValue;
    // Compute the key for each node.
    // If multiple nodes have the same key, the duplicates are added to exit.
    for(i = 0; i < groupLength; ++i)if (node = group[i]) {
        keyValues[i] = keyValue = key.call(node, node.__data__, i, group) + "";
        if (nodeByKeyValue.has(keyValue)) exit[i] = node;
        else nodeByKeyValue.set(keyValue, node);
    }
    // Compute the key for each datum.
    // If there a node associated with this key, join and add it to update.
    // If there is not (or the key is a duplicate), add it to enter.
    for(i = 0; i < dataLength; ++i){
        keyValue = key.call(parent, data[i], i, data) + "";
        if (node = nodeByKeyValue.get(keyValue)) {
            update[i] = node;
            node.__data__ = data[i];
            nodeByKeyValue.delete(keyValue);
        } else enter[i] = new (0, $lQhCK.EnterNode)(parent, data[i]);
    }
    // Add any remaining nodes that were not bound to data to exit.
    for(i = 0; i < groupLength; ++i)if ((node = group[i]) && nodeByKeyValue.get(keyValues[i]) === node) exit[i] = node;
}
function $b2ffc1aed51412a0$var$datum(node) {
    return node.__data__;
}
function $b2ffc1aed51412a0$export$2e2bcd8739ae039(value, key) {
    if (!arguments.length) return Array.from(this, $b2ffc1aed51412a0$var$datum);
    var bind = key ? $b2ffc1aed51412a0$var$bindKey : $b2ffc1aed51412a0$var$bindIndex, parents = this._parents, groups = this._groups;
    if (typeof value !== "function") value = (0, $fBk0q.default)(value);
    for(var m = groups.length, update = new Array(m), enter = new Array(m), exit = new Array(m), j = 0; j < m; ++j){
        var parent = parents[j], group = groups[j], groupLength = group.length, data = $b2ffc1aed51412a0$var$arraylike(value.call(parent, parent && parent.__data__, j, parents)), dataLength = data.length, enterGroup = enter[j] = new Array(dataLength), updateGroup = update[j] = new Array(dataLength), exitGroup = exit[j] = new Array(groupLength);
        bind(parent, group, enterGroup, updateGroup, exitGroup, data, key);
        // Now connect the enter nodes to their following update node, such that
        // appendChild can insert the materialized enter node before this node,
        // rather than at the end of the parent node.
        for(var i0 = 0, i1 = 0, previous, next; i0 < dataLength; ++i0)if (previous = enterGroup[i0]) {
            if (i0 >= i1) i1 = i0 + 1;
            while(!(next = updateGroup[i1]) && ++i1 < dataLength);
            previous._next = next || null;
        }
    }
    update = new (0, $kWPfg.Selection)(update, parents);
    update._enter = enter;
    update._exit = exit;
    return update;
}
// Given some data, this returns an array-like view of it: an object that
// exposes a length property and allows numeric indexing. Note that unlike
// selectAll, this isn’t worried about “live” collections because the resulting
// array will only be used briefly while data is being bound. (It is possible to
// cause the data to change while iterating by using a key function, but please
// don’t; we’d rather avoid a gratuitous copy.)
function $b2ffc1aed51412a0$var$arraylike(data) {
    return typeof data === "object" && "length" in data ? data // Array, TypedArray, NodeList, array-like
     : Array.from(data); // Map, Set, iterable, string, or anything else
}

});

parcelRegister("lQhCK", function(module, exports) {
$parcel$export(module.exports, "default", () => $fe6c2014a009a3af$export$2e2bcd8739ae039);

var $7nxbF = parcelRequire("7nxbF");


var $kWPfg = parcelRequire("kWPfg");

function $fe6c2014a009a3af$export$2e2bcd8739ae039() {
    return new (0, $kWPfg.Selection)(this._enter || this._groups.map((0, $7nxbF.default)), this._parents);
}
function $fe6c2014a009a3af$export$67b01759a14cf6a4(parent, datum) {
    this.ownerDocument = parent.ownerDocument;
    this.namespaceURI = parent.namespaceURI;
    this._next = null;
    this._parent = parent;
    this.__data__ = datum;
}
$fe6c2014a009a3af$export$67b01759a14cf6a4.prototype = {
    constructor: $fe6c2014a009a3af$export$67b01759a14cf6a4,
    appendChild: function(child) {
        return this._parent.insertBefore(child, this._next);
    },
    insertBefore: function(child, next) {
        return this._parent.insertBefore(child, next);
    },
    querySelector: function(selector) {
        return this._parent.querySelector(selector);
    },
    querySelectorAll: function(selector) {
        return this._parent.querySelectorAll(selector);
    }
};
module.exports["EnterNode"] = $fe6c2014a009a3af$export$67b01759a14cf6a4;

});

parcelRegister("iL6CZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $da81c1f1a7bd2565$export$2e2bcd8739ae039);

var $7nxbF = parcelRequire("7nxbF");


var $kWPfg = parcelRequire("kWPfg");

function $da81c1f1a7bd2565$export$2e2bcd8739ae039() {
    return new (0, $kWPfg.Selection)(this._exit || this._groups.map((0, $7nxbF.default)), this._parents);
}

});

parcelRegister("klrzo", function(module, exports) {
$parcel$export(module.exports, "default", () => $ecfb279b4d22f353$export$2e2bcd8739ae039);
function $ecfb279b4d22f353$export$2e2bcd8739ae039(onenter, onupdate, onexit) {
    var enter = this.enter(), update = this, exit = this.exit();
    if (typeof onenter === "function") {
        enter = onenter(enter);
        if (enter) enter = enter.selection();
    } else enter = enter.append(onenter + "");
    if (onupdate != null) {
        update = onupdate(update);
        if (update) update = update.selection();
    }
    if (onexit == null) exit.remove();
    else onexit(exit);
    return enter && update ? enter.merge(update).order() : update;
}

});

parcelRegister("5Q9Rs", function(module, exports) {
$parcel$export(module.exports, "default", () => $4409754a3ccf823e$export$2e2bcd8739ae039);

var $kWPfg = parcelRequire("kWPfg");

function $4409754a3ccf823e$export$2e2bcd8739ae039(context) {
    var selection = context.selection ? context.selection() : context;
    for(var groups0 = this._groups, groups1 = selection._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j){
        for(var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group0[i] || group1[i]) merge[i] = node;
    }
    for(; j < m0; ++j)merges[j] = groups0[j];
    return new (0, $kWPfg.Selection)(merges, this._parents);
}

});

parcelRegister("kZaOC", function(module, exports) {
$parcel$export(module.exports, "default", () => $f471e4e30935ff38$export$2e2bcd8739ae039);
function $f471e4e30935ff38$export$2e2bcd8739ae039() {
    for(var groups = this._groups, j = -1, m = groups.length; ++j < m;){
        for(var group = groups[j], i = group.length - 1, next = group[i], node; --i >= 0;)if (node = group[i]) {
            if (next && node.compareDocumentPosition(next) ^ 4) next.parentNode.insertBefore(node, next);
            next = node;
        }
    }
    return this;
}

});

parcelRegister("dIof9", function(module, exports) {
$parcel$export(module.exports, "default", () => $9fc230ac1e399343$export$2e2bcd8739ae039);

var $kWPfg = parcelRequire("kWPfg");

function $9fc230ac1e399343$export$2e2bcd8739ae039(compare) {
    if (!compare) compare = $9fc230ac1e399343$var$ascending;
    function compareNode(a, b) {
        return a && b ? compare(a.__data__, b.__data__) : !a - !b;
    }
    for(var groups = this._groups, m = groups.length, sortgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, sortgroup = sortgroups[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group[i]) sortgroup[i] = node;
        sortgroup.sort(compareNode);
    }
    return new (0, $kWPfg.Selection)(sortgroups, this._parents).order();
}
function $9fc230ac1e399343$var$ascending(a, b) {
    return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}

});

parcelRegister("lB2gh", function(module, exports) {
$parcel$export(module.exports, "default", () => $fb8ecec3719cb775$export$2e2bcd8739ae039);
function $fb8ecec3719cb775$export$2e2bcd8739ae039() {
    var callback = arguments[0];
    arguments[0] = this;
    callback.apply(null, arguments);
    return this;
}

});

parcelRegister("knJ5b", function(module, exports) {
$parcel$export(module.exports, "default", () => $ed68ed14366cd238$export$2e2bcd8739ae039);
function $ed68ed14366cd238$export$2e2bcd8739ae039() {
    return Array.from(this);
}

});

parcelRegister("eNUkl", function(module, exports) {
$parcel$export(module.exports, "default", () => $ac7155b3da306c6f$export$2e2bcd8739ae039);
function $ac7155b3da306c6f$export$2e2bcd8739ae039() {
    for(var groups = this._groups, j = 0, m = groups.length; j < m; ++j)for(var group = groups[j], i = 0, n = group.length; i < n; ++i){
        var node = group[i];
        if (node) return node;
    }
    return null;
}

});

parcelRegister("hOsVn", function(module, exports) {
$parcel$export(module.exports, "default", () => $cf7d8af68ce2f1e4$export$2e2bcd8739ae039);
function $cf7d8af68ce2f1e4$export$2e2bcd8739ae039() {
    let size = 0;
    for (const node of this)++size; // eslint-disable-line no-unused-vars
    return size;
}

});

parcelRegister("4rBkn", function(module, exports) {
$parcel$export(module.exports, "default", () => $33c6a3894fec91ad$export$2e2bcd8739ae039);
function $33c6a3894fec91ad$export$2e2bcd8739ae039() {
    return !this.node();
}

});

parcelRegister("8rLdU", function(module, exports) {
$parcel$export(module.exports, "default", () => $626579e9ec570768$export$2e2bcd8739ae039);
function $626579e9ec570768$export$2e2bcd8739ae039(callback) {
    for(var groups = this._groups, j = 0, m = groups.length; j < m; ++j){
        for(var group = groups[j], i = 0, n = group.length, node; i < n; ++i)if (node = group[i]) callback.call(node, node.__data__, i, group);
    }
    return this;
}

});

parcelRegister("7vL0Q", function(module, exports) {
$parcel$export(module.exports, "default", () => $577fe564a0e176ec$export$2e2bcd8739ae039);

var $1IOzU = parcelRequire("1IOzU");

function $577fe564a0e176ec$var$attrRemove(name) {
    return function() {
        this.removeAttribute(name);
    };
}
function $577fe564a0e176ec$var$attrRemoveNS(fullname) {
    return function() {
        this.removeAttributeNS(fullname.space, fullname.local);
    };
}
function $577fe564a0e176ec$var$attrConstant(name, value) {
    return function() {
        this.setAttribute(name, value);
    };
}
function $577fe564a0e176ec$var$attrConstantNS(fullname, value) {
    return function() {
        this.setAttributeNS(fullname.space, fullname.local, value);
    };
}
function $577fe564a0e176ec$var$attrFunction(name, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.removeAttribute(name);
        else this.setAttribute(name, v);
    };
}
function $577fe564a0e176ec$var$attrFunctionNS(fullname, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.removeAttributeNS(fullname.space, fullname.local);
        else this.setAttributeNS(fullname.space, fullname.local, v);
    };
}
function $577fe564a0e176ec$export$2e2bcd8739ae039(name, value) {
    var fullname = (0, $1IOzU.default)(name);
    if (arguments.length < 2) {
        var node = this.node();
        return fullname.local ? node.getAttributeNS(fullname.space, fullname.local) : node.getAttribute(fullname);
    }
    return this.each((value == null ? fullname.local ? $577fe564a0e176ec$var$attrRemoveNS : $577fe564a0e176ec$var$attrRemove : typeof value === "function" ? fullname.local ? $577fe564a0e176ec$var$attrFunctionNS : $577fe564a0e176ec$var$attrFunction : fullname.local ? $577fe564a0e176ec$var$attrConstantNS : $577fe564a0e176ec$var$attrConstant)(fullname, value));
}

});

parcelRegister("fzcnR", function(module, exports) {
$parcel$export(module.exports, "default", () => $b553bb12cf1674dd$export$2e2bcd8739ae039);

var $cREL1 = parcelRequire("cREL1");

function $b553bb12cf1674dd$var$styleRemove(name) {
    return function() {
        this.style.removeProperty(name);
    };
}
function $b553bb12cf1674dd$var$styleConstant(name, value, priority) {
    return function() {
        this.style.setProperty(name, value, priority);
    };
}
function $b553bb12cf1674dd$var$styleFunction(name, value, priority) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.style.removeProperty(name);
        else this.style.setProperty(name, v, priority);
    };
}
function $b553bb12cf1674dd$export$2e2bcd8739ae039(name, value, priority) {
    return arguments.length > 1 ? this.each((value == null ? $b553bb12cf1674dd$var$styleRemove : typeof value === "function" ? $b553bb12cf1674dd$var$styleFunction : $b553bb12cf1674dd$var$styleConstant)(name, value, priority == null ? "" : priority)) : $b553bb12cf1674dd$export$5e3cec964f0b5efd(this.node(), name);
}
function $b553bb12cf1674dd$export$5e3cec964f0b5efd(node, name) {
    return node.style.getPropertyValue(name) || (0, $cREL1.default)(node).getComputedStyle(node, null).getPropertyValue(name);
}
module.exports["styleValue"] = $b553bb12cf1674dd$export$5e3cec964f0b5efd;

});

parcelRegister("gnwzD", function(module, exports) {
$parcel$export(module.exports, "default", () => $bec80fcc5a38cd31$export$2e2bcd8739ae039);
function $bec80fcc5a38cd31$var$propertyRemove(name) {
    return function() {
        delete this[name];
    };
}
function $bec80fcc5a38cd31$var$propertyConstant(name, value) {
    return function() {
        this[name] = value;
    };
}
function $bec80fcc5a38cd31$var$propertyFunction(name, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) delete this[name];
        else this[name] = v;
    };
}
function $bec80fcc5a38cd31$export$2e2bcd8739ae039(name, value) {
    return arguments.length > 1 ? this.each((value == null ? $bec80fcc5a38cd31$var$propertyRemove : typeof value === "function" ? $bec80fcc5a38cd31$var$propertyFunction : $bec80fcc5a38cd31$var$propertyConstant)(name, value)) : this.node()[name];
}

});

parcelRegister("2fBRw", function(module, exports) {
$parcel$export(module.exports, "default", () => $1a3a5a2143af0255$export$2e2bcd8739ae039);
function $1a3a5a2143af0255$var$classArray(string) {
    return string.trim().split(/^|\s+/);
}
function $1a3a5a2143af0255$var$classList(node) {
    return node.classList || new $1a3a5a2143af0255$var$ClassList(node);
}
function $1a3a5a2143af0255$var$ClassList(node) {
    this._node = node;
    this._names = $1a3a5a2143af0255$var$classArray(node.getAttribute("class") || "");
}
$1a3a5a2143af0255$var$ClassList.prototype = {
    add: function(name) {
        var i = this._names.indexOf(name);
        if (i < 0) {
            this._names.push(name);
            this._node.setAttribute("class", this._names.join(" "));
        }
    },
    remove: function(name) {
        var i = this._names.indexOf(name);
        if (i >= 0) {
            this._names.splice(i, 1);
            this._node.setAttribute("class", this._names.join(" "));
        }
    },
    contains: function(name) {
        return this._names.indexOf(name) >= 0;
    }
};
function $1a3a5a2143af0255$var$classedAdd(node, names) {
    var list = $1a3a5a2143af0255$var$classList(node), i = -1, n = names.length;
    while(++i < n)list.add(names[i]);
}
function $1a3a5a2143af0255$var$classedRemove(node, names) {
    var list = $1a3a5a2143af0255$var$classList(node), i = -1, n = names.length;
    while(++i < n)list.remove(names[i]);
}
function $1a3a5a2143af0255$var$classedTrue(names) {
    return function() {
        $1a3a5a2143af0255$var$classedAdd(this, names);
    };
}
function $1a3a5a2143af0255$var$classedFalse(names) {
    return function() {
        $1a3a5a2143af0255$var$classedRemove(this, names);
    };
}
function $1a3a5a2143af0255$var$classedFunction(names, value) {
    return function() {
        (value.apply(this, arguments) ? $1a3a5a2143af0255$var$classedAdd : $1a3a5a2143af0255$var$classedRemove)(this, names);
    };
}
function $1a3a5a2143af0255$export$2e2bcd8739ae039(name, value) {
    var names = $1a3a5a2143af0255$var$classArray(name + "");
    if (arguments.length < 2) {
        var list = $1a3a5a2143af0255$var$classList(this.node()), i = -1, n = names.length;
        while(++i < n)if (!list.contains(names[i])) return false;
        return true;
    }
    return this.each((typeof value === "function" ? $1a3a5a2143af0255$var$classedFunction : value ? $1a3a5a2143af0255$var$classedTrue : $1a3a5a2143af0255$var$classedFalse)(names, value));
}

});

parcelRegister("9D8wD", function(module, exports) {
$parcel$export(module.exports, "default", () => $702e5e85ea0bd36e$export$2e2bcd8739ae039);
function $702e5e85ea0bd36e$var$textRemove() {
    this.textContent = "";
}
function $702e5e85ea0bd36e$var$textConstant(value) {
    return function() {
        this.textContent = value;
    };
}
function $702e5e85ea0bd36e$var$textFunction(value) {
    return function() {
        var v = value.apply(this, arguments);
        this.textContent = v == null ? "" : v;
    };
}
function $702e5e85ea0bd36e$export$2e2bcd8739ae039(value) {
    return arguments.length ? this.each(value == null ? $702e5e85ea0bd36e$var$textRemove : (typeof value === "function" ? $702e5e85ea0bd36e$var$textFunction : $702e5e85ea0bd36e$var$textConstant)(value)) : this.node().textContent;
}

});

parcelRegister("aWan2", function(module, exports) {
$parcel$export(module.exports, "default", () => $7f675d8ac111e065$export$2e2bcd8739ae039);
function $7f675d8ac111e065$var$htmlRemove() {
    this.innerHTML = "";
}
function $7f675d8ac111e065$var$htmlConstant(value) {
    return function() {
        this.innerHTML = value;
    };
}
function $7f675d8ac111e065$var$htmlFunction(value) {
    return function() {
        var v = value.apply(this, arguments);
        this.innerHTML = v == null ? "" : v;
    };
}
function $7f675d8ac111e065$export$2e2bcd8739ae039(value) {
    return arguments.length ? this.each(value == null ? $7f675d8ac111e065$var$htmlRemove : (typeof value === "function" ? $7f675d8ac111e065$var$htmlFunction : $7f675d8ac111e065$var$htmlConstant)(value)) : this.node().innerHTML;
}

});

parcelRegister("jziEI", function(module, exports) {
$parcel$export(module.exports, "default", () => $e3efc1d85ec4f646$export$2e2bcd8739ae039);
function $e3efc1d85ec4f646$var$raise() {
    if (this.nextSibling) this.parentNode.appendChild(this);
}
function $e3efc1d85ec4f646$export$2e2bcd8739ae039() {
    return this.each($e3efc1d85ec4f646$var$raise);
}

});

parcelRegister("7QXYj", function(module, exports) {
$parcel$export(module.exports, "default", () => $5b7be8e28620505a$export$2e2bcd8739ae039);
function $5b7be8e28620505a$var$lower() {
    if (this.previousSibling) this.parentNode.insertBefore(this, this.parentNode.firstChild);
}
function $5b7be8e28620505a$export$2e2bcd8739ae039() {
    return this.each($5b7be8e28620505a$var$lower);
}

});

parcelRegister("1KLa6", function(module, exports) {
$parcel$export(module.exports, "default", () => $146eabba64e96bbd$export$2e2bcd8739ae039);

var $4e7Ob = parcelRequire("4e7Ob");

function $146eabba64e96bbd$export$2e2bcd8739ae039(name) {
    var create = typeof name === "function" ? name : (0, $4e7Ob.default)(name);
    return this.select(function() {
        return this.appendChild(create.apply(this, arguments));
    });
}

});

parcelRegister("bDuSP", function(module, exports) {
$parcel$export(module.exports, "default", () => $878b4b039ae77d7e$export$2e2bcd8739ae039);

var $4e7Ob = parcelRequire("4e7Ob");


var $4PaSL = parcelRequire("4PaSL");

function $878b4b039ae77d7e$var$constantNull() {
    return null;
}
function $878b4b039ae77d7e$export$2e2bcd8739ae039(name, before) {
    var create = typeof name === "function" ? name : (0, $4e7Ob.default)(name), select = before == null ? $878b4b039ae77d7e$var$constantNull : typeof before === "function" ? before : (0, $4PaSL.default)(before);
    return this.select(function() {
        return this.insertBefore(create.apply(this, arguments), select.apply(this, arguments) || null);
    });
}

});

parcelRegister("hQqIf", function(module, exports) {
$parcel$export(module.exports, "default", () => $cfdc0394d3c419a3$export$2e2bcd8739ae039);
function $cfdc0394d3c419a3$var$remove() {
    var parent = this.parentNode;
    if (parent) parent.removeChild(this);
}
function $cfdc0394d3c419a3$export$2e2bcd8739ae039() {
    return this.each($cfdc0394d3c419a3$var$remove);
}

});

parcelRegister("38Ggx", function(module, exports) {
$parcel$export(module.exports, "default", () => $2492e7861ad7001a$export$2e2bcd8739ae039);
function $2492e7861ad7001a$var$selection_cloneShallow() {
    var clone = this.cloneNode(false), parent = this.parentNode;
    return parent ? parent.insertBefore(clone, this.nextSibling) : clone;
}
function $2492e7861ad7001a$var$selection_cloneDeep() {
    var clone = this.cloneNode(true), parent = this.parentNode;
    return parent ? parent.insertBefore(clone, this.nextSibling) : clone;
}
function $2492e7861ad7001a$export$2e2bcd8739ae039(deep) {
    return this.select(deep ? $2492e7861ad7001a$var$selection_cloneDeep : $2492e7861ad7001a$var$selection_cloneShallow);
}

});

parcelRegister("0Zxzu", function(module, exports) {
$parcel$export(module.exports, "default", () => $002fbcdba7226103$export$2e2bcd8739ae039);
function $002fbcdba7226103$export$2e2bcd8739ae039(value) {
    return arguments.length ? this.property("__data__", value) : this.node().__data__;
}

});

parcelRegister("9jjFR", function(module, exports) {
$parcel$export(module.exports, "default", () => $01bfd332b328b85d$export$2e2bcd8739ae039);
function $01bfd332b328b85d$var$contextListener(listener) {
    return function(event) {
        listener.call(this, event, this.__data__);
    };
}
function $01bfd332b328b85d$var$parseTypenames(typenames) {
    return typenames.trim().split(/^|\s+/).map(function(t) {
        var name = "", i = t.indexOf(".");
        if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
        return {
            type: t,
            name: name
        };
    });
}
function $01bfd332b328b85d$var$onRemove(typename) {
    return function() {
        var on = this.__on;
        if (!on) return;
        for(var j = 0, i = -1, m = on.length, o; j < m; ++j)if (o = on[j], (!typename.type || o.type === typename.type) && o.name === typename.name) this.removeEventListener(o.type, o.listener, o.options);
        else on[++i] = o;
        if (++i) on.length = i;
        else delete this.__on;
    };
}
function $01bfd332b328b85d$var$onAdd(typename, value, options) {
    return function() {
        var on = this.__on, o, listener = $01bfd332b328b85d$var$contextListener(value);
        if (on) {
            for(var j = 0, m = on.length; j < m; ++j)if ((o = on[j]).type === typename.type && o.name === typename.name) {
                this.removeEventListener(o.type, o.listener, o.options);
                this.addEventListener(o.type, o.listener = listener, o.options = options);
                o.value = value;
                return;
            }
        }
        this.addEventListener(typename.type, listener, options);
        o = {
            type: typename.type,
            name: typename.name,
            value: value,
            listener: listener,
            options: options
        };
        if (!on) this.__on = [
            o
        ];
        else on.push(o);
    };
}
function $01bfd332b328b85d$export$2e2bcd8739ae039(typename, value, options) {
    var typenames = $01bfd332b328b85d$var$parseTypenames(typename + ""), i, n = typenames.length, t;
    if (arguments.length < 2) {
        var on = this.node().__on;
        if (on) for(var j = 0, m = on.length, o; j < m; ++j)for(i = 0, o = on[j]; i < n; ++i){
            if ((t = typenames[i]).type === o.type && t.name === o.name) return o.value;
        }
        return;
    }
    on = value ? $01bfd332b328b85d$var$onAdd : $01bfd332b328b85d$var$onRemove;
    for(i = 0; i < n; ++i)this.each(on(typenames[i], value, options));
    return this;
}

});

parcelRegister("305yy", function(module, exports) {
$parcel$export(module.exports, "default", () => $22f5ae8c06b9cc00$export$2e2bcd8739ae039);

var $cREL1 = parcelRequire("cREL1");

function $22f5ae8c06b9cc00$var$dispatchEvent(node, type, params) {
    var window = (0, $cREL1.default)(node), event = window.CustomEvent;
    if (typeof event === "function") event = new event(type, params);
    else {
        event = window.document.createEvent("Event");
        if (params) event.initEvent(type, params.bubbles, params.cancelable), event.detail = params.detail;
        else event.initEvent(type, false, false);
    }
    node.dispatchEvent(event);
}
function $22f5ae8c06b9cc00$var$dispatchConstant(type, params) {
    return function() {
        return $22f5ae8c06b9cc00$var$dispatchEvent(this, type, params);
    };
}
function $22f5ae8c06b9cc00$var$dispatchFunction(type, params) {
    return function() {
        return $22f5ae8c06b9cc00$var$dispatchEvent(this, type, params.apply(this, arguments));
    };
}
function $22f5ae8c06b9cc00$export$2e2bcd8739ae039(type, params) {
    return this.each((typeof params === "function" ? $22f5ae8c06b9cc00$var$dispatchFunction : $22f5ae8c06b9cc00$var$dispatchConstant)(type, params));
}

});

parcelRegister("bDl0i", function(module, exports) {
$parcel$export(module.exports, "default", () => $8783a1251644c730$export$2e2bcd8739ae039);
function* $8783a1251644c730$export$2e2bcd8739ae039() {
    for(var groups = this._groups, j = 0, m = groups.length; j < m; ++j){
        for(var group = groups[j], i = 0, n = group.length, node; i < n; ++i)if (node = group[i]) yield node;
    }
}

});

parcelRegister("lV8JW", function(module, exports) {
$parcel$export(module.exports, "default", () => $ff55b368ad4a48f5$export$2e2bcd8739ae039);

var $i7zWP = parcelRequire("i7zWP");

function $ff55b368ad4a48f5$export$2e2bcd8739ae039(callback, delay, time) {
    var t = new (0, $i7zWP.Timer);
    delay = delay == null ? 0 : +delay;
    t.restart((elapsed)=>{
        t.stop();
        callback(elapsed + delay);
    }, delay, time);
    return t;
}

});

parcelRegister("i7zWP", function(module, exports) {
var $03678f8c0b215133$var$frame = 0, $03678f8c0b215133$var$timeout = 0, $03678f8c0b215133$var$interval = 0, $03678f8c0b215133$var$pokeDelay = 1000, $03678f8c0b215133$var$taskHead, $03678f8c0b215133$var$taskTail, $03678f8c0b215133$var$clockLast = 0, $03678f8c0b215133$var$clockNow = 0, $03678f8c0b215133$var$clockSkew = 0, $03678f8c0b215133$var$clock = typeof performance === "object" && performance.now ? performance : Date, $03678f8c0b215133$var$setFrame = typeof window === "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(f) {
    setTimeout(f, 17);
};
function $03678f8c0b215133$export$461939dd4422153() {
    return $03678f8c0b215133$var$clockNow || ($03678f8c0b215133$var$setFrame($03678f8c0b215133$var$clearNow), $03678f8c0b215133$var$clockNow = $03678f8c0b215133$var$clock.now() + $03678f8c0b215133$var$clockSkew);
}
function $03678f8c0b215133$var$clearNow() {
    $03678f8c0b215133$var$clockNow = 0;
}
function $03678f8c0b215133$export$c57e9b2d8b9e4de() {
    this._call = this._time = this._next = null;
}
$03678f8c0b215133$export$c57e9b2d8b9e4de.prototype = $03678f8c0b215133$export$9dc4ecf953986f04.prototype = {
    constructor: $03678f8c0b215133$export$c57e9b2d8b9e4de,
    restart: function(callback, delay, time) {
        if (typeof callback !== "function") throw new TypeError("callback is not a function");
        time = (time == null ? $03678f8c0b215133$export$461939dd4422153() : +time) + (delay == null ? 0 : +delay);
        if (!this._next && $03678f8c0b215133$var$taskTail !== this) {
            if ($03678f8c0b215133$var$taskTail) $03678f8c0b215133$var$taskTail._next = this;
            else $03678f8c0b215133$var$taskHead = this;
            $03678f8c0b215133$var$taskTail = this;
        }
        this._call = callback;
        this._time = time;
        $03678f8c0b215133$var$sleep();
    },
    stop: function() {
        if (this._call) {
            this._call = null;
            this._time = Infinity;
            $03678f8c0b215133$var$sleep();
        }
    }
};
function $03678f8c0b215133$export$9dc4ecf953986f04(callback, delay, time) {
    var t = new $03678f8c0b215133$export$c57e9b2d8b9e4de;
    t.restart(callback, delay, time);
    return t;
}
function $03678f8c0b215133$export$d60154c1d7f3990e() {
    $03678f8c0b215133$export$461939dd4422153(); // Get the current time, if not already set.
    ++$03678f8c0b215133$var$frame; // Pretend we’ve set an alarm, if we haven’t already.
    var t = $03678f8c0b215133$var$taskHead, e;
    while(t){
        if ((e = $03678f8c0b215133$var$clockNow - t._time) >= 0) t._call.call(undefined, e);
        t = t._next;
    }
    --$03678f8c0b215133$var$frame;
}
function $03678f8c0b215133$var$wake() {
    $03678f8c0b215133$var$clockNow = ($03678f8c0b215133$var$clockLast = $03678f8c0b215133$var$clock.now()) + $03678f8c0b215133$var$clockSkew;
    $03678f8c0b215133$var$frame = $03678f8c0b215133$var$timeout = 0;
    try {
        $03678f8c0b215133$export$d60154c1d7f3990e();
    } finally{
        $03678f8c0b215133$var$frame = 0;
        $03678f8c0b215133$var$nap();
        $03678f8c0b215133$var$clockNow = 0;
    }
}
function $03678f8c0b215133$var$poke() {
    var now = $03678f8c0b215133$var$clock.now(), delay = now - $03678f8c0b215133$var$clockLast;
    if (delay > $03678f8c0b215133$var$pokeDelay) $03678f8c0b215133$var$clockSkew -= delay, $03678f8c0b215133$var$clockLast = now;
}
function $03678f8c0b215133$var$nap() {
    var t0, t1 = $03678f8c0b215133$var$taskHead, t2, time = Infinity;
    while(t1)if (t1._call) {
        if (time > t1._time) time = t1._time;
        t0 = t1, t1 = t1._next;
    } else {
        t2 = t1._next, t1._next = null;
        t1 = t0 ? t0._next = t2 : $03678f8c0b215133$var$taskHead = t2;
    }
    $03678f8c0b215133$var$taskTail = t0;
    $03678f8c0b215133$var$sleep(time);
}
function $03678f8c0b215133$var$sleep(time) {
    if ($03678f8c0b215133$var$frame) return; // Soonest alarm already set, or will be.
    if ($03678f8c0b215133$var$timeout) $03678f8c0b215133$var$timeout = clearTimeout($03678f8c0b215133$var$timeout);
    var delay = time - $03678f8c0b215133$var$clockNow; // Strictly less than if we recomputed clockNow.
    if (delay > 24) {
        if (time < Infinity) $03678f8c0b215133$var$timeout = setTimeout($03678f8c0b215133$var$wake, time - $03678f8c0b215133$var$clock.now() - $03678f8c0b215133$var$clockSkew);
        if ($03678f8c0b215133$var$interval) $03678f8c0b215133$var$interval = clearInterval($03678f8c0b215133$var$interval);
    } else {
        if (!$03678f8c0b215133$var$interval) $03678f8c0b215133$var$clockLast = $03678f8c0b215133$var$clock.now(), $03678f8c0b215133$var$interval = setInterval($03678f8c0b215133$var$poke, $03678f8c0b215133$var$pokeDelay);
        $03678f8c0b215133$var$frame = 1, $03678f8c0b215133$var$setFrame($03678f8c0b215133$var$wake);
    }
}
module.exports["now"] = $03678f8c0b215133$export$461939dd4422153;
module.exports["Timer"] = $03678f8c0b215133$export$c57e9b2d8b9e4de;
module.exports["timer"] = $03678f8c0b215133$export$9dc4ecf953986f04;

});

parcelRegister("bXFEI", function(module, exports) {
$parcel$export(module.exports, "default", () => $8b558453cccb992d$export$2e2bcd8739ae039);
// These are typically used in conjunction with noevent to ensure that we can
// preventDefault on the event.
const $8b558453cccb992d$export$524615cd03e458cc = {
    passive: false
};
const $8b558453cccb992d$export$35431a0e47022de1 = {
    capture: true,
    passive: false
};
function $8b558453cccb992d$export$2e2561858db9bf47(event) {
    event.stopImmediatePropagation();
}
function $8b558453cccb992d$export$2e2bcd8739ae039(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
}
module.exports["nonpassivecapture"] = $8b558453cccb992d$export$35431a0e47022de1;

});

parcelRegister("5rNAx", function(module, exports) {
$parcel$export(module.exports, "default", () => $3f75f08cfe7f3545$export$2e2bcd8739ae039);
function $3f75f08cfe7f3545$export$2e2bcd8739ae039(event) {
    let sourceEvent;
    while(sourceEvent = event.sourceEvent)event = sourceEvent;
    return event;
}

});

parcelRegister("4PaSL", function(module, exports) {
$parcel$export(module.exports, "default", () => $38345dd7e247c5dd$export$2e2bcd8739ae039);
function $38345dd7e247c5dd$var$none() {}
function $38345dd7e247c5dd$export$2e2bcd8739ae039(selector) {
    return selector == null ? $38345dd7e247c5dd$var$none : function() {
        return this.querySelector(selector);
    };
}

});

parcelRegister("d7CCZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $98d9e482dc418825$export$2e2bcd8739ae039);
// Given something array like (or null), returns something that is strictly an
// array. This is used to ensure that array-like objects passed to d3.selectAll
// or selection.selectAll are converted into proper arrays when creating a
// selection; we don’t ever want to create a selection backed by a live
// HTMLCollection or NodeList. However, note that selection.selectAll will use a
// static NodeList as a group, since it safely derived from querySelectorAll.
function $98d9e482dc418825$export$2e2bcd8739ae039(x) {
    return x == null ? [] : Array.isArray(x) ? x : Array.from(x);
}

});

parcelRegister("g3K2y", function(module, exports) {
$parcel$export(module.exports, "default", () => $bb10a3c64d33c520$export$2e2bcd8739ae039);
function $bb10a3c64d33c520$var$empty() {
    return [];
}
function $bb10a3c64d33c520$export$2e2bcd8739ae039(selector) {
    return selector == null ? $bb10a3c64d33c520$var$empty : function() {
        return this.querySelectorAll(selector);
    };
}

});

parcelRegister("9B7Qm", function(module, exports) {
$parcel$export(module.exports, "default", () => $6fcda753d04b2a99$export$2e2bcd8739ae039);
function $6fcda753d04b2a99$export$2e2bcd8739ae039(selector) {
    return function() {
        return this.matches(selector);
    };
}
function $6fcda753d04b2a99$export$90c2759c036528(selector) {
    return function(node) {
        return node.matches(selector);
    };
}
module.exports["childMatcher"] = $6fcda753d04b2a99$export$90c2759c036528;

});

parcelRegister("fBk0q", function(module, exports) {
$parcel$export(module.exports, "default", () => $b5b9d473e1477b49$export$2e2bcd8739ae039);
function $b5b9d473e1477b49$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}

});

parcelRegister("7nxbF", function(module, exports) {
$parcel$export(module.exports, "default", () => $55f46ca5a8a882e8$export$2e2bcd8739ae039);
function $55f46ca5a8a882e8$export$2e2bcd8739ae039(update) {
    return new Array(update.length);
}

});

parcelRegister("1IOzU", function(module, exports) {
$parcel$export(module.exports, "default", () => $14112248dafbea85$export$2e2bcd8739ae039);

var $bVNFO = parcelRequire("bVNFO");

function $14112248dafbea85$export$2e2bcd8739ae039(name) {
    var prefix = name += "", i = prefix.indexOf(":");
    if (i >= 0 && (prefix = name.slice(0, i)) !== "xmlns") name = name.slice(i + 1);
    return (0, $bVNFO.default).hasOwnProperty(prefix) ? {
        space: (0, $bVNFO.default)[prefix],
        local: name
    } : name; // eslint-disable-line no-prototype-builtins
}

});

parcelRegister("cREL1", function(module, exports) {
$parcel$export(module.exports, "default", () => $95da0cd99f83d4e7$export$2e2bcd8739ae039);
function $95da0cd99f83d4e7$export$2e2bcd8739ae039(node) {
    return node.ownerDocument && node.ownerDocument.defaultView // node is a Node
     || node.document && node // node is a Window
     || node.defaultView; // node is a Document
}

});

parcelRegister("4e7Ob", function(module, exports) {
$parcel$export(module.exports, "default", () => $313e86ccd417de94$export$2e2bcd8739ae039);

var $1IOzU = parcelRequire("1IOzU");


var $bVNFO = parcelRequire("bVNFO");

function $313e86ccd417de94$var$creatorInherit(name) {
    return function() {
        var document = this.ownerDocument, uri = this.namespaceURI;
        return uri === (0, $bVNFO.xhtml) && document.documentElement.namespaceURI === (0, $bVNFO.xhtml) ? document.createElement(name) : document.createElementNS(uri, name);
    };
}
function $313e86ccd417de94$var$creatorFixed(fullname) {
    return function() {
        return this.ownerDocument.createElementNS(fullname.space, fullname.local);
    };
}
function $313e86ccd417de94$export$2e2bcd8739ae039(name) {
    var fullname = (0, $1IOzU.default)(name);
    return (fullname.local ? $313e86ccd417de94$var$creatorFixed : $313e86ccd417de94$var$creatorInherit)(fullname);
}

});

parcelRegister("bVNFO", function(module, exports) {
$parcel$export(module.exports, "default", () => $8afb8ca9465010e3$export$2e2bcd8739ae039);
var $8afb8ca9465010e3$export$201a3f7520ccc326 = "http://www.w3.org/1999/xhtml";
var $8afb8ca9465010e3$export$2e2bcd8739ae039 = {
    svg: "http://www.w3.org/2000/svg",
    xhtml: $8afb8ca9465010e3$export$201a3f7520ccc326,
    xlink: "http://www.w3.org/1999/xlink",
    xml: "http://www.w3.org/XML/1998/namespace",
    xmlns: "http://www.w3.org/2000/xmlns/"
};
module.exports["xhtml"] = $8afb8ca9465010e3$export$201a3f7520ccc326;

});


//# sourceMappingURL=AnalyticsByLine.8fec0b2b.js.map
